{
  "title": "PoliPoker: US State Fact Bank",
  "version": "1.0.1",
  "compiled_on": "2026-09-07",
  "language": "en-AU",
  "status": "source_linked_editorial_draft",
  "state_count": 50,
  "facts_per_state": 30,
  "total_facts": 1500,
  "editorial_note": "Short paraphrased entries selected for stability. Sources are primarily secondary educational and trivia pages, supplemented by official and museum references. Source pages were consulted, but this bank has not received an exhaustive fact-by-fact primary-source audit. A source link is not a verified-claim certification.",
  "scope_note": "The 50 US states only. Historical dates, places, nature, culture, people and unusual facts. No electoral weights, party endorsements or gameplay scoring rules are encoded.",
  "categories": [
    "culture",
    "food_and_farming",
    "geography",
    "geology",
    "government",
    "history",
    "industry",
    "landmarks_and_engineering",
    "nature_and_wildlife",
    "people",
    "science_and_invention",
    "sport",
    "unusual"
  ],
  "sources": {
    "AL-D": {
      "title": "Ducksters: Alabama",
      "url": "https://www.ducksters.com/geography/state.php?State=Alabama",
      "type": "educational secondary source"
    },
    "AL-F": {
      "title": "50states.com: Alabama Facts",
      "url": "https://www.50states.com/facts/alabama.htm",
      "type": "trivia secondary source"
    },
    "AK-W": {
      "title": "Wikipedia: Alaska",
      "url": "https://en.wikipedia.org/wiki/Alaska",
      "type": "encyclopedia secondary source"
    },
    "AK-F": {
      "title": "50states.com: Alaska Facts",
      "url": "https://www.50states.com/facts/alaska.htm",
      "type": "trivia secondary source"
    },
    "AZ-D": {
      "title": "Ducksters: Arizona",
      "url": "https://www.ducksters.com/geography/state.php?State=Arizona",
      "type": "educational secondary source"
    },
    "AZ-F": {
      "title": "50states.com: Arizona Facts",
      "url": "https://www.50states.com/facts/arizona.htm",
      "type": "trivia secondary source"
    },
    "AR-D": {
      "title": "Ducksters: Arkansas",
      "url": "https://www.ducksters.com/geography/state.php?State=Arkansas",
      "type": "educational secondary source"
    },
    "AR-F": {
      "title": "50states.com: Arkansas Facts",
      "url": "https://www.50states.com/facts/arkansas.htm",
      "type": "trivia secondary source"
    },
    "CA-D": {
      "title": "Ducksters: California",
      "url": "https://www.ducksters.com/geography/state.php?State=California",
      "type": "educational secondary source"
    },
    "CA-F": {
      "title": "50states.com: California Facts",
      "url": "https://www.50states.com/facts/california.htm",
      "type": "trivia secondary source"
    },
    "CO-D": {
      "title": "Ducksters: Colorado",
      "url": "https://www.ducksters.com/geography/state.php?State=Colorado",
      "type": "educational secondary source"
    },
    "CO-F": {
      "title": "50states.com: Colorado Facts",
      "url": "https://www.50states.com/facts/colorado.htm",
      "type": "trivia secondary source"
    },
    "CT-D": {
      "title": "Ducksters: Connecticut",
      "url": "https://www.ducksters.com/geography/state.php?State=Connecticut",
      "type": "educational secondary source"
    },
    "CT-F": {
      "title": "50states.com: Connecticut Facts",
      "url": "https://www.50states.com/facts/connecticut.htm",
      "type": "trivia secondary source"
    },
    "DE-D": {
      "title": "Ducksters: Delaware",
      "url": "https://www.ducksters.com/geography/state.php?State=Delaware",
      "type": "educational secondary source"
    },
    "DE-F": {
      "title": "50states.com: Delaware Facts",
      "url": "https://www.50states.com/facts/delaware.htm",
      "type": "trivia secondary source"
    },
    "FL-D": {
      "title": "Ducksters: Florida",
      "url": "https://www.ducksters.com/geography/state.php?State=Florida",
      "type": "educational secondary source"
    },
    "FL-F": {
      "title": "50states.com: Florida Facts",
      "url": "https://www.50states.com/facts/florida.htm",
      "type": "trivia secondary source"
    },
    "FL-P": {
      "title": "Florida Department of State: State Gem",
      "url": "https://dos.fl.gov/florida-facts/florida-state-symbols/state-gem/",
      "type": "government"
    },
    "GA-D": {
      "title": "Ducksters: Georgia",
      "url": "https://www.ducksters.com/geography/state.php?State=Georgia",
      "type": "educational secondary source"
    },
    "GA-F": {
      "title": "50states.com: Georgia Facts",
      "url": "https://www.50states.com/facts/georgia.htm",
      "type": "trivia secondary source"
    },
    "HI-D": {
      "title": "Ducksters: Hawaii",
      "url": "https://www.ducksters.com/geography/state.php?State=Hawaii",
      "type": "educational secondary source"
    },
    "HI-F": {
      "title": "50states.com: Hawaii Facts",
      "url": "https://www.50states.com/facts/hawaii.htm",
      "type": "trivia secondary source"
    },
    "ID-D": {
      "title": "Ducksters: Idaho",
      "url": "https://www.ducksters.com/geography/state.php?State=Idaho",
      "type": "educational secondary source"
    },
    "ID-F": {
      "title": "50states.com: Idaho Facts",
      "url": "https://www.50states.com/facts/idaho.htm",
      "type": "trivia secondary source"
    },
    "IL-D": {
      "title": "Ducksters: Illinois",
      "url": "https://www.ducksters.com/geography/state.php?State=Illinois",
      "type": "educational secondary source"
    },
    "IL-F": {
      "title": "50states.com: Illinois Facts",
      "url": "https://www.50states.com/facts/illinois.htm",
      "type": "trivia secondary source"
    },
    "IL-P": {
      "title": "US Department of Energy: First Nuclear Chain Reaction",
      "url": "https://www.energy.gov/ne/articles/10-intriguing-facts-about-worlds-first-nuclear-chain-reaction",
      "type": "government"
    },
    "IN-D": {
      "title": "Ducksters: Indiana",
      "url": "https://www.ducksters.com/geography/state.php?State=Indiana",
      "type": "educational secondary source"
    },
    "IN-F": {
      "title": "50states.com: Indiana Facts",
      "url": "https://www.50states.com/facts/indiana.htm",
      "type": "trivia secondary source"
    },
    "IA-D": {
      "title": "Ducksters: Iowa",
      "url": "https://www.ducksters.com/geography/state.php?State=Iowa",
      "type": "educational secondary source"
    },
    "IA-F": {
      "title": "50states.com: Iowa Facts",
      "url": "https://www.50states.com/facts/iowa.htm",
      "type": "trivia secondary source"
    },
    "KS-D": {
      "title": "Ducksters: Kansas",
      "url": "https://www.ducksters.com/geography/state.php?State=Kansas",
      "type": "educational secondary source"
    },
    "KS-F": {
      "title": "50states.com: Kansas Facts",
      "url": "https://www.50states.com/facts/kansas.htm",
      "type": "trivia secondary source"
    },
    "KS-P": {
      "title": "Visit Wichita: Hattie McDaniel Memorial",
      "url": "https://www.visitwichita.com/listing/hattie-mcdaniel-memorial/35446/",
      "type": "local tourism"
    },
    "KY-D": {
      "title": "Ducksters: Kentucky",
      "url": "https://www.ducksters.com/geography/state.php?State=Kentucky",
      "type": "educational secondary source"
    },
    "KY-F": {
      "title": "50states.com: Kentucky Facts",
      "url": "https://www.50states.com/facts/kentucky.htm",
      "type": "trivia secondary source"
    },
    "LA-D": {
      "title": "Ducksters: Louisiana",
      "url": "https://www.ducksters.com/geography/state.php?State=Louisiana",
      "type": "educational secondary source"
    },
    "LA-F": {
      "title": "50states.com: Louisiana Facts",
      "url": "https://www.50states.com/facts/louisiana.htm",
      "type": "trivia secondary source"
    },
    "ME-D": {
      "title": "Ducksters: Maine",
      "url": "https://www.ducksters.com/geography/state.php?State=Maine",
      "type": "educational secondary source"
    },
    "ME-F": {
      "title": "50states.com: Maine Facts",
      "url": "https://www.50states.com/facts/maine.htm",
      "type": "trivia secondary source"
    },
    "MD-D": {
      "title": "Ducksters: Maryland",
      "url": "https://www.ducksters.com/geography/state.php?State=Maryland",
      "type": "educational secondary source"
    },
    "MD-F": {
      "title": "50states.com: Maryland Facts",
      "url": "https://www.50states.com/facts/maryland.htm",
      "type": "trivia secondary source"
    },
    "MA-D": {
      "title": "Ducksters: Massachusetts",
      "url": "https://www.ducksters.com/geography/state.php?State=Massachusetts",
      "type": "educational secondary source"
    },
    "MA-F": {
      "title": "50states.com: Massachusetts Facts",
      "url": "https://www.50states.com/facts/massachusetts.htm",
      "type": "trivia secondary source"
    },
    "MI-D": {
      "title": "Ducksters: Michigan",
      "url": "https://www.ducksters.com/geography/state.php?State=Michigan",
      "type": "educational secondary source"
    },
    "MI-F": {
      "title": "50states.com: Michigan Facts",
      "url": "https://www.50states.com/facts/michigan.htm",
      "type": "trivia secondary source"
    },
    "MN-D": {
      "title": "Ducksters: Minnesota",
      "url": "https://www.ducksters.com/geography/state.php?State=Minnesota",
      "type": "educational secondary source"
    },
    "MN-F": {
      "title": "50states.com: Minnesota Facts",
      "url": "https://www.50states.com/facts/minnesota.htm",
      "type": "trivia secondary source"
    },
    "MN-P": {
      "title": "Smithsonian National Museum of American History: Bundt Pan",
      "url": "https://americanhistory.si.edu/collections/object/nmah_1321435",
      "type": "museum"
    },
    "MS-D": {
      "title": "Ducksters: Mississippi",
      "url": "https://www.ducksters.com/geography/state.php?State=Mississippi",
      "type": "educational secondary source"
    },
    "MS-F": {
      "title": "50states.com: Mississippi Facts",
      "url": "https://www.50states.com/facts/mississippi.htm",
      "type": "trivia secondary source"
    },
    "MO-D": {
      "title": "Ducksters: Missouri",
      "url": "https://www.ducksters.com/geography/state.php?State=Missouri",
      "type": "educational secondary source"
    },
    "MO-F": {
      "title": "50states.com: Missouri Facts",
      "url": "https://www.50states.com/facts/missouri.htm",
      "type": "trivia secondary source"
    },
    "MT-D": {
      "title": "Ducksters: Montana",
      "url": "https://www.ducksters.com/geography/state.php?State=Montana",
      "type": "educational secondary source"
    },
    "MT-F": {
      "title": "50states.com: Montana Facts",
      "url": "https://www.50states.com/facts/montana.htm",
      "type": "trivia secondary source"
    },
    "NE-D": {
      "title": "Ducksters: Nebraska",
      "url": "https://www.ducksters.com/geography/state.php?State=Nebraska",
      "type": "educational secondary source"
    },
    "NE-F": {
      "title": "50states.com: Nebraska Facts",
      "url": "https://www.50states.com/facts/nebraska.htm",
      "type": "trivia secondary source"
    },
    "NV-D": {
      "title": "Ducksters: Nevada",
      "url": "https://www.ducksters.com/geography/state.php?State=Nevada",
      "type": "educational secondary source"
    },
    "NV-F": {
      "title": "50states.com: Nevada Facts",
      "url": "https://www.50states.com/facts/nevada.htm",
      "type": "trivia secondary source"
    },
    "NH-D": {
      "title": "Ducksters: New Hampshire",
      "url": "https://www.ducksters.com/geography/state.php?State=New%20Hampshire",
      "type": "educational secondary source"
    },
    "NH-F": {
      "title": "50states.com: New Hampshire Facts",
      "url": "https://www.50states.com/facts/new-hampshire.htm",
      "type": "trivia secondary source"
    },
    "NJ-D": {
      "title": "Ducksters: New Jersey",
      "url": "https://www.ducksters.com/geography/state.php?State=New%20Jersey",
      "type": "educational secondary source"
    },
    "NJ-F": {
      "title": "50states.com: New Jersey Facts",
      "url": "https://www.50states.com/facts/new-jersey.htm",
      "type": "trivia secondary source"
    },
    "NM-D": {
      "title": "Ducksters: New Mexico",
      "url": "https://www.ducksters.com/geography/state.php?State=New%20Mexico",
      "type": "educational secondary source"
    },
    "NM-F": {
      "title": "50states.com: New Mexico Facts",
      "url": "https://www.50states.com/facts/new-mexico.htm",
      "type": "trivia secondary source"
    },
    "NY-D": {
      "title": "Ducksters: New York",
      "url": "https://www.ducksters.com/geography/state.php?State=New%20York",
      "type": "educational secondary source"
    },
    "NY-F": {
      "title": "50states.com: New York Facts",
      "url": "https://www.50states.com/facts/new-york.htm",
      "type": "trivia secondary source"
    },
    "NC-D": {
      "title": "Ducksters: North Carolina",
      "url": "https://www.ducksters.com/geography/state.php?State=North%20Carolina",
      "type": "educational secondary source"
    },
    "NC-F": {
      "title": "50states.com: North Carolina Facts",
      "url": "https://www.50states.com/facts/north-carolina.htm",
      "type": "trivia secondary source"
    },
    "ND-D": {
      "title": "Ducksters: North Dakota",
      "url": "https://www.ducksters.com/geography/state.php?State=North%20Dakota",
      "type": "educational secondary source"
    },
    "ND-F": {
      "title": "50states.com: North Dakota Facts",
      "url": "https://www.50states.com/facts/north-dakota.htm",
      "type": "trivia secondary source"
    },
    "OH-D": {
      "title": "Ducksters: Ohio",
      "url": "https://www.ducksters.com/geography/state.php?State=Ohio",
      "type": "educational secondary source"
    },
    "OH-F": {
      "title": "50states.com: Ohio Facts",
      "url": "https://www.50states.com/facts/ohio.htm",
      "type": "trivia secondary source"
    },
    "OK-D": {
      "title": "Ducksters: Oklahoma",
      "url": "https://www.ducksters.com/geography/state.php?State=Oklahoma",
      "type": "educational secondary source"
    },
    "OK-F": {
      "title": "50states.com: Oklahoma Facts",
      "url": "https://www.50states.com/facts/oklahoma.htm",
      "type": "trivia secondary source"
    },
    "OR-D": {
      "title": "Ducksters: Oregon",
      "url": "https://www.ducksters.com/geography/state.php?State=Oregon",
      "type": "educational secondary source"
    },
    "OR-F": {
      "title": "50states.com: Oregon Facts",
      "url": "https://www.50states.com/facts/oregon.htm",
      "type": "trivia secondary source"
    },
    "PA-D": {
      "title": "Ducksters: Pennsylvania",
      "url": "https://www.ducksters.com/geography/state.php?State=Pennsylvania",
      "type": "educational secondary source"
    },
    "PA-F": {
      "title": "50states.com: Pennsylvania Facts",
      "url": "https://www.50states.com/facts/pennsylvania.htm",
      "type": "trivia secondary source"
    },
    "RI-D": {
      "title": "Ducksters: Rhode Island",
      "url": "https://www.ducksters.com/geography/state.php?State=Rhode%20Island",
      "type": "educational secondary source"
    },
    "RI-F": {
      "title": "50states.com: Rhode Island Facts",
      "url": "https://www.50states.com/facts/rhode-island.htm",
      "type": "trivia secondary source"
    },
    "SC-D": {
      "title": "Ducksters: South Carolina",
      "url": "https://www.ducksters.com/geography/state.php?State=South%20Carolina",
      "type": "educational secondary source"
    },
    "SC-F": {
      "title": "50states.com: South Carolina Facts",
      "url": "https://www.50states.com/facts/south-carolina.htm",
      "type": "trivia secondary source"
    },
    "SD-D": {
      "title": "Ducksters: South Dakota",
      "url": "https://www.ducksters.com/geography/state.php?State=South%20Dakota",
      "type": "educational secondary source"
    },
    "SD-F": {
      "title": "50states.com: South Dakota Facts",
      "url": "https://www.50states.com/facts/south-dakota.htm",
      "type": "trivia secondary source"
    },
    "TN-D": {
      "title": "Ducksters: Tennessee",
      "url": "https://www.ducksters.com/geography/state.php?State=Tennessee",
      "type": "educational secondary source"
    },
    "TN-F": {
      "title": "50states.com: Tennessee Facts",
      "url": "https://www.50states.com/facts/tennessee.htm",
      "type": "trivia secondary source"
    },
    "TX-D": {
      "title": "Ducksters: Texas",
      "url": "https://www.ducksters.com/geography/state.php?State=Texas",
      "type": "educational secondary source"
    },
    "TX-F": {
      "title": "50states.com: Texas Facts",
      "url": "https://www.50states.com/facts/texas.htm",
      "type": "trivia secondary source"
    },
    "UT-D": {
      "title": "Ducksters: Utah",
      "url": "https://www.ducksters.com/geography/state.php?State=Utah",
      "type": "educational secondary source"
    },
    "UT-F": {
      "title": "50states.com: Utah Facts",
      "url": "https://www.50states.com/facts/utah.htm",
      "type": "trivia secondary source"
    },
    "VT-D": {
      "title": "Ducksters: Vermont",
      "url": "https://www.ducksters.com/geography/state.php?State=Vermont",
      "type": "educational secondary source"
    },
    "VT-F": {
      "title": "50states.com: Vermont Facts",
      "url": "https://www.50states.com/facts/vermont.htm",
      "type": "trivia secondary source"
    },
    "VT-T": {
      "title": "Vermont Tourism: Vermont Facts",
      "url": "https://vermontvacation.com/vermont-facts/",
      "type": "state tourism"
    },
    "VT-B": {
      "title": "Ben & Jerry's: About Us",
      "url": "https://www.benjerry.com/about-us",
      "type": "company history"
    },
    "VA-D": {
      "title": "Ducksters: Virginia",
      "url": "https://www.ducksters.com/geography/state.php?State=Virginia",
      "type": "educational secondary source"
    },
    "VA-F": {
      "title": "50states.com: Virginia Facts",
      "url": "https://www.50states.com/facts/virginia.htm",
      "type": "trivia secondary source"
    },
    "WA-D": {
      "title": "Ducksters: Washington",
      "url": "https://www.ducksters.com/geography/state.php?State=Washington",
      "type": "educational secondary source"
    },
    "WA-F": {
      "title": "50states.com: Washington Facts",
      "url": "https://www.50states.com/facts/washington.htm",
      "type": "trivia secondary source"
    },
    "WV-D": {
      "title": "Ducksters: West Virginia",
      "url": "https://www.ducksters.com/geography/state.php?State=West%20Virginia",
      "type": "educational secondary source"
    },
    "WV-F": {
      "title": "50states.com: West Virginia Facts",
      "url": "https://www.50states.com/facts/west-virginia.htm",
      "type": "trivia secondary source"
    },
    "WI-D": {
      "title": "Ducksters: Wisconsin",
      "url": "https://www.ducksters.com/geography/state.php?State=Wisconsin",
      "type": "educational secondary source"
    },
    "WI-F": {
      "title": "50states.com: Wisconsin Facts",
      "url": "https://www.50states.com/facts/wisconsin.htm",
      "type": "trivia secondary source"
    },
    "WY-D": {
      "title": "Ducksters: Wyoming",
      "url": "https://www.ducksters.com/geography/state.php?State=Wyoming",
      "type": "educational secondary source"
    },
    "WY-F": {
      "title": "50states.com: Wyoming Facts",
      "url": "https://www.50states.com/facts/wyoming.htm",
      "type": "trivia secondary source"
    },
    "WY-P": {
      "title": "National Park Service: Yellowstone Park Facts",
      "url": "https://www.nps.gov/yell/planyourvisit/parkfacts.htm",
      "type": "government"
    }
  },
  "states": [
    {
      "name": "Alabama",
      "code": "AL",
      "facts": [
        {
          "id": "AL-001",
          "category": "geography",
          "text": "Montgomery serves as Alabama's capital.",
          "source_id": "AL-D"
        },
        {
          "id": "AL-002",
          "category": "geography",
          "text": "Alabama borders four other states.",
          "source_id": "AL-D"
        },
        {
          "id": "AL-003",
          "category": "geography",
          "text": "The Tennessee River crosses northern Alabama.",
          "source_id": "AL-D"
        },
        {
          "id": "AL-004",
          "category": "nature_and_wildlife",
          "text": "Alabama's yellowhammer is a type of woodpecker.",
          "source_id": "AL-D"
        },
        {
          "id": "AL-005",
          "category": "nature_and_wildlife",
          "text": "The largemouth bass represents Alabama's freshwater fish.",
          "source_id": "AL-D"
        },
        {
          "id": "AL-006",
          "category": "nature_and_wildlife",
          "text": "The tarpon represents Alabama's saltwater fish.",
          "source_id": "AL-D"
        },
        {
          "id": "AL-007",
          "category": "culture",
          "text": "The Iron Bowl pits Alabama against Auburn.",
          "source_id": "AL-D"
        },
        {
          "id": "AL-008",
          "category": "science_and_invention",
          "text": "Huntsville hosts Space Camp for aspiring space explorers.",
          "source_id": "AL-D"
        },
        {
          "id": "AL-009",
          "category": "landmarks_and_engineering",
          "text": "Birmingham's Vulcan sculpture depicts the Roman god of fire.",
          "source_id": "AL-D"
        },
        {
          "id": "AL-010",
          "category": "history",
          "text": "The Wright brothers operated a flying school in Montgomery.",
          "source_id": "AL-D"
        },
        {
          "id": "AL-011",
          "category": "history",
          "text": "Alabama became state number 22 in 1819.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-012",
          "category": "people",
          "text": "Baseball legend Hank Aaron was born in Mobile.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-013",
          "category": "people",
          "text": "Willie Mays was born in Westfield.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-014",
          "category": "people",
          "text": "Singer Nat King Cole was born in Montgomery.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-015",
          "category": "people",
          "text": "Actor Tallulah Bankhead came from Huntsville.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-016",
          "category": "people",
          "text": "Boxing champion Joe Louis was born in Alabama.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-017",
          "category": "unusual",
          "text": "Enterprise erected a monument honouring the boll weevil.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-018",
          "category": "food_and_farming",
          "text": "Boll-weevil damage encouraged Enterprise farmers to diversify beyond cotton.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-019",
          "category": "nature_and_wildlife",
          "text": "Alabama selected the camellia as its floral emblem.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-020",
          "category": "nature_and_wildlife",
          "text": "Longleaf pine represents Alabama as its state tree.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-021",
          "category": "geology",
          "text": "Hematite, an iron ore, is Alabama's state mineral.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-022",
          "category": "geology",
          "text": "Star blue quartz represents Alabama as its gemstone.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-023",
          "category": "food_and_farming",
          "text": "Alabama gives the pecan official state-nut status.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-024",
          "category": "geography",
          "text": "Cheaha Mountain rises above every other Alabama summit.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-025",
          "category": "culture",
          "text": "Fort Payne has a museum devoted to the band Alabama.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-026",
          "category": "history",
          "text": "St. Stephens served as Alabama's early territorial capital.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-027",
          "category": "history",
          "text": "Blount County predates Alabama's statehood.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-028",
          "category": "history",
          "text": "Montgomery became the state capital in 1846.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-029",
          "category": "history",
          "text": "The Battle of Mobile Bay occurred in 1864.",
          "source_id": "AL-F"
        },
        {
          "id": "AL-030",
          "category": "culture",
          "text": "Winston County acquired the nickname Free State of Winston.",
          "source_id": "AL-F"
        }
      ]
    },
    {
      "name": "Alaska",
      "code": "AK",
      "facts": [
        {
          "id": "AK-001",
          "category": "geography",
          "text": "Juneau serves as Alaska's capital.",
          "source_id": "AK-W"
        },
        {
          "id": "AK-002",
          "category": "geography",
          "text": "Alaska shares a land border with Canada.",
          "source_id": "AK-W"
        },
        {
          "id": "AK-003",
          "category": "geography",
          "text": "The Bering Strait separates Alaska from Russia.",
          "source_id": "AK-W"
        },
        {
          "id": "AK-004",
          "category": "geography",
          "text": "Alaska touches both the Pacific and Arctic oceans.",
          "source_id": "AK-W"
        },
        {
          "id": "AK-005",
          "category": "geography",
          "text": "The Aleutian Islands stretch southwest from mainland Alaska.",
          "source_id": "AK-W"
        },
        {
          "id": "AK-006",
          "category": "history",
          "text": "Russia sold Alaska to the United States in 1867.",
          "source_id": "AK-W"
        },
        {
          "id": "AK-007",
          "category": "nature_and_wildlife",
          "text": "Alaska supports wild populations of polar bears.",
          "source_id": "AK-W"
        },
        {
          "id": "AK-008",
          "category": "geography",
          "text": "Alaska is separated from the other states by Canada.",
          "source_id": "AK-W"
        },
        {
          "id": "AK-009",
          "category": "culture",
          "text": "Alaska Native peoples include Iñupiat, Yup'ik and Tlingit communities.",
          "source_id": "AK-W"
        },
        {
          "id": "AK-010",
          "category": "geography",
          "text": "Much of Alaska's interior experiences long, cold winters.",
          "source_id": "AK-W"
        },
        {
          "id": "AK-011",
          "category": "history",
          "text": "Alaska entered the Union as state 49 in 1959.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-012",
          "category": "geography",
          "text": "Alaska exceeds Texas in area by more than twofold.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-013",
          "category": "nature_and_wildlife",
          "text": "Tongass is America's largest national forest.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-014",
          "category": "landmarks_and_engineering",
          "text": "Gates of the Arctic National Park has no roads.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-015",
          "category": "geology",
          "text": "Novarupta's enormous volcanic eruption occurred in 1912.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-016",
          "category": "geography",
          "text": "Part of Alaska lies north of the Arctic Circle.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-017",
          "category": "history",
          "text": "The Alaska purchase cost the United States US$7.2 million.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-018",
          "category": "nature_and_wildlife",
          "text": "Alaska chose Sitka spruce as its state tree.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-019",
          "category": "nature_and_wildlife",
          "text": "The wild forget-me-not is Alaska's floral emblem.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-020",
          "category": "nature_and_wildlife",
          "text": "Alaska's bird emblem is the willow ptarmigan.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-021",
          "category": "sport",
          "text": "Dog mushing holds official state-sport status.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-022",
          "category": "geology",
          "text": "Gold is Alaska's designated state mineral.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-023",
          "category": "geology",
          "text": "Jade is Alaska's designated state gem.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-024",
          "category": "nature_and_wildlife",
          "text": "Alaska's insect emblem is the four-spot skimmer dragonfly.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-025",
          "category": "culture",
          "text": "Alaska uses the nickname Last Frontier.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-026",
          "category": "landmarks_and_engineering",
          "text": "The Trans-Alaska Pipeline terminates at Valdez.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-027",
          "category": "landmarks_and_engineering",
          "text": "The Trans-Alaska Pipeline stretches roughly 800 miles.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-028",
          "category": "history",
          "text": "The Alaska Highway began as a wartime military road.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-029",
          "category": "geology",
          "text": "Mount Augustine erupted in 1986.",
          "source_id": "AK-F"
        },
        {
          "id": "AK-030",
          "category": "nature_and_wildlife",
          "text": "The Alaskan malamute was developed as a sled dog.",
          "source_id": "AK-F"
        }
      ]
    },
    {
      "name": "Arizona",
      "code": "AZ",
      "facts": [
        {
          "id": "AZ-001",
          "category": "geography",
          "text": "Phoenix serves as Arizona's capital.",
          "source_id": "AZ-D"
        },
        {
          "id": "AZ-002",
          "category": "geography",
          "text": "Arizona shares an international border with Mexico.",
          "source_id": "AZ-D"
        },
        {
          "id": "AZ-003",
          "category": "history",
          "text": "Arizona includes territory formerly governed by Mexico.",
          "source_id": "AZ-D"
        },
        {
          "id": "AZ-004",
          "category": "geography",
          "text": "Arizona has snowy mountain country as well as deserts.",
          "source_id": "AZ-D"
        },
        {
          "id": "AZ-005",
          "category": "history",
          "text": "Tombstone hosted the famous O.K. Corral gunfight.",
          "source_id": "AZ-D"
        },
        {
          "id": "AZ-006",
          "category": "nature_and_wildlife",
          "text": "The venomous Gila monster lives in Arizona.",
          "source_id": "AZ-D"
        },
        {
          "id": "AZ-007",
          "category": "geography",
          "text": "The Gila River runs through Arizona.",
          "source_id": "AZ-D"
        },
        {
          "id": "AZ-008",
          "category": "geography",
          "text": "Arizona shares Lake Mead with Nevada.",
          "source_id": "AZ-D"
        },
        {
          "id": "AZ-009",
          "category": "geography",
          "text": "The Colorado River helps define Arizona's western boundary.",
          "source_id": "AZ-D"
        },
        {
          "id": "AZ-010",
          "category": "nature_and_wildlife",
          "text": "The Apache trout is Arizona's designated state fish.",
          "source_id": "AZ-D"
        },
        {
          "id": "AZ-011",
          "category": "history",
          "text": "Arizona gained statehood on Valentine's Day in 1912.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-012",
          "category": "history",
          "text": "Arizona was the 48th state admitted to the Union.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-013",
          "category": "landmarks_and_engineering",
          "text": "Lake Havasu City rebuilt a bridge transported from London.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-014",
          "category": "culture",
          "text": "Arizona recognises the bola tie as official neckwear.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-015",
          "category": "nature_and_wildlife",
          "text": "The ringtail is Arizona's state mammal.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-016",
          "category": "nature_and_wildlife",
          "text": "Arizona's floral emblem comes from the saguaro cactus.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-017",
          "category": "nature_and_wildlife",
          "text": "The cactus wren is Arizona's state bird.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-018",
          "category": "geology",
          "text": "Arizona chose turquoise as its state gemstone.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-019",
          "category": "geology",
          "text": "Petrified wood holds state-fossil status in Arizona.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-020",
          "category": "geography",
          "text": "Humphreys Peak is Arizona's highest summit.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-021",
          "category": "geography",
          "text": "Four Corners joins Arizona, Utah, Colorado and New Mexico.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-022",
          "category": "culture",
          "text": "Window Rock is the Navajo Nation's capital.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-023",
          "category": "history",
          "text": "Bisbee grew through copper mining.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-024",
          "category": "history",
          "text": "Jerome's population plunged after its copper mines closed.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-025",
          "category": "landmarks_and_engineering",
          "text": "Taliesin West was Frank Lloyd Wright's desert base.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-026",
          "category": "people",
          "text": "Labour organiser César Chávez was born in Yuma.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-027",
          "category": "people",
          "text": "Presidential candidate Barry Goldwater was born in Phoenix.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-028",
          "category": "landmarks_and_engineering",
          "text": "Arizona contains Grand Canyon National Park.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-029",
          "category": "nature_and_wildlife",
          "text": "Arizona's state amphibian is the Arizona tree frog.",
          "source_id": "AZ-F"
        },
        {
          "id": "AZ-030",
          "category": "culture",
          "text": "Arizona's official colours are blue and gold.",
          "source_id": "AZ-F"
        }
      ]
    },
    {
      "name": "Arkansas",
      "code": "AR",
      "facts": [
        {
          "id": "AR-001",
          "category": "geography",
          "text": "Little Rock serves as Arkansas's capital.",
          "source_id": "AR-D"
        },
        {
          "id": "AR-002",
          "category": "geography",
          "text": "Arkansas shares borders with six other states.",
          "source_id": "AR-D"
        },
        {
          "id": "AR-003",
          "category": "geography",
          "text": "The Mississippi River runs along Arkansas's eastern side.",
          "source_id": "AR-D"
        },
        {
          "id": "AR-004",
          "category": "geography",
          "text": "Arkansas has 75 counties.",
          "source_id": "AR-D"
        },
        {
          "id": "AR-005",
          "category": "nature_and_wildlife",
          "text": "The white-tailed deer is Arkansas's state mammal.",
          "source_id": "AR-D"
        },
        {
          "id": "AR-006",
          "category": "food_and_farming",
          "text": "Rice is an important Arkansas crop.",
          "source_id": "AR-D"
        },
        {
          "id": "AR-007",
          "category": "people",
          "text": "Bill Clinton served as Arkansas governor before becoming president.",
          "source_id": "AR-D"
        },
        {
          "id": "AR-008",
          "category": "people",
          "text": "President Bill Clinton was born in Hope.",
          "source_id": "AR-D"
        },
        {
          "id": "AR-009",
          "category": "culture",
          "text": "Arkansas's flag has a 25-star border marking its statehood order.",
          "source_id": "AR-D"
        },
        {
          "id": "AR-010",
          "category": "geography",
          "text": "Lake Ouachita is one of Arkansas's large reservoirs.",
          "source_id": "AR-D"
        },
        {
          "id": "AR-011",
          "category": "unusual",
          "text": "Visitors search for diamonds at Crater of Diamonds State Park.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-012",
          "category": "culture",
          "text": "Stuttgart hosts a championship duck-calling contest.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-013",
          "category": "culture",
          "text": "Mountain View celebrates Ozark folk music and traditions.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-014",
          "category": "people",
          "text": "Johnny Cash was born in Kingsland.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-015",
          "category": "people",
          "text": "General Douglas MacArthur was born in Little Rock.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-016",
          "category": "geography",
          "text": "Mount Magazine is Arkansas's highest point.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-017",
          "category": "history",
          "text": "Arkansas joined the Union in 1836.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-018",
          "category": "nature_and_wildlife",
          "text": "The apple blossom is Arkansas's floral emblem.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-019",
          "category": "nature_and_wildlife",
          "text": "The mockingbird is Arkansas's designated state bird.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-020",
          "category": "geology",
          "text": "Arkansas selected bauxite as its state mineral.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-021",
          "category": "geology",
          "text": "The diamond is Arkansas's designated state gem.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-022",
          "category": "nature_and_wildlife",
          "text": "Arkansas adopted the honeybee as its insect emblem in 1973.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-023",
          "category": "culture",
          "text": "The fiddle is Arkansas's official musical instrument.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-024",
          "category": "food_and_farming",
          "text": "Milk became Arkansas's official beverage in 1985.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-025",
          "category": "geology",
          "text": "Mount Ida is associated with quartz-crystal mining.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-026",
          "category": "landmarks_and_engineering",
          "text": "Little Rock's Quapaw Quarter preserves historic architecture.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-027",
          "category": "history",
          "text": "French settlers established Arkansas Post in 1686.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-028",
          "category": "landmarks_and_engineering",
          "text": "Hot Springs National Park sits within a city.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-029",
          "category": "geography",
          "text": "The Buffalo River remains free-flowing.",
          "source_id": "AR-F"
        },
        {
          "id": "AR-030",
          "category": "culture",
          "text": "Arkansas uses the nickname Natural State.",
          "source_id": "AR-F"
        }
      ]
    },
    {
      "name": "California",
      "code": "CA",
      "facts": [
        {
          "id": "CA-001",
          "category": "geography",
          "text": "Sacramento serves as California's capital.",
          "source_id": "CA-D"
        },
        {
          "id": "CA-002",
          "category": "history",
          "text": "California became the 31st state in 1850.",
          "source_id": "CA-D"
        },
        {
          "id": "CA-003",
          "category": "culture",
          "text": "California's name comes from a fictional island in Spanish literature.",
          "source_id": "CA-D"
        },
        {
          "id": "CA-004",
          "category": "science_and_invention",
          "text": "Silicon Valley became a centre of computer innovation.",
          "source_id": "CA-D"
        },
        {
          "id": "CA-005",
          "category": "geography",
          "text": "California borders Mexico and three other US states.",
          "source_id": "CA-D"
        },
        {
          "id": "CA-006",
          "category": "nature_and_wildlife",
          "text": "The golden trout is California's freshwater fish emblem.",
          "source_id": "CA-D"
        },
        {
          "id": "CA-007",
          "category": "nature_and_wildlife",
          "text": "The bright-orange garibaldi is California's marine fish emblem.",
          "source_id": "CA-D"
        },
        {
          "id": "CA-008",
          "category": "geography",
          "text": "California contains 58 counties.",
          "source_id": "CA-D"
        },
        {
          "id": "CA-009",
          "category": "geography",
          "text": "California's inland waters include the Salton Sea.",
          "source_id": "CA-D"
        },
        {
          "id": "CA-010",
          "category": "people",
          "text": "Ronald Reagan governed California before becoming US president.",
          "source_id": "CA-D"
        },
        {
          "id": "CA-011",
          "category": "geography",
          "text": "Mount Whitney is the highest summit in the contiguous states.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-012",
          "category": "geography",
          "text": "Death Valley includes land below sea level.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-013",
          "category": "nature_and_wildlife",
          "text": "Inyo National Forest protects ancient bristlecone pines.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-014",
          "category": "landmarks_and_engineering",
          "text": "Yorba Linda houses the Richard Nixon Presidential Library.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-015",
          "category": "landmarks_and_engineering",
          "text": "Simi Valley houses the Ronald Reagan Presidential Library.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-016",
          "category": "culture",
          "text": "Castroville celebrates its association with artichokes.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-017",
          "category": "food_and_farming",
          "text": "Fallbrook hosts an avocado festival.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-018",
          "category": "nature_and_wildlife",
          "text": "The California poppy provides the state's floral emblem.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-019",
          "category": "nature_and_wildlife",
          "text": "California chose the California quail as its bird emblem.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-020",
          "category": "nature_and_wildlife",
          "text": "California's state animal is the California grizzly bear.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-021",
          "category": "culture",
          "text": "California officially adopted Golden State as its nickname in 1968.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-022",
          "category": "history",
          "text": "California adopted its state flag in 1911.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-023",
          "category": "landmarks_and_engineering",
          "text": "Sacramento houses the California State Railroad Museum.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-024",
          "category": "landmarks_and_engineering",
          "text": "Santa Monica Pier has an amusement park.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-025",
          "category": "nature_and_wildlife",
          "text": "Sequoia National Park protects enormous giant sequoia trees.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-026",
          "category": "landmarks_and_engineering",
          "text": "Atwater houses the Castle Air Museum.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-027",
          "category": "food_and_farming",
          "text": "The Coachella Valley is associated with date growing.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-028",
          "category": "geography",
          "text": "Mount Langley belongs to the Sierra Nevada range.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-029",
          "category": "people",
          "text": "Writer Zane Grey built a home overlooking Avalon Bay.",
          "source_id": "CA-F"
        },
        {
          "id": "CA-030",
          "category": "nature_and_wildlife",
          "text": "Caswell Memorial State Park shelters riparian brush rabbits.",
          "source_id": "CA-F"
        }
      ]
    },
    {
      "name": "Colorado",
      "code": "CO",
      "facts": [
        {
          "id": "CO-001",
          "category": "geography",
          "text": "Denver serves as Colorado's capital.",
          "source_id": "CO-D"
        },
        {
          "id": "CO-002",
          "category": "culture",
          "text": "Denver's Mile High City nickname refers to its elevation.",
          "source_id": "CO-D"
        },
        {
          "id": "CO-003",
          "category": "history",
          "text": "Colorado became the 38th state in 1876.",
          "source_id": "CO-D"
        },
        {
          "id": "CO-004",
          "category": "culture",
          "text": "Colorado's name comes from Spanish for red-coloured.",
          "source_id": "CO-D"
        },
        {
          "id": "CO-005",
          "category": "nature_and_wildlife",
          "text": "The Rocky Mountain columbine is Colorado's floral emblem.",
          "source_id": "CO-D"
        },
        {
          "id": "CO-006",
          "category": "nature_and_wildlife",
          "text": "Colorado's mammal emblem is the Rocky Mountain bighorn sheep.",
          "source_id": "CO-D"
        },
        {
          "id": "CO-007",
          "category": "nature_and_wildlife",
          "text": "The greenback cutthroat trout is Colorado's state fish.",
          "source_id": "CO-D"
        },
        {
          "id": "CO-008",
          "category": "geography",
          "text": "Mount Elbert is Colorado's highest summit.",
          "source_id": "CO-D"
        },
        {
          "id": "CO-009",
          "category": "geography",
          "text": "Colorado contains 64 counties.",
          "source_id": "CO-D"
        },
        {
          "id": "CO-010",
          "category": "culture",
          "text": "The flag's white stripe represents snow on the mountains.",
          "source_id": "CO-D"
        },
        {
          "id": "CO-011",
          "category": "landmarks_and_engineering",
          "text": "Colorado Springs hosts the United States Air Force Academy.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-012",
          "category": "geography",
          "text": "Colorado has the highest average elevation among US states.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-013",
          "category": "culture",
          "text": "Centennial State recalls statehood during America's hundredth anniversary.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-014",
          "category": "geography",
          "text": "Colorado's southwest corner meets three other states.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-015",
          "category": "nature_and_wildlife",
          "text": "Colorado's tree emblem is the Colorado blue spruce.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-016",
          "category": "nature_and_wildlife",
          "text": "The lark bunting represents Colorado as its bird emblem.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-017",
          "category": "culture",
          "text": "Denver's LoDo name abbreviates Lower Downtown.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-018",
          "category": "landmarks_and_engineering",
          "text": "Mesa Verde preserves Ancestral Pueblo cliff dwellings.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-019",
          "category": "geology",
          "text": "Florissant Fossil Beds preserves petrified tree stumps.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-020",
          "category": "landmarks_and_engineering",
          "text": "The Royal Gorge Bridge crosses above the Arkansas River.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-021",
          "category": "culture",
          "text": "Pikes Peak inspired Katharine Lee Bates's America the Beautiful.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-022",
          "category": "history",
          "text": "Explorer Zebulon Pike never reached Pikes Peak's summit.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-023",
          "category": "culture",
          "text": "Loveland has a tradition of remailing Valentine cards.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-024",
          "category": "landmarks_and_engineering",
          "text": "Durango's narrow-gauge railway originally transported mining products.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-025",
          "category": "geography",
          "text": "Colorado contains the broad, flat-topped Grand Mesa.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-026",
          "category": "landmarks_and_engineering",
          "text": "Black Canyon of the Gunnison became a national park in 1999.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-027",
          "category": "history",
          "text": "Fort Garland was established in 1858.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-028",
          "category": "people",
          "text": "Doc Holliday died in Glenwood Springs in 1887.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-029",
          "category": "geography",
          "text": "Glenwood Springs is known for geothermal bathing pools.",
          "source_id": "CO-F"
        },
        {
          "id": "CO-030",
          "category": "food_and_farming",
          "text": "Rocky Ford is associated with melon growing.",
          "source_id": "CO-F"
        }
      ]
    },
    {
      "name": "Connecticut",
      "code": "CT",
      "facts": [
        {
          "id": "CT-001",
          "category": "geography",
          "text": "Hartford serves as Connecticut's capital.",
          "source_id": "CT-D"
        },
        {
          "id": "CT-002",
          "category": "history",
          "text": "Connecticut was fifth to ratify the US Constitution.",
          "source_id": "CT-D"
        },
        {
          "id": "CT-003",
          "category": "nature_and_wildlife",
          "text": "Connecticut's state animal is the sperm whale.",
          "source_id": "CT-D"
        },
        {
          "id": "CT-004",
          "category": "nature_and_wildlife",
          "text": "The American shad is Connecticut's state fish.",
          "source_id": "CT-D"
        },
        {
          "id": "CT-005",
          "category": "nature_and_wildlife",
          "text": "The eastern oyster is Connecticut's state shellfish.",
          "source_id": "CT-D"
        },
        {
          "id": "CT-006",
          "category": "geography",
          "text": "Connecticut's highest point lies on Mount Frissell's southern slope.",
          "source_id": "CT-D"
        },
        {
          "id": "CT-007",
          "category": "geography",
          "text": "Connecticut's coast faces Long Island Sound.",
          "source_id": "CT-D"
        },
        {
          "id": "CT-008",
          "category": "culture",
          "text": "Connecticut also goes by the nickname Nutmeg State.",
          "source_id": "CT-D"
        },
        {
          "id": "CT-009",
          "category": "landmarks_and_engineering",
          "text": "Connecticut hosts the United States Coast Guard Academy.",
          "source_id": "CT-D"
        },
        {
          "id": "CT-010",
          "category": "culture",
          "text": "Three grapevines appear on Connecticut's state flag.",
          "source_id": "CT-D"
        },
        {
          "id": "CT-011",
          "category": "history",
          "text": "A New Haven telephone directory listed 50 names in 1878.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-012",
          "category": "landmarks_and_engineering",
          "text": "Groton built the pioneering nuclear submarine USS Nautilus.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-013",
          "category": "landmarks_and_engineering",
          "text": "The historic Nautilus belongs to Groton's submarine museum.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-014",
          "category": "people",
          "text": "Mary Kies received a US patent for straw weaving in 1809.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-015",
          "category": "people",
          "text": "Ella Grasso won Connecticut's governorship in 1974.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-016",
          "category": "people",
          "text": "Dictionary maker Noah Webster was born in West Hartford.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-017",
          "category": "food_and_farming",
          "text": "Orange has a PEZ candy factory.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-018",
          "category": "culture",
          "text": "Bristol's Mum City nickname refers to chrysanthemums.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-019",
          "category": "nature_and_wildlife",
          "text": "Connecticut's insect emblem is the praying mantis.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-020",
          "category": "nature_and_wildlife",
          "text": "The white oak is Connecticut's designated state tree.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-021",
          "category": "nature_and_wildlife",
          "text": "Mountain laurel supplies Connecticut's floral emblem.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-022",
          "category": "nature_and_wildlife",
          "text": "Connecticut's bird emblem is the American robin.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-023",
          "category": "history",
          "text": "The Hartford Courant began publication in 1764.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-024",
          "category": "history",
          "text": "Connecticut adopted its state flag in 1897.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-025",
          "category": "culture",
          "text": "Constitution State became an official nickname in 1959.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-026",
          "category": "history",
          "text": "A former copper mine became New-Gate Prison.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-027",
          "category": "history",
          "text": "British forces burned Danbury during a 1777 raid.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-028",
          "category": "history",
          "text": "New Haven incorporated as a city in 1784.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-029",
          "category": "landmarks_and_engineering",
          "text": "Mystic has a historic steam-powered cider mill.",
          "source_id": "CT-F"
        },
        {
          "id": "CT-030",
          "category": "history",
          "text": "Hartford became Connecticut's sole capital in 1875.",
          "source_id": "CT-F"
        }
      ]
    },
    {
      "name": "Delaware",
      "code": "DE",
      "facts": [
        {
          "id": "DE-001",
          "category": "geography",
          "text": "Dover serves as Delaware's capital.",
          "source_id": "DE-D"
        },
        {
          "id": "DE-002",
          "category": "geography",
          "text": "Delaware has only three counties.",
          "source_id": "DE-D"
        },
        {
          "id": "DE-003",
          "category": "geography",
          "text": "Only Rhode Island is smaller than Delaware by area.",
          "source_id": "DE-D"
        },
        {
          "id": "DE-004",
          "category": "geography",
          "text": "Delaware borders Maryland, Pennsylvania and New Jersey.",
          "source_id": "DE-D"
        },
        {
          "id": "DE-005",
          "category": "nature_and_wildlife",
          "text": "Delaware's designated state animal is the grey fox.",
          "source_id": "DE-D"
        },
        {
          "id": "DE-006",
          "category": "nature_and_wildlife",
          "text": "The weakfish is Delaware's state fish.",
          "source_id": "DE-D"
        },
        {
          "id": "DE-007",
          "category": "history",
          "text": "DuPont began a Delaware gunpowder business in 1802.",
          "source_id": "DE-D"
        },
        {
          "id": "DE-008",
          "category": "people",
          "text": "Joe Biden represented Delaware in the US Senate.",
          "source_id": "DE-D"
        },
        {
          "id": "DE-009",
          "category": "geography",
          "text": "Delaware Bay opens into the Atlantic Ocean.",
          "source_id": "DE-D"
        },
        {
          "id": "DE-010",
          "category": "food_and_farming",
          "text": "Poultry farming is important to Delaware's agriculture.",
          "source_id": "DE-D"
        },
        {
          "id": "DE-011",
          "category": "history",
          "text": "Delaware ratified the US Constitution first, in 1787.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-012",
          "category": "geography",
          "text": "Delaware's northern boundary includes a circular arc.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-013",
          "category": "unusual",
          "text": "Delmar straddles Delaware and Maryland.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-014",
          "category": "nature_and_wildlife",
          "text": "Horseshoe crabs gather along Delaware's shores during spring.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-015",
          "category": "landmarks_and_engineering",
          "text": "Hagley preserves the site of early DuPont powder mills.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-016",
          "category": "landmarks_and_engineering",
          "text": "Winterthur combines a museum with landscaped gardens.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-017",
          "category": "history",
          "text": "Swedish colonists established New Sweden in 1638.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-018",
          "category": "history",
          "text": "Coastal observation towers survive from World War II.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-019",
          "category": "people",
          "text": "Abolitionist Thomas Garrett helped people escape slavery through Delaware.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-020",
          "category": "history",
          "text": "John Dickinson became known for influential Revolutionary-era writings.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-021",
          "category": "landmarks_and_engineering",
          "text": "Oliver Evans developed automated flour-milling equipment in Delaware.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-022",
          "category": "industry",
          "text": "Seaford became associated with nylon manufacturing.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-023",
          "category": "nature_and_wildlife",
          "text": "The blue hen chicken is Delaware's state bird.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-024",
          "category": "nature_and_wildlife",
          "text": "The American holly is Delaware's state tree.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-025",
          "category": "nature_and_wildlife",
          "text": "Delaware selected the peach blossom as its floral emblem.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-026",
          "category": "nature_and_wildlife",
          "text": "Delaware's insect emblem is the ladybird, called ladybug locally.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-027",
          "category": "culture",
          "text": "Delaware's official colours are colonial blue and buff.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-028",
          "category": "culture",
          "text": "An ox, corn and wheat appear on Delaware's seal.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-029",
          "category": "history",
          "text": "Milton was named after English poet John Milton.",
          "source_id": "DE-F"
        },
        {
          "id": "DE-030",
          "category": "history",
          "text": "Barratt's Chapel was built in 1780.",
          "source_id": "DE-F"
        }
      ]
    },
    {
      "name": "Florida",
      "code": "FL",
      "facts": [
        {
          "id": "FL-001",
          "category": "geography",
          "text": "Tallahassee serves as Florida's capital.",
          "source_id": "FL-D"
        },
        {
          "id": "FL-002",
          "category": "history",
          "text": "Florida became the 27th state in 1845.",
          "source_id": "FL-D"
        },
        {
          "id": "FL-003",
          "category": "geography",
          "text": "Florida touches the Atlantic Ocean and the Gulf.",
          "source_id": "FL-D"
        },
        {
          "id": "FL-004",
          "category": "geography",
          "text": "Florida shares land borders with Alabama and Georgia.",
          "source_id": "FL-D"
        },
        {
          "id": "FL-005",
          "category": "geography",
          "text": "Britton Hill is Florida's highest natural point.",
          "source_id": "FL-D"
        },
        {
          "id": "FL-006",
          "category": "nature_and_wildlife",
          "text": "The Florida panther is the state's animal emblem.",
          "source_id": "FL-D"
        },
        {
          "id": "FL-007",
          "category": "nature_and_wildlife",
          "text": "Florida honours the manatee as its marine mammal.",
          "source_id": "FL-D"
        },
        {
          "id": "FL-008",
          "category": "nature_and_wildlife",
          "text": "The sailfish is Florida's saltwater fish emblem.",
          "source_id": "FL-D"
        },
        {
          "id": "FL-009",
          "category": "history",
          "text": "Spanish settlers founded St. Augustine in 1565.",
          "source_id": "FL-D"
        },
        {
          "id": "FL-010",
          "category": "unusual",
          "text": "Two separate Florida rivers share the name Withlacoochee.",
          "source_id": "FL-D"
        },
        {
          "id": "FL-011",
          "category": "science_and_invention",
          "text": "Cape Canaveral became a major American space-launch site.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-012",
          "category": "food_and_farming",
          "text": "Gatorade was invented in 1965 by University of Florida researchers for the school's football team, the Gators, which is how the sports drink got its name.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-013",
          "category": "unusual",
          "text": "Florida's gemstone is moonstone, despite having no natural deposits.",
          "source_id": "FL-P"
        },
        {
          "id": "FL-014",
          "category": "geography",
          "text": "The St. Johns River flows north.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-015",
          "category": "geography",
          "text": "Lake Okeechobee is Florida's largest lake.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-016",
          "category": "nature_and_wildlife",
          "text": "Florida chose orange blossom as its floral emblem.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-017",
          "category": "nature_and_wildlife",
          "text": "The sabal palm is Florida's state tree.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-018",
          "category": "nature_and_wildlife",
          "text": "Florida's bird emblem is the northern mockingbird.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-019",
          "category": "nature_and_wildlife",
          "text": "Florida adopted the American alligator as state reptile in 1987.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-020",
          "category": "culture",
          "text": "Florida officially adopted Sunshine State as its nickname in 1970.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-021",
          "category": "landmarks_and_engineering",
          "text": "Venice beaches are associated with fossil shark teeth.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-022",
          "category": "landmarks_and_engineering",
          "text": "Sanibel has a museum devoted to shells and molluscs.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-023",
          "category": "history",
          "text": "Ybor City developed a major cigar-making industry.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-024",
          "category": "landmarks_and_engineering",
          "text": "The Sunshine Skyway Bridge crosses Tampa Bay.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-025",
          "category": "history",
          "text": "A scheduled air service linked St. Petersburg and Tampa in 1914.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-026",
          "category": "landmarks_and_engineering",
          "text": "Fort Zachary Taylor stands in Key West.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-027",
          "category": "history",
          "text": "Union forces held Fort Zachary Taylor during the Civil War.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-028",
          "category": "culture",
          "text": "Fort Lauderdale's waterways inspired its Venice of America nickname.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-029",
          "category": "landmarks_and_engineering",
          "text": "Delray Beach's Morikami Museum explores Japanese culture.",
          "source_id": "FL-F"
        },
        {
          "id": "FL-030",
          "category": "history",
          "text": "Olustee commemorates a Civil War battle fought in Florida.",
          "source_id": "FL-F"
        }
      ]
    },
    {
      "name": "Georgia",
      "code": "GA",
      "facts": [
        {
          "id": "GA-001",
          "category": "geography",
          "text": "Atlanta serves as Georgia's capital.",
          "source_id": "GA-D"
        },
        {
          "id": "GA-002",
          "category": "history",
          "text": "Georgia was fourth to ratify the US Constitution.",
          "source_id": "GA-D"
        },
        {
          "id": "GA-003",
          "category": "geography",
          "text": "Georgia has 159 counties.",
          "source_id": "GA-D"
        },
        {
          "id": "GA-004",
          "category": "sport",
          "text": "Atlanta hosted the Summer Olympics in 1996.",
          "source_id": "GA-D"
        },
        {
          "id": "GA-005",
          "category": "unusual",
          "text": "Georgia Tech beat Cumberland 222–0 in a 1916 football game.",
          "source_id": "GA-D"
        },
        {
          "id": "GA-006",
          "category": "people",
          "text": "Rebecca Latimer Felton became the first woman US senator.",
          "source_id": "GA-D"
        },
        {
          "id": "GA-007",
          "category": "geography",
          "text": "Georgia borders five states and the Atlantic Ocean.",
          "source_id": "GA-D"
        },
        {
          "id": "GA-008",
          "category": "nature_and_wildlife",
          "text": "Georgia honours the right whale as its marine mammal.",
          "source_id": "GA-D"
        },
        {
          "id": "GA-009",
          "category": "food_and_farming",
          "text": "Peanuts are an important Georgia crop.",
          "source_id": "GA-D"
        },
        {
          "id": "GA-010",
          "category": "geography",
          "text": "The Chattahoochee River runs through Georgia.",
          "source_id": "GA-D"
        },
        {
          "id": "GA-011",
          "category": "food_and_farming",
          "text": "Coca-Cola was developed in Atlanta in 1886.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-012",
          "category": "people",
          "text": "John Pemberton developed the original Coca-Cola drink.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-013",
          "category": "food_and_farming",
          "text": "Vidalia is associated with sweet-onion growing.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-014",
          "category": "sport",
          "text": "Augusta National hosts the Masters golf tournament.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-015",
          "category": "people",
          "text": "Jimmy Carter's hometown was Plains.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-016",
          "category": "landmarks_and_engineering",
          "text": "Franklin Roosevelt used the Little White House in Warm Springs.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-017",
          "category": "nature_and_wildlife",
          "text": "Feral horses live on Cumberland Island.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-018",
          "category": "landmarks_and_engineering",
          "text": "Cumberland Island preserves ruins of the Carnegie family's Dungeness estate.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-019",
          "category": "nature_and_wildlife",
          "text": "The Okefenokee includes cypress swamps and open wetland prairies.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-020",
          "category": "geography",
          "text": "Brasstown Bald is Georgia's highest summit.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-021",
          "category": "geology",
          "text": "Stone Mountain is a vast exposed granite outcrop.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-022",
          "category": "culture",
          "text": "Providence Canyon is nicknamed Georgia's Little Grand Canyon.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-023",
          "category": "nature_and_wildlife",
          "text": "Georgia chose the Cherokee rose as its floral emblem.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-024",
          "category": "nature_and_wildlife",
          "text": "The brown thrasher is Georgia's designated bird.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-025",
          "category": "nature_and_wildlife",
          "text": "Georgia's tree emblem is the live oak.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-026",
          "category": "history",
          "text": "Georgia's name honours King George II.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-027",
          "category": "history",
          "text": "Georgia adopted its current flag design in 2003.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-028",
          "category": "culture",
          "text": "Thomasville uses the nickname City of Roses.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-029",
          "category": "history",
          "text": "The locomotive General was stolen during an 1862 wartime raid.",
          "source_id": "GA-F"
        },
        {
          "id": "GA-030",
          "category": "nature_and_wildlife",
          "text": "Callaway Gardens is associated with displays of azaleas.",
          "source_id": "GA-F"
        }
      ]
    },
    {
      "name": "Hawaii",
      "code": "HI",
      "facts": [
        {
          "id": "HI-001",
          "category": "geography",
          "text": "Honolulu serves as Hawaii's capital.",
          "source_id": "HI-D"
        },
        {
          "id": "HI-002",
          "category": "history",
          "text": "Hawaii became the 50th state on 21 August 1959.",
          "source_id": "HI-D"
        },
        {
          "id": "HI-003",
          "category": "geography",
          "text": "Hawaii shares no land border with another state.",
          "source_id": "HI-D"
        },
        {
          "id": "HI-004",
          "category": "geography",
          "text": "The state consists of islands in the Pacific Ocean.",
          "source_id": "HI-D"
        },
        {
          "id": "HI-005",
          "category": "nature_and_wildlife",
          "text": "Hawaii's reef triggerfish has official state-fish status.",
          "source_id": "HI-D"
        },
        {
          "id": "HI-006",
          "category": "nature_and_wildlife",
          "text": "The humpback whale is Hawaii's state marine mammal.",
          "source_id": "HI-D"
        },
        {
          "id": "HI-007",
          "category": "culture",
          "text": "Hawaii's flag includes Britain's Union Jack.",
          "source_id": "HI-D"
        },
        {
          "id": "HI-008",
          "category": "history",
          "text": "Kamehameha I united the main Hawaiian Islands in 1810.",
          "source_id": "HI-D"
        },
        {
          "id": "HI-009",
          "category": "history",
          "text": "Japan's Pearl Harbor attack brought America into World War II.",
          "source_id": "HI-D"
        },
        {
          "id": "HI-010",
          "category": "history",
          "text": "European navigators once called Hawaii the Sandwich Islands.",
          "source_id": "HI-D"
        },
        {
          "id": "HI-011",
          "category": "nature_and_wildlife",
          "text": "Hawaii's bird emblem, the nēnē, is a goose.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-012",
          "category": "nature_and_wildlife",
          "text": "The kukui, or candlenut, is Hawaii's state tree.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-013",
          "category": "culture",
          "text": "Hawaii officially adopted Aloha State as its nickname in 1959.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-014",
          "category": "geology",
          "text": "Volcanic eruptions built the Hawaiian Islands.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-015",
          "category": "geography",
          "text": "Hawaii has eight main islands.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-016",
          "category": "geography",
          "text": "The island of Hawaii is the largest main island.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-017",
          "category": "geography",
          "text": "Mauna Kea's base lies deep below the ocean's surface.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-018",
          "category": "science_and_invention",
          "text": "Mauna Kea hosts astronomical observatories.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-019",
          "category": "people",
          "text": "Hiram Fong entered the US Senate in 1959.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-020",
          "category": "landmarks_and_engineering",
          "text": "Honolulu's Iolani Palace housed Hawaiian royalty.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-021",
          "category": "landmarks_and_engineering",
          "text": "Maui contains Haleakalā volcano.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-022",
          "category": "history",
          "text": "Lahaina developed as a whaling port.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-023",
          "category": "geography",
          "text": "The road to Hāna follows Maui's rugged coast.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-024",
          "category": "history",
          "text": "Lānaʻi once supported extensive pineapple plantations.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-025",
          "category": "history",
          "text": "Kahoʻolawe was used for military target practice.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-026",
          "category": "geography",
          "text": "Molokaʻi has high sea cliffs.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-027",
          "category": "nature_and_wildlife",
          "text": "Eastern Molokaʻi contains tropical rainforest.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-028",
          "category": "geography",
          "text": "Kure Atoll lies near the archipelago's northwestern end.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-029",
          "category": "culture",
          "text": "Hawaiian tradition calls the star Arcturus Hōkūleʻa.",
          "source_id": "HI-F"
        },
        {
          "id": "HI-030",
          "category": "geography",
          "text": "Mauna Loa dominates part of Hawaii's largest island.",
          "source_id": "HI-F"
        }
      ]
    },
    {
      "name": "Idaho",
      "code": "ID",
      "facts": [
        {
          "id": "ID-001",
          "category": "geography",
          "text": "Boise serves as Idaho's capital.",
          "source_id": "ID-D"
        },
        {
          "id": "ID-002",
          "category": "history",
          "text": "Idaho became the 43rd state in 1890.",
          "source_id": "ID-D"
        },
        {
          "id": "ID-003",
          "category": "geography",
          "text": "Idaho shares a border with Canada.",
          "source_id": "ID-D"
        },
        {
          "id": "ID-004",
          "category": "geography",
          "text": "Idaho touches six other US states.",
          "source_id": "ID-D"
        },
        {
          "id": "ID-005",
          "category": "geography",
          "text": "Borah Peak is Idaho's highest summit.",
          "source_id": "ID-D"
        },
        {
          "id": "ID-006",
          "category": "geography",
          "text": "Idaho contains 44 counties.",
          "source_id": "ID-D"
        },
        {
          "id": "ID-007",
          "category": "geology",
          "text": "Craters of the Moon preserves volcanic terrain.",
          "source_id": "ID-D"
        },
        {
          "id": "ID-008",
          "category": "geography",
          "text": "Lake Pend Oreille exceeds 1,000 feet in depth.",
          "source_id": "ID-D"
        },
        {
          "id": "ID-009",
          "category": "nature_and_wildlife",
          "text": "The Appaloosa is Idaho's official horse.",
          "source_id": "ID-D"
        },
        {
          "id": "ID-010",
          "category": "culture",
          "text": "Nez Perce and Shoshone peoples have homelands in Idaho.",
          "source_id": "ID-D"
        },
        {
          "id": "ID-011",
          "category": "landmarks_and_engineering",
          "text": "American Falls was relocated for a dam project in the 1920s.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-012",
          "category": "people",
          "text": "Emma Edwards Green designed Idaho's state seal.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-013",
          "category": "culture",
          "text": "Idaho's Gem State nickname celebrates its minerals.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-014",
          "category": "nature_and_wildlife",
          "text": "The mountain bluebird is Idaho's bird emblem.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-015",
          "category": "nature_and_wildlife",
          "text": "Western white pine represents Idaho as its state tree.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-016",
          "category": "nature_and_wildlife",
          "text": "Syringa, a mock orange, is Idaho's floral emblem.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-017",
          "category": "geography",
          "text": "Lewiston stands where the Snake and Clearwater rivers meet.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-018",
          "category": "landmarks_and_engineering",
          "text": "Shoshone Falls plunges near Twin Falls.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-019",
          "category": "geography",
          "text": "Hells Canyon forms part of Idaho's western edge.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-020",
          "category": "landmarks_and_engineering",
          "text": "Bruneau Dunes State Park protects large sand dunes.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-021",
          "category": "geography",
          "text": "Lava Hot Springs is known for geothermal waters.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-022",
          "category": "history",
          "text": "Idaho City grew during the 1860s gold rush.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-023",
          "category": "science_and_invention",
          "text": "Television pioneer Philo Farnsworth spent formative years near Rigby.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-024",
          "category": "culture",
          "text": "Weiser hosts an old-time fiddling contest.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-025",
          "category": "food_and_farming",
          "text": "Shelley celebrates potatoes through its Spud Day tradition.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-026",
          "category": "sport",
          "text": "Sun Valley became a pioneering American destination ski resort.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-027",
          "category": "landmarks_and_engineering",
          "text": "Pocatello houses Idaho State University.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-028",
          "category": "landmarks_and_engineering",
          "text": "Blackfoot hosts the Eastern Idaho State Fair.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-029",
          "category": "geography",
          "text": "The Sawtooth Mountains take their name from their jagged outline.",
          "source_id": "ID-F"
        },
        {
          "id": "ID-030",
          "category": "history",
          "text": "Idaho's territorial prison opened in 1872.",
          "source_id": "ID-F"
        }
      ]
    },
    {
      "name": "Illinois",
      "code": "IL",
      "facts": [
        {
          "id": "IL-001",
          "category": "geography",
          "text": "Springfield serves as Illinois's capital.",
          "source_id": "IL-D"
        },
        {
          "id": "IL-002",
          "category": "history",
          "text": "Illinois became the 21st state in 1818.",
          "source_id": "IL-D"
        },
        {
          "id": "IL-003",
          "category": "geography",
          "text": "Illinois contains 102 counties.",
          "source_id": "IL-D"
        },
        {
          "id": "IL-004",
          "category": "geography",
          "text": "Charles Mound is Illinois's highest point.",
          "source_id": "IL-D"
        },
        {
          "id": "IL-005",
          "category": "geography",
          "text": "Illinois has a shoreline on Lake Michigan.",
          "source_id": "IL-D"
        },
        {
          "id": "IL-006",
          "category": "nature_and_wildlife",
          "text": "Illinois's designated state fish is the bluegill.",
          "source_id": "IL-D"
        },
        {
          "id": "IL-007",
          "category": "nature_and_wildlife",
          "text": "The white-tailed deer is Illinois's state animal.",
          "source_id": "IL-D"
        },
        {
          "id": "IL-008",
          "category": "people",
          "text": "Walt Disney was born in Illinois.",
          "source_id": "IL-D"
        },
        {
          "id": "IL-009",
          "category": "people",
          "text": "Writer Ernest Hemingway was born in Illinois.",
          "source_id": "IL-D"
        },
        {
          "id": "IL-010",
          "category": "people",
          "text": "Actor Harrison Ford was born in Illinois.",
          "source_id": "IL-D"
        },
        {
          "id": "IL-011",
          "category": "culture",
          "text": "Chicago dyes its river green for St. Patrick's celebrations.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-012",
          "category": "unusual",
          "text": "Illinois has a real town named Metropolis celebrating Superman.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-013",
          "category": "science_and_invention",
          "text": "Chicago hosted the first controlled, self-sustaining nuclear chain reaction in 1942.",
          "source_id": "IL-P"
        },
        {
          "id": "IL-014",
          "category": "history",
          "text": "Kaskaskia and Vandalia were capitals before Springfield.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-015",
          "category": "history",
          "text": "Illinois was the first state to ratify the Thirteenth Amendment.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-016",
          "category": "people",
          "text": "Abraham Lincoln practised law in Springfield.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-017",
          "category": "landmarks_and_engineering",
          "text": "Lincoln's tomb stands in Springfield.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-018",
          "category": "people",
          "text": "Ronald Reagan grew up in Dixon.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-019",
          "category": "people",
          "text": "Ronald Reagan was born in Tampico.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-020",
          "category": "culture",
          "text": "Square dancing is Illinois's official state dance.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-021",
          "category": "nature_and_wildlife",
          "text": "The northern cardinal is Illinois's bird emblem.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-022",
          "category": "nature_and_wildlife",
          "text": "Illinois selected the violet as its floral emblem.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-023",
          "category": "nature_and_wildlife",
          "text": "Illinois's state tree is the white oak.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-024",
          "category": "history",
          "text": "Cahokia preserves monumental earthworks built by Indigenous communities.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-025",
          "category": "history",
          "text": "Seven Illinois towns hosted the Lincoln–Douglas debates.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-026",
          "category": "culture",
          "text": "O'Hare's ORD airport code recalls its earlier Orchard Field name.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-027",
          "category": "culture",
          "text": "Chicago's Second City comedy theatre began in 1959.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-028",
          "category": "people",
          "text": "Harold Washington became Chicago's first Black mayor in 1983.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-029",
          "category": "history",
          "text": "The University of Chicago opened in 1892.",
          "source_id": "IL-F"
        },
        {
          "id": "IL-030",
          "category": "culture",
          "text": "Chicago's flag has four stars commemorating historical events.",
          "source_id": "IL-F"
        }
      ]
    },
    {
      "name": "Indiana",
      "code": "IN",
      "facts": [
        {
          "id": "IN-001",
          "category": "geography",
          "text": "Indianapolis serves as Indiana's capital.",
          "source_id": "IN-D"
        },
        {
          "id": "IN-002",
          "category": "history",
          "text": "Indiana became the 19th state in 1816.",
          "source_id": "IN-D"
        },
        {
          "id": "IN-003",
          "category": "geography",
          "text": "Hoosier Hill is Indiana's highest point.",
          "source_id": "IN-D"
        },
        {
          "id": "IN-004",
          "category": "geography",
          "text": "Indiana contains 92 counties.",
          "source_id": "IN-D"
        },
        {
          "id": "IN-005",
          "category": "geography",
          "text": "Indiana borders Ohio, Kentucky, Illinois and Michigan.",
          "source_id": "IN-D"
        },
        {
          "id": "IN-006",
          "category": "culture",
          "text": "Indiana's flag has 19 stars marking its statehood order.",
          "source_id": "IN-D"
        },
        {
          "id": "IN-007",
          "category": "culture",
          "text": "The precise origin of the word Hoosier remains uncertain.",
          "source_id": "IN-D"
        },
        {
          "id": "IN-008",
          "category": "landmarks_and_engineering",
          "text": "Holiday World is located in the town of Santa Claus.",
          "source_id": "IN-D"
        },
        {
          "id": "IN-009",
          "category": "food_and_farming",
          "text": "Corn is an important Indiana crop.",
          "source_id": "IN-D"
        },
        {
          "id": "IN-010",
          "category": "geography",
          "text": "The Wabash is one of Indiana's major rivers.",
          "source_id": "IN-D"
        },
        {
          "id": "IN-011",
          "category": "unusual",
          "text": "Crawfordsville preserves a jail with a rotating cellblock.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-012",
          "category": "unusual",
          "text": "A town named Santa Claus receives Christmas letters.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-013",
          "category": "landmarks_and_engineering",
          "text": "Indiana limestone was used in the Empire State Building.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-014",
          "category": "sport",
          "text": "The Indianapolis 500 began in 1911.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-015",
          "category": "sport",
          "text": "A full Indianapolis 500 consists of 200 laps.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-016",
          "category": "people",
          "text": "Abraham Lincoln spent much of his childhood in Indiana.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-017",
          "category": "history",
          "text": "Corydon was Indiana's capital before Indianapolis.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-018",
          "category": "history",
          "text": "Vincennes served as Indiana's territorial capital.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-019",
          "category": "nature_and_wildlife",
          "text": "Indiana's tree emblem is the tulip tree.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-020",
          "category": "nature_and_wildlife",
          "text": "The peony is Indiana's floral emblem.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-021",
          "category": "nature_and_wildlife",
          "text": "The northern cardinal is Indiana's bird emblem.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-022",
          "category": "geography",
          "text": "Indiana has a short shoreline on Lake Michigan.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-023",
          "category": "geography",
          "text": "Lake Wawasee is Indiana's largest natural lake.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-024",
          "category": "landmarks_and_engineering",
          "text": "Parke County is known for its covered bridges.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-025",
          "category": "landmarks_and_engineering",
          "text": "Evansville manufactured P-47 aircraft during World War II.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-026",
          "category": "industry",
          "text": "Studebaker made wagons before moving into automobile production.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-027",
          "category": "culture",
          "text": "Peru developed a strong association with travelling circuses.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-028",
          "category": "people",
          "text": "Broadcaster David Letterman was born in Indianapolis.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-029",
          "category": "sport",
          "text": "Indianapolis hosted the Pan American Games in 1987.",
          "source_id": "IN-F"
        },
        {
          "id": "IN-030",
          "category": "people",
          "text": "Comedian Red Skelton was born in Vincennes.",
          "source_id": "IN-F"
        }
      ]
    },
    {
      "name": "Iowa",
      "code": "IA",
      "facts": [
        {
          "id": "IA-001",
          "category": "geography",
          "text": "Des Moines serves as Iowa's capital.",
          "source_id": "IA-D"
        },
        {
          "id": "IA-002",
          "category": "history",
          "text": "Iowa became the 29th state in 1846.",
          "source_id": "IA-D"
        },
        {
          "id": "IA-003",
          "category": "geography",
          "text": "Iowa contains 99 counties.",
          "source_id": "IA-D"
        },
        {
          "id": "IA-004",
          "category": "geography",
          "text": "Hawkeye Point is Iowa's highest point.",
          "source_id": "IA-D"
        },
        {
          "id": "IA-005",
          "category": "culture",
          "text": "Iowa's name comes from the Ioway people.",
          "source_id": "IA-D"
        },
        {
          "id": "IA-006",
          "category": "nature_and_wildlife",
          "text": "Iowa's floral emblem is the wild rose.",
          "source_id": "IA-D"
        },
        {
          "id": "IA-007",
          "category": "nature_and_wildlife",
          "text": "Iowa chose the oak as its state tree.",
          "source_id": "IA-D"
        },
        {
          "id": "IA-008",
          "category": "food_and_farming",
          "text": "Corn and soybeans are major Iowa crops.",
          "source_id": "IA-D"
        },
        {
          "id": "IA-009",
          "category": "history",
          "text": "Iowa communities participated in the Underground Railroad.",
          "source_id": "IA-D"
        },
        {
          "id": "IA-010",
          "category": "geography",
          "text": "Iowa borders six other states.",
          "source_id": "IA-D"
        },
        {
          "id": "IA-011",
          "category": "unusual",
          "text": "Iowa alone begins its state name with two vowels.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-012",
          "category": "landmarks_and_engineering",
          "text": "Strawberry Point displays a giant strawberry sculpture.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-013",
          "category": "landmarks_and_engineering",
          "text": "Burlington's Snake Alley winds through a series of tight bends.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-014",
          "category": "culture",
          "text": "Decorah's Nordic Fest celebrates Scandinavian heritage.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-015",
          "category": "culture",
          "text": "Elk Horn preserves a strong Danish heritage.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-016",
          "category": "landmarks_and_engineering",
          "text": "Cedar Rapids Museum of Art holds works by Grant Wood.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-017",
          "category": "landmarks_and_engineering",
          "text": "Dubuque's Fenelon Place Elevator is a short inclined railway.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-018",
          "category": "geography",
          "text": "Sabula occupies an island in the Mississippi River.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-019",
          "category": "people",
          "text": "Herbert Hoover was born in West Branch.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-020",
          "category": "people",
          "text": "John Wayne was born in Winterset.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-021",
          "category": "people",
          "text": "Bandleader Glenn Miller was born in Clarinda.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-022",
          "category": "people",
          "text": "Composer Meredith Willson came from Mason City.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-023",
          "category": "people",
          "text": "Actor Donna Reed was born in Denison.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-024",
          "category": "landmarks_and_engineering",
          "text": "Indianola houses the National Balloon Museum.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-025",
          "category": "sport",
          "text": "Knoxville has a museum devoted to sprint-car racing.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-026",
          "category": "history",
          "text": "Sioux City's Sergeant Floyd Monument honours a Lewis–Clark expedition member.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-027",
          "category": "culture",
          "text": "Story City preserves an antique carousel.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-028",
          "category": "geography",
          "text": "West Okoboji is Iowa's deepest natural lake.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-029",
          "category": "culture",
          "text": "Dixie Cornell Gebhardt designed Iowa's flag.",
          "source_id": "IA-F"
        },
        {
          "id": "IA-030",
          "category": "nature_and_wildlife",
          "text": "The American goldfinch is Iowa's bird emblem.",
          "source_id": "IA-F"
        }
      ]
    },
    {
      "name": "Kansas",
      "code": "KS",
      "facts": [
        {
          "id": "KS-001",
          "category": "geography",
          "text": "Topeka serves as Kansas's capital.",
          "source_id": "KS-D"
        },
        {
          "id": "KS-002",
          "category": "history",
          "text": "Kansas became the 34th state in 1861.",
          "source_id": "KS-D"
        },
        {
          "id": "KS-003",
          "category": "geography",
          "text": "Mount Sunflower is Kansas's highest point.",
          "source_id": "KS-D"
        },
        {
          "id": "KS-004",
          "category": "geography",
          "text": "Kansas contains 105 counties.",
          "source_id": "KS-D"
        },
        {
          "id": "KS-005",
          "category": "geography",
          "text": "Kansas borders Nebraska, Missouri, Oklahoma and Colorado.",
          "source_id": "KS-D"
        },
        {
          "id": "KS-006",
          "category": "culture",
          "text": "Kansas takes its name from the Kansa people.",
          "source_id": "KS-D"
        },
        {
          "id": "KS-007",
          "category": "nature_and_wildlife",
          "text": "The American bison is Kansas's state animal.",
          "source_id": "KS-D"
        },
        {
          "id": "KS-008",
          "category": "culture",
          "text": "Dorothy's fictional home in The Wizard of Oz is Kansas.",
          "source_id": "KS-D"
        },
        {
          "id": "KS-009",
          "category": "food_and_farming",
          "text": "Wheat is central to Kansas's farming identity.",
          "source_id": "KS-D"
        },
        {
          "id": "KS-010",
          "category": "geography",
          "text": "The Kansas River is also called the Kaw.",
          "source_id": "KS-D"
        },
        {
          "id": "KS-011",
          "category": "unusual",
          "text": "Cawker City displays an enormous community-built ball of twine.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-012",
          "category": "food_and_farming",
          "text": "The first Pizza Hut opened in Wichita.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-013",
          "category": "people",
          "text": "Susanna Salter became Argonia's mayor in 1887.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-014",
          "category": "people",
          "text": "Aviation pioneer Amelia Earhart came from Atchison.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-015",
          "category": "people",
          "text": "Buster Keaton came from Piqua.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-016",
          "category": "people",
          "text": "Dwight Eisenhower grew up in Abilene.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-017",
          "category": "people",
          "text": "Wichita-born Hattie McDaniel became the first Black Oscar winner.",
          "source_id": "KS-P"
        },
        {
          "id": "KS-018",
          "category": "culture",
          "text": "Barton County honours nurse Clara Barton.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-019",
          "category": "landmarks_and_engineering",
          "text": "Lucas's Garden of Eden features elaborate concrete sculptures.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-020",
          "category": "geology",
          "text": "Hutchinson developed above substantial salt deposits.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-021",
          "category": "geology",
          "text": "Rock City features large rounded sandstone concretions.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-022",
          "category": "culture",
          "text": "Manhattan displays a statue of fictional farmer Johnny Kaw.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-023",
          "category": "landmarks_and_engineering",
          "text": "Cedar Crest is the Kansas governor's residence.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-024",
          "category": "nature_and_wildlife",
          "text": "Kansas's floral emblem is the sunflower.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-025",
          "category": "nature_and_wildlife",
          "text": "The western meadowlark is Kansas's bird emblem.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-026",
          "category": "nature_and_wildlife",
          "text": "The eastern cottonwood is Kansas's state tree.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-027",
          "category": "culture",
          "text": "Home on the Range is Kansas's state song.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-028",
          "category": "history",
          "text": "George Washington Carver attended high school in Minneapolis, Kansas.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-029",
          "category": "history",
          "text": "Dodge City became famous as a frontier cattle town.",
          "source_id": "KS-F"
        },
        {
          "id": "KS-030",
          "category": "landmarks_and_engineering",
          "text": "Meades Ranch became a reference point for continental land surveying.",
          "source_id": "KS-F"
        }
      ]
    },
    {
      "name": "Kentucky",
      "code": "KY",
      "facts": [
        {
          "id": "KY-001",
          "category": "geography",
          "text": "Frankfort serves as Kentucky's capital.",
          "source_id": "KY-D"
        },
        {
          "id": "KY-002",
          "category": "history",
          "text": "Kentucky became the 15th state in 1792.",
          "source_id": "KY-D"
        },
        {
          "id": "KY-003",
          "category": "history",
          "text": "Kentucky was part of Virginia before statehood.",
          "source_id": "KY-D"
        },
        {
          "id": "KY-004",
          "category": "geography",
          "text": "Kentucky borders seven other states.",
          "source_id": "KY-D"
        },
        {
          "id": "KY-005",
          "category": "geography",
          "text": "Black Mountain is Kentucky's highest point.",
          "source_id": "KY-D"
        },
        {
          "id": "KY-006",
          "category": "geography",
          "text": "Kentucky contains 120 counties.",
          "source_id": "KY-D"
        },
        {
          "id": "KY-007",
          "category": "landmarks_and_engineering",
          "text": "Fort Knox houses the United States Bullion Depository.",
          "source_id": "KY-D"
        },
        {
          "id": "KY-008",
          "category": "sport",
          "text": "Louisville produces the famous Louisville Slugger baseball bats.",
          "source_id": "KY-D"
        },
        {
          "id": "KY-009",
          "category": "nature_and_wildlife",
          "text": "Kentucky recognises the thoroughbred as its state horse.",
          "source_id": "KY-D"
        },
        {
          "id": "KY-010",
          "category": "geography",
          "text": "The Ohio River runs along Kentucky's northern side.",
          "source_id": "KY-D"
        },
        {
          "id": "KY-011",
          "category": "geology",
          "text": "Mammoth Cave is the longest known cave system.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-012",
          "category": "nature_and_wildlife",
          "text": "Cumberland Falls sometimes produces a rainbow under moonlight.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-013",
          "category": "unusual",
          "text": "Middlesboro occupies an ancient meteorite-impact structure.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-014",
          "category": "sport",
          "text": "Churchill Downs in Louisville hosts the Kentucky Derby.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-015",
          "category": "industry",
          "text": "Bowling Green manufactures Chevrolet Corvettes.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-016",
          "category": "people",
          "text": "Abraham Lincoln was born in Kentucky.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-017",
          "category": "people",
          "text": "Confederate president Jefferson Davis was also born in Kentucky.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-018",
          "category": "food_and_farming",
          "text": "Colonel Sanders developed his fried-chicken business in Corbin.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-019",
          "category": "nature_and_wildlife",
          "text": "Goldenrod is Kentucky's floral emblem.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-020",
          "category": "nature_and_wildlife",
          "text": "Kentucky's tree emblem is the tulip poplar.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-021",
          "category": "nature_and_wildlife",
          "text": "Kentucky's bird emblem is the northern cardinal.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-022",
          "category": "history",
          "text": "Kentucky replaced its coffee-tree emblem with tulip poplar in 1976.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-023",
          "category": "history",
          "text": "Harrodsburg began as Harrodstown in 1774.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-024",
          "category": "sport",
          "text": "The Lexington area is associated with racehorse breeding.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-025",
          "category": "culture",
          "text": "Fleming County is known for covered bridges.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-026",
          "category": "culture",
          "text": "Thunder Over Louisville forms part of the Derby Festival.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-027",
          "category": "landmarks_and_engineering",
          "text": "Newport displays the World Peace Bell.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-028",
          "category": "people",
          "text": "Temperance campaigner Carrie Nation was born in Kentucky.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-029",
          "category": "unusual",
          "text": "Lexington has a memorial to a local dog, Smiley Pete.",
          "source_id": "KY-F"
        },
        {
          "id": "KY-030",
          "category": "landmarks_and_engineering",
          "text": "Covington's cathedral basilica contains extensive stained-glass windows.",
          "source_id": "KY-F"
        }
      ]
    },
    {
      "name": "Louisiana",
      "code": "LA",
      "facts": [
        {
          "id": "LA-001",
          "category": "geography",
          "text": "Baton Rouge serves as Louisiana's capital.",
          "source_id": "LA-D"
        },
        {
          "id": "LA-002",
          "category": "history",
          "text": "Louisiana became the 18th state in 1812.",
          "source_id": "LA-D"
        },
        {
          "id": "LA-003",
          "category": "geography",
          "text": "Louisiana borders Texas, Arkansas and Mississippi.",
          "source_id": "LA-D"
        },
        {
          "id": "LA-004",
          "category": "geography",
          "text": "Driskill Mountain is Louisiana's highest natural point.",
          "source_id": "LA-D"
        },
        {
          "id": "LA-005",
          "category": "nature_and_wildlife",
          "text": "The honeybee is Louisiana's insect emblem.",
          "source_id": "LA-D"
        },
        {
          "id": "LA-006",
          "category": "culture",
          "text": "New Orleans became a major birthplace of jazz.",
          "source_id": "LA-D"
        },
        {
          "id": "LA-007",
          "category": "history",
          "text": "The United States bought the Louisiana Territory from France in 1803.",
          "source_id": "LA-D"
        },
        {
          "id": "LA-008",
          "category": "history",
          "text": "The Louisiana Purchase cost US$15 million.",
          "source_id": "LA-D"
        },
        {
          "id": "LA-009",
          "category": "nature_and_wildlife",
          "text": "Conservation helped restore brown pelicans to Louisiana.",
          "source_id": "LA-D"
        },
        {
          "id": "LA-010",
          "category": "geography",
          "text": "Lake Maurepas is one of Louisiana's coastal lakes.",
          "source_id": "LA-D"
        },
        {
          "id": "LA-011",
          "category": "culture",
          "text": "Louisiana calls its county-level subdivisions parishes.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-012",
          "category": "landmarks_and_engineering",
          "text": "The Lake Pontchartrain Causeway stretches about 24 miles.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-013",
          "category": "landmarks_and_engineering",
          "text": "Louisiana's state capitol rises 34 storeys.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-014",
          "category": "history",
          "text": "Louisiana's name honours France's King Louis XIV.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-015",
          "category": "history",
          "text": "French colonists founded New Orleans in 1718.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-016",
          "category": "culture",
          "text": "New Orleans is known for Mardi Gras parades.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-017",
          "category": "nature_and_wildlife",
          "text": "Louisiana's state tree is the bald cypress.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-018",
          "category": "nature_and_wildlife",
          "text": "The magnolia is Louisiana's floral emblem.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-019",
          "category": "nature_and_wildlife",
          "text": "Louisiana's bird emblem is the brown pelican.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-020",
          "category": "nature_and_wildlife",
          "text": "The Catahoula leopard dog is Louisiana's official dog.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-021",
          "category": "culture",
          "text": "Cajun heritage includes descendants of Acadians expelled from Canada.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-022",
          "category": "food_and_farming",
          "text": "Breaux Bridge celebrates its association with crawfish.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-023",
          "category": "landmarks_and_engineering",
          "text": "New Orleans has the historic St. Charles streetcar line.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-024",
          "category": "geography",
          "text": "The Atchafalaya Basin contains extensive swamps and wetlands.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-025",
          "category": "sport",
          "text": "Baton Rouge hosted the Special Olympics World Summer Games in 1983.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-026",
          "category": "culture",
          "text": "Gueydan's Duck Capital nickname reflects its waterfowl traditions.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-027",
          "category": "history",
          "text": "Louisiana also experienced Spanish colonial rule.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-028",
          "category": "history",
          "text": "Pirate Jean Lafitte became associated with Louisiana's coast.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-029",
          "category": "people",
          "text": "Jim Bowie lived in Opelousas before his Texas years.",
          "source_id": "LA-F"
        },
        {
          "id": "LA-030",
          "category": "culture",
          "text": "The town of Sulphur takes its name from mineral extraction.",
          "source_id": "LA-F"
        }
      ]
    },
    {
      "name": "Maine",
      "code": "ME",
      "facts": [
        {
          "id": "ME-001",
          "category": "geography",
          "text": "Augusta serves as Maine's capital.",
          "source_id": "ME-D"
        },
        {
          "id": "ME-002",
          "category": "history",
          "text": "Maine became the 23rd state in 1820.",
          "source_id": "ME-D"
        },
        {
          "id": "ME-003",
          "category": "history",
          "text": "Maine belonged to Massachusetts before becoming a state.",
          "source_id": "ME-D"
        },
        {
          "id": "ME-004",
          "category": "geography",
          "text": "Katahdin is Maine's highest summit.",
          "source_id": "ME-D"
        },
        {
          "id": "ME-005",
          "category": "geography",
          "text": "Maine has 16 counties.",
          "source_id": "ME-D"
        },
        {
          "id": "ME-006",
          "category": "nature_and_wildlife",
          "text": "The black-capped chickadee is Maine's bird emblem.",
          "source_id": "ME-D"
        },
        {
          "id": "ME-007",
          "category": "nature_and_wildlife",
          "text": "Maine's official tree is the eastern white pine.",
          "source_id": "ME-D"
        },
        {
          "id": "ME-008",
          "category": "nature_and_wildlife",
          "text": "The moose is Maine's state animal.",
          "source_id": "ME-D"
        },
        {
          "id": "ME-009",
          "category": "nature_and_wildlife",
          "text": "Landlocked salmon is Maine's state fish.",
          "source_id": "ME-D"
        },
        {
          "id": "ME-010",
          "category": "geography",
          "text": "The Kennebec and Penobscot are major Maine rivers.",
          "source_id": "ME-D"
        },
        {
          "id": "ME-011",
          "category": "unusual",
          "text": "Maine is the only one-syllable US state name.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-012",
          "category": "geography",
          "text": "New Hampshire is Maine's only neighbouring US state.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-013",
          "category": "unusual",
          "text": "Maine's floral emblem is a pine cone and tassel.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-014",
          "category": "culture",
          "text": "Bath's City of Ships nickname reflects its shipbuilding heritage.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-015",
          "category": "history",
          "text": "Portland served as Maine's capital before Augusta.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-016",
          "category": "people",
          "text": "Poet Henry Wadsworth Longfellow was born in Portland.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-017",
          "category": "landmarks_and_engineering",
          "text": "Freeport is associated with outdoor retailer L.L.Bean.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-018",
          "category": "landmarks_and_engineering",
          "text": "Searsport houses the Penobscot Marine Museum.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-019",
          "category": "history",
          "text": "Maine's Fort Knox was designed to protect the Penobscot River.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-020",
          "category": "landmarks_and_engineering",
          "text": "Maine's Fort Knox used granite from Mount Waldo.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-021",
          "category": "nature_and_wildlife",
          "text": "Maine selected the honeybee as its state insect.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-022",
          "category": "culture",
          "text": "Pine Tree State recalls Maine's forest heritage.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-023",
          "category": "geography",
          "text": "Maine covers nearly as much area as the remaining New England states combined.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-024",
          "category": "history",
          "text": "English colonists attempted a Popham settlement in 1607.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-025",
          "category": "history",
          "text": "British troops occupied Eastport from 1814 to 1818.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-026",
          "category": "history",
          "text": "Machias saw an early Revolutionary War naval battle in 1775.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-027",
          "category": "people",
          "text": "Senator Edmund Muskie was born in Rumford.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-028",
          "category": "landmarks_and_engineering",
          "text": "Islesboro has a Sailors' Memorial Museum.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-029",
          "category": "food_and_farming",
          "text": "Maine has a long lobster-fishing tradition.",
          "source_id": "ME-F"
        },
        {
          "id": "ME-030",
          "category": "landmarks_and_engineering",
          "text": "Fort Point Lighthouse stands in Stockton Springs.",
          "source_id": "ME-F"
        }
      ]
    },
    {
      "name": "Maryland",
      "code": "MD",
      "facts": [
        {
          "id": "MD-001",
          "category": "geography",
          "text": "Annapolis serves as Maryland's capital.",
          "source_id": "MD-D"
        },
        {
          "id": "MD-002",
          "category": "history",
          "text": "Maryland was seventh to ratify the US Constitution.",
          "source_id": "MD-D"
        },
        {
          "id": "MD-003",
          "category": "culture",
          "text": "Maryland's name honours Queen Henrietta Maria.",
          "source_id": "MD-D"
        },
        {
          "id": "MD-004",
          "category": "geography",
          "text": "Maryland surrounds Washington, DC on three sides.",
          "source_id": "MD-D"
        },
        {
          "id": "MD-005",
          "category": "nature_and_wildlife",
          "text": "Maryland's floral emblem is the black-eyed Susan.",
          "source_id": "MD-D"
        },
        {
          "id": "MD-006",
          "category": "nature_and_wildlife",
          "text": "The Baltimore oriole is Maryland's bird emblem.",
          "source_id": "MD-D"
        },
        {
          "id": "MD-007",
          "category": "nature_and_wildlife",
          "text": "The white oak is Maryland's state tree.",
          "source_id": "MD-D"
        },
        {
          "id": "MD-008",
          "category": "nature_and_wildlife",
          "text": "Maryland's rockfish is also known as striped bass.",
          "source_id": "MD-D"
        },
        {
          "id": "MD-009",
          "category": "nature_and_wildlife",
          "text": "The Chesapeake Bay retriever is Maryland's official dog.",
          "source_id": "MD-D"
        },
        {
          "id": "MD-010",
          "category": "geography",
          "text": "Chesapeake Bay divides Maryland into western and eastern shores.",
          "source_id": "MD-D"
        },
        {
          "id": "MD-011",
          "category": "history",
          "text": "Fort McHenry's bombardment inspired the US national anthem.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-012",
          "category": "people",
          "text": "Francis Scott Key wrote the anthem's original poem.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-013",
          "category": "landmarks_and_engineering",
          "text": "Baltimore's Inner Harbor houses the National Aquarium.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-014",
          "category": "landmarks_and_engineering",
          "text": "The Chesapeake Bay Bridge links Maryland's two shores.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-015",
          "category": "landmarks_and_engineering",
          "text": "Maryland's State House still serves its legislature.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-016",
          "category": "history",
          "text": "Annapolis hosted the national government during the 1780s.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-017",
          "category": "history",
          "text": "The Naval Academy opened in Annapolis in 1845.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-018",
          "category": "people",
          "text": "Baseball star Babe Ruth was born in Baltimore.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-019",
          "category": "nature_and_wildlife",
          "text": "Feral horses live on Assateague Island.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-020",
          "category": "unusual",
          "text": "Silver Spring's Acorn Park contains an acorn-shaped gazebo.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-021",
          "category": "history",
          "text": "Maryland contributed land for the national capital.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-022",
          "category": "landmarks_and_engineering",
          "text": "Glen Echo preserves Clara Barton's former home.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-023",
          "category": "history",
          "text": "Clara Barton's home also served as Red Cross headquarters.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-024",
          "category": "culture",
          "text": "Havre de Grace is associated with carved duck decoys.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-025",
          "category": "landmarks_and_engineering",
          "text": "Swallow Falls State Park contains Muddy Creek Falls.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-026",
          "category": "history",
          "text": "Greenbelt began as an experiment in planned community development.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-027",
          "category": "landmarks_and_engineering",
          "text": "Savage preserves the historic Bollman iron-truss railway bridge.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-028",
          "category": "culture",
          "text": "Frederick's Community Bridge uses painted optical illusions.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-029",
          "category": "history",
          "text": "Baltimore's airport opened as Friendship International in 1950.",
          "source_id": "MD-F"
        },
        {
          "id": "MD-030",
          "category": "landmarks_and_engineering",
          "text": "Frostburg's Thrasher museum preserves horse-drawn vehicles.",
          "source_id": "MD-F"
        }
      ]
    },
    {
      "name": "Massachusetts",
      "code": "MA",
      "facts": [
        {
          "id": "MA-001",
          "category": "geography",
          "text": "Boston serves as Massachusetts's capital.",
          "source_id": "MA-D"
        },
        {
          "id": "MA-002",
          "category": "history",
          "text": "Massachusetts was sixth to ratify the US Constitution.",
          "source_id": "MA-D"
        },
        {
          "id": "MA-003",
          "category": "geography",
          "text": "Mount Greylock is Massachusetts's highest summit.",
          "source_id": "MA-D"
        },
        {
          "id": "MA-004",
          "category": "geography",
          "text": "Massachusetts contains 14 counties.",
          "source_id": "MA-D"
        },
        {
          "id": "MA-005",
          "category": "nature_and_wildlife",
          "text": "The mayflower is Massachusetts's floral emblem.",
          "source_id": "MA-D"
        },
        {
          "id": "MA-006",
          "category": "nature_and_wildlife",
          "text": "The black-capped chickadee is Massachusetts's bird emblem.",
          "source_id": "MA-D"
        },
        {
          "id": "MA-007",
          "category": "nature_and_wildlife",
          "text": "The American elm is Massachusetts's state tree.",
          "source_id": "MA-D"
        },
        {
          "id": "MA-008",
          "category": "nature_and_wildlife",
          "text": "The Atlantic cod is Massachusetts's state fish.",
          "source_id": "MA-D"
        },
        {
          "id": "MA-009",
          "category": "culture",
          "text": "Massachusetts uses the nickname Bay State.",
          "source_id": "MA-D"
        },
        {
          "id": "MA-010",
          "category": "geography",
          "text": "The Charles River flows into Boston Harbor.",
          "source_id": "MA-D"
        },
        {
          "id": "MA-011",
          "category": "sport",
          "text": "Basketball originated in Springfield in 1891.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-012",
          "category": "sport",
          "text": "Volleyball began in Holyoke under the name Mintonette.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-013",
          "category": "people",
          "text": "William G. Morgan created volleyball in 1895.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-014",
          "category": "landmarks_and_engineering",
          "text": "Boston opened America's first subway in 1897.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-015",
          "category": "science_and_invention",
          "text": "Robert Goddard launched a liquid-fuelled rocket in Auburn.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-016",
          "category": "food_and_farming",
          "text": "Boston cream pie is Massachusetts's official dessert.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-017",
          "category": "food_and_farming",
          "text": "The Fig Newton took its name from Newton.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-018",
          "category": "food_and_farming",
          "text": "The first Dunkin' Donuts opened in Quincy.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-019",
          "category": "landmarks_and_engineering",
          "text": "Springfield houses the Basketball Hall of Fame.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-020",
          "category": "history",
          "text": "Harvard was founded in 1636.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-021",
          "category": "landmarks_and_engineering",
          "text": "Boston Common dates to 1634.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-022",
          "category": "landmarks_and_engineering",
          "text": "Boston preserves the warship USS Constitution.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-023",
          "category": "history",
          "text": "Lowell developed as a planned textile-manufacturing city.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-024",
          "category": "geology",
          "text": "Glaciers helped shape Nantucket and Martha's Vineyard.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-025",
          "category": "people",
          "text": "John Adams and John Quincy Adams are buried in Quincy.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-026",
          "category": "landmarks_and_engineering",
          "text": "Salem's House of the Seven Gables inspired Hawthorne's novel.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-027",
          "category": "unusual",
          "text": "Boston Children's Museum has a giant milk-bottle landmark.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-028",
          "category": "geology",
          "text": "Milford became known for its pink granite.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-029",
          "category": "culture",
          "text": "Massachusetts designated an official state polka in 1998.",
          "source_id": "MA-F"
        },
        {
          "id": "MA-030",
          "category": "people",
          "text": "George H.W. Bush was born in Massachusetts's Norfolk County.",
          "source_id": "MA-F"
        }
      ]
    },
    {
      "name": "Michigan",
      "code": "MI",
      "facts": [
        {
          "id": "MI-001",
          "category": "geography",
          "text": "Lansing serves as Michigan's capital.",
          "source_id": "MI-D"
        },
        {
          "id": "MI-002",
          "category": "history",
          "text": "Michigan became the 26th state in 1837.",
          "source_id": "MI-D"
        },
        {
          "id": "MI-003",
          "category": "geography",
          "text": "Mount Arvon is Michigan's highest point.",
          "source_id": "MI-D"
        },
        {
          "id": "MI-004",
          "category": "geography",
          "text": "Michigan contains 83 counties.",
          "source_id": "MI-D"
        },
        {
          "id": "MI-005",
          "category": "nature_and_wildlife",
          "text": "Michigan's floral emblem is the apple blossom.",
          "source_id": "MI-D"
        },
        {
          "id": "MI-006",
          "category": "nature_and_wildlife",
          "text": "The American robin is Michigan's bird emblem.",
          "source_id": "MI-D"
        },
        {
          "id": "MI-007",
          "category": "nature_and_wildlife",
          "text": "Michigan's state tree is the eastern white pine.",
          "source_id": "MI-D"
        },
        {
          "id": "MI-008",
          "category": "nature_and_wildlife",
          "text": "The brook trout is Michigan's state fish.",
          "source_id": "MI-D"
        },
        {
          "id": "MI-009",
          "category": "nature_and_wildlife",
          "text": "Michigan recognises the white-tailed deer as its state animal.",
          "source_id": "MI-D"
        },
        {
          "id": "MI-010",
          "category": "food_and_farming",
          "text": "Cherries are an important Michigan fruit crop.",
          "source_id": "MI-D"
        },
        {
          "id": "MI-011",
          "category": "landmarks_and_engineering",
          "text": "The Mackinac Bridge connects Michigan's two principal peninsulas.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-012",
          "category": "history",
          "text": "The Mackinac Bridge opened in 1957.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-013",
          "category": "geography",
          "text": "Michigan touches four of the five Great Lakes.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-014",
          "category": "unusual",
          "text": "Detroit has a boat-based mail service for passing ships.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-015",
          "category": "geology",
          "text": "Petoskey stone is Michigan's designated state stone.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-016",
          "category": "nature_and_wildlife",
          "text": "The painted turtle is Michigan's reptile emblem.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-017",
          "category": "nature_and_wildlife",
          "text": "The dwarf lake iris is Michigan's state wildflower.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-018",
          "category": "geography",
          "text": "Sleeping Bear Dunes rises beside Lake Michigan.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-019",
          "category": "industry",
          "text": "Detroit became a centre of automobile manufacturing.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-020",
          "category": "food_and_farming",
          "text": "Battle Creek became closely associated with breakfast cereals.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-021",
          "category": "food_and_farming",
          "text": "Vernors ginger ale originated in Detroit.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-022",
          "category": "culture",
          "text": "Colon developed a reputation for manufacturing magicians' supplies.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-023",
          "category": "people",
          "text": "Gerald Ford grew up in Grand Rapids.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-024",
          "category": "sport",
          "text": "Gerald Ford played football at the University of Michigan.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-025",
          "category": "history",
          "text": "The University of Michigan began in Detroit in 1817.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-026",
          "category": "landmarks_and_engineering",
          "text": "Lansing's state capitol building dates to 1879.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-027",
          "category": "landmarks_and_engineering",
          "text": "The Detroit–Windsor tunnel runs beneath the Detroit River.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-028",
          "category": "history",
          "text": "An international railway tunnel opened at Port Huron in 1891.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-029",
          "category": "nature_and_wildlife",
          "text": "Isle Royale supports wild moose.",
          "source_id": "MI-F"
        },
        {
          "id": "MI-030",
          "category": "geology",
          "text": "Michigan's Upper Peninsula has a long copper-mining history.",
          "source_id": "MI-F"
        }
      ]
    },
    {
      "name": "Minnesota",
      "code": "MN",
      "facts": [
        {
          "id": "MN-001",
          "category": "geography",
          "text": "Saint Paul serves as Minnesota's capital.",
          "source_id": "MN-D"
        },
        {
          "id": "MN-002",
          "category": "history",
          "text": "Minnesota became the 32nd state in 1858.",
          "source_id": "MN-D"
        },
        {
          "id": "MN-003",
          "category": "geography",
          "text": "Eagle Mountain is Minnesota's highest summit.",
          "source_id": "MN-D"
        },
        {
          "id": "MN-004",
          "category": "geography",
          "text": "Minnesota contains 87 counties.",
          "source_id": "MN-D"
        },
        {
          "id": "MN-005",
          "category": "nature_and_wildlife",
          "text": "The common loon is Minnesota's bird emblem.",
          "source_id": "MN-D"
        },
        {
          "id": "MN-006",
          "category": "nature_and_wildlife",
          "text": "The pink-and-white lady's slipper is Minnesota's floral emblem.",
          "source_id": "MN-D"
        },
        {
          "id": "MN-007",
          "category": "nature_and_wildlife",
          "text": "Minnesota's state tree is the red pine.",
          "source_id": "MN-D"
        },
        {
          "id": "MN-008",
          "category": "nature_and_wildlife",
          "text": "The walleye is Minnesota's designated state fish.",
          "source_id": "MN-D"
        },
        {
          "id": "MN-009",
          "category": "culture",
          "text": "Minnesota uses the nickname North Star State.",
          "source_id": "MN-D"
        },
        {
          "id": "MN-010",
          "category": "geography",
          "text": "Minnesota shares Lake of the Woods with Canada.",
          "source_id": "MN-D"
        },
        {
          "id": "MN-011",
          "category": "unusual",
          "text": "Saint Paul's early settlement was nicknamed Pig's Eye.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-012",
          "category": "landmarks_and_engineering",
          "text": "Minneapolis's enclosed skyways connect downtown buildings above street level.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-013",
          "category": "landmarks_and_engineering",
          "text": "Rochester houses the Mayo Clinic.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-014",
          "category": "geography",
          "text": "Minnesota drains towards Hudson Bay, the Atlantic and the Gulf.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-015",
          "category": "landmarks_and_engineering",
          "text": "Bloomington contains the Mall of America.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-016",
          "category": "unusual",
          "text": "Darwin displays Francis Johnson's enormous ball of twine.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-017",
          "category": "sport",
          "text": "Ralph Samuelson pioneered water skiing at Lake City in 1922.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-018",
          "category": "history",
          "text": "Edina's Southdale shopping centre opened in 1956.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-019",
          "category": "food_and_farming",
          "text": "Hormel introduced Spam in 1937.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-020",
          "category": "people",
          "text": "Laura Ingalls Wilder lived near Walnut Grove.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-021",
          "category": "industry",
          "text": "Greyhound's origins trace to a Hibbing-area bus service.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-022",
          "category": "unusual",
          "text": "Olivia displays a giant ear-of-corn sculpture.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-023",
          "category": "unusual",
          "text": "Pelican Rapids displays a large pelican sculpture.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-024",
          "category": "culture",
          "text": "Akeley celebrates the fictional lumberjack Paul Bunyan.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-025",
          "category": "history",
          "text": "Moorhead preserves the nineteenth-century Bergquist cabin.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-026",
          "category": "landmarks_and_engineering",
          "text": "The St. Lawrence Seaway gave oceangoing ships access to Duluth.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-027",
          "category": "sport",
          "text": "Minnesota's Olson brothers helped popularise modern inline skating.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-028",
          "category": "food_and_farming",
          "text": "Minnesota's Nordic Ware developed the Bundt baking pan.",
          "source_id": "MN-P"
        },
        {
          "id": "MN-029",
          "category": "industry",
          "text": "Hibbing became associated with open-pit iron mining.",
          "source_id": "MN-F"
        },
        {
          "id": "MN-030",
          "category": "food_and_farming",
          "text": "Madison celebrates the Scandinavian dish lutefisk.",
          "source_id": "MN-F"
        }
      ]
    },
    {
      "name": "Mississippi",
      "code": "MS",
      "facts": [
        {
          "id": "MS-001",
          "category": "geography",
          "text": "Jackson serves as Mississippi's capital.",
          "source_id": "MS-D"
        },
        {
          "id": "MS-002",
          "category": "history",
          "text": "Mississippi became the 20th state in 1817.",
          "source_id": "MS-D"
        },
        {
          "id": "MS-003",
          "category": "geography",
          "text": "Woodall Mountain is Mississippi's highest point.",
          "source_id": "MS-D"
        },
        {
          "id": "MS-004",
          "category": "geography",
          "text": "Mississippi contains 82 counties.",
          "source_id": "MS-D"
        },
        {
          "id": "MS-005",
          "category": "nature_and_wildlife",
          "text": "The magnolia serves as Mississippi's floral emblem.",
          "source_id": "MS-D"
        },
        {
          "id": "MS-006",
          "category": "nature_and_wildlife",
          "text": "Mississippi's state tree is the southern magnolia.",
          "source_id": "MS-D"
        },
        {
          "id": "MS-007",
          "category": "nature_and_wildlife",
          "text": "The northern mockingbird is Mississippi's bird emblem.",
          "source_id": "MS-D"
        },
        {
          "id": "MS-008",
          "category": "nature_and_wildlife",
          "text": "The largemouth bass is Mississippi's state fish.",
          "source_id": "MS-D"
        },
        {
          "id": "MS-009",
          "category": "culture",
          "text": "Mississippi uses the nickname Magnolia State.",
          "source_id": "MS-D"
        },
        {
          "id": "MS-010",
          "category": "geography",
          "text": "The Pearl River flows through Mississippi.",
          "source_id": "MS-D"
        },
        {
          "id": "MS-011",
          "category": "people",
          "text": "Elvis Presley was born in Tupelo in 1935.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-012",
          "category": "history",
          "text": "Roosevelt's 1902 Mississippi bear hunt inspired teddy-bear publicity.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-013",
          "category": "food_and_farming",
          "text": "Barq's root beer began in Biloxi.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-014",
          "category": "people",
          "text": "Composer William Grant Still was born in Woodville.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-015",
          "category": "people",
          "text": "Opera singer Leontyne Price came from Laurel.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-016",
          "category": "people",
          "text": "Mississippi-born Burnita Shelton Matthews became a pioneering federal district judge.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-017",
          "category": "sport",
          "text": "Choctaw stickball remains part of Mississippi cultural celebrations.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-018",
          "category": "culture",
          "text": "The Choctaw Indian Fair takes place near Philadelphia, Mississippi.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-019",
          "category": "nature_and_wildlife",
          "text": "Mississippi sandhill cranes inhabit coastal wet-pine savannas.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-020",
          "category": "food_and_farming",
          "text": "Belzoni is associated with farm-raised catfish.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-021",
          "category": "food_and_farming",
          "text": "Vardaman celebrates sweet potatoes.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-022",
          "category": "industry",
          "text": "Greenville developed a reputation for towboat operations.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-023",
          "category": "industry",
          "text": "Greenwood's historic Cotton Row reflects the cotton trade.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-024",
          "category": "history",
          "text": "French colonists established Natchez in 1716.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-025",
          "category": "landmarks_and_engineering",
          "text": "The Natchez Trace Parkway follows an old travel corridor.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-026",
          "category": "landmarks_and_engineering",
          "text": "Vicksburg contains a national military cemetery.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-027",
          "category": "science_and_invention",
          "text": "Vicksburg became a centre for hydraulic engineering research.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-028",
          "category": "industry",
          "text": "Pascagoula has a major naval shipbuilding industry.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-029",
          "category": "science_and_invention",
          "text": "Harry Cole developed Pine-Sol in Jackson in 1929.",
          "source_id": "MS-F"
        },
        {
          "id": "MS-030",
          "category": "history",
          "text": "Columbus residents decorated both Union and Confederate graves in 1866.",
          "source_id": "MS-F"
        }
      ]
    },
    {
      "name": "Missouri",
      "code": "MO",
      "facts": [
        {
          "id": "MO-001",
          "category": "geography",
          "text": "Jefferson City serves as Missouri's capital.",
          "source_id": "MO-D"
        },
        {
          "id": "MO-002",
          "category": "history",
          "text": "Missouri became the 24th state in 1821.",
          "source_id": "MO-D"
        },
        {
          "id": "MO-003",
          "category": "geography",
          "text": "Taum Sauk Mountain is Missouri's highest point.",
          "source_id": "MO-D"
        },
        {
          "id": "MO-004",
          "category": "geography",
          "text": "Missouri borders eight other states.",
          "source_id": "MO-D"
        },
        {
          "id": "MO-005",
          "category": "nature_and_wildlife",
          "text": "The eastern bluebird is Missouri's bird emblem.",
          "source_id": "MO-D"
        },
        {
          "id": "MO-006",
          "category": "nature_and_wildlife",
          "text": "Hawthorn blossom is Missouri's floral emblem.",
          "source_id": "MO-D"
        },
        {
          "id": "MO-007",
          "category": "nature_and_wildlife",
          "text": "Missouri's official tree is the flowering dogwood.",
          "source_id": "MO-D"
        },
        {
          "id": "MO-008",
          "category": "nature_and_wildlife",
          "text": "The mule is Missouri's state animal.",
          "source_id": "MO-D"
        },
        {
          "id": "MO-009",
          "category": "culture",
          "text": "Missouri uses the nickname Show Me State.",
          "source_id": "MO-D"
        },
        {
          "id": "MO-010",
          "category": "geography",
          "text": "The Osage River feeds the Lake of the Ozarks.",
          "source_id": "MO-D"
        },
        {
          "id": "MO-011",
          "category": "landmarks_and_engineering",
          "text": "St. Louis's Gateway Arch was completed in 1965.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-012",
          "category": "people",
          "text": "Architect Eero Saarinen designed the Gateway Arch.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-013",
          "category": "landmarks_and_engineering",
          "text": "The Gateway Arch reaches 630 feet high.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-014",
          "category": "geology",
          "text": "Strong earthquakes struck the New Madrid region in 1811–1812.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-015",
          "category": "history",
          "text": "St. Charles served as Missouri's temporary capital.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-016",
          "category": "history",
          "text": "Jefferson City became Missouri's permanent capital in 1826.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-017",
          "category": "history",
          "text": "A lightning strike destroyed Missouri's capitol in 1911.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-018",
          "category": "people",
          "text": "President Harry Truman was born in Lamar.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-019",
          "category": "culture",
          "text": "Jefferson City's name honours Thomas Jefferson.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-020",
          "category": "culture",
          "text": "Hermann preserves a strong German winemaking heritage.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-021",
          "category": "history",
          "text": "St. Louis was founded in 1764.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-022",
          "category": "geology",
          "text": "Mozarkite is Missouri's designated state rock.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-023",
          "category": "geology",
          "text": "Galena is Missouri's official state mineral.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-024",
          "category": "geology",
          "text": "Crinoids became Missouri's state fossil following students' campaigning.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-025",
          "category": "nature_and_wildlife",
          "text": "Missouri's insect emblem is the honeybee.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-026",
          "category": "culture",
          "text": "Missouri recognises the fiddle as its musical instrument.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-027",
          "category": "culture",
          "text": "Square dancing is Missouri's official folk dance.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-028",
          "category": "culture",
          "text": "Charleston celebrates a Dogwood-Azalea Festival.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-029",
          "category": "food_and_farming",
          "text": "Nixa's Sucker Days celebrates an often-overlooked freshwater fish.",
          "source_id": "MO-F"
        },
        {
          "id": "MO-030",
          "category": "culture",
          "text": "Lexington has a Madonna of the Trail monument.",
          "source_id": "MO-F"
        }
      ]
    },
    {
      "name": "Montana",
      "code": "MT",
      "facts": [
        {
          "id": "MT-001",
          "category": "geography",
          "text": "Helena serves as Montana's capital.",
          "source_id": "MT-D"
        },
        {
          "id": "MT-002",
          "category": "history",
          "text": "Montana became the 41st state in 1889.",
          "source_id": "MT-D"
        },
        {
          "id": "MT-003",
          "category": "geography",
          "text": "Granite Peak is Montana's highest summit.",
          "source_id": "MT-D"
        },
        {
          "id": "MT-004",
          "category": "geography",
          "text": "Montana contains 56 counties.",
          "source_id": "MT-D"
        },
        {
          "id": "MT-005",
          "category": "nature_and_wildlife",
          "text": "The bitterroot is Montana's floral emblem.",
          "source_id": "MT-D"
        },
        {
          "id": "MT-006",
          "category": "nature_and_wildlife",
          "text": "The western meadowlark is Montana's bird emblem.",
          "source_id": "MT-D"
        },
        {
          "id": "MT-007",
          "category": "nature_and_wildlife",
          "text": "The ponderosa pine is Montana's state tree.",
          "source_id": "MT-D"
        },
        {
          "id": "MT-008",
          "category": "nature_and_wildlife",
          "text": "The grizzly bear is Montana's state animal.",
          "source_id": "MT-D"
        },
        {
          "id": "MT-009",
          "category": "culture",
          "text": "Montana's name derives from Spanish for mountainous.",
          "source_id": "MT-D"
        },
        {
          "id": "MT-010",
          "category": "geography",
          "text": "Montana shares its northern border with Canada.",
          "source_id": "MT-D"
        },
        {
          "id": "MT-011",
          "category": "geography",
          "text": "Triple Divide Peak separates three major drainage systems.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-012",
          "category": "geology",
          "text": "Egg Mountain produced important dinosaur nests and eggs.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-013",
          "category": "landmarks_and_engineering",
          "text": "Bozeman's Museum of the Rockies holds dinosaur fossils.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-014",
          "category": "landmarks_and_engineering",
          "text": "Going-to-the-Sun Road crosses Glacier National Park.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-015",
          "category": "geography",
          "text": "Glacier adjoins Canada's Waterton Lakes National Park.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-016",
          "category": "history",
          "text": "Waterton and Glacier form an International Peace Park.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-017",
          "category": "history",
          "text": "Bannack was Montana's first territorial capital.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-018",
          "category": "landmarks_and_engineering",
          "text": "Bannack survives as a ghost-town state park.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-019",
          "category": "history",
          "text": "Virginia City grew during the 1860s gold rush.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-020",
          "category": "landmarks_and_engineering",
          "text": "Great Falls houses a museum devoted to Charles M. Russell.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-021",
          "category": "history",
          "text": "Little Bighorn Battlefield commemorates an 1876 battle.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-022",
          "category": "nature_and_wildlife",
          "text": "Freezeout Lake attracts migrating snow geese and tundra swans.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-023",
          "category": "nature_and_wildlife",
          "text": "Medicine Lake attracts migrating white pelicans.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-024",
          "category": "geography",
          "text": "Flathead Lake is a large natural freshwater lake.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-025",
          "category": "geography",
          "text": "The short Roe River flows near Great Falls.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-026",
          "category": "culture",
          "text": "Treasure State recalls Montana's mining heritage.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-027",
          "category": "culture",
          "text": "Montana's Spanish motto refers to gold and silver.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-028",
          "category": "culture",
          "text": "Miles City is associated with cowboy traditions.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-029",
          "category": "nature_and_wildlife",
          "text": "Bowdoin National Wildlife Refuge supports nesting pelicans.",
          "source_id": "MT-F"
        },
        {
          "id": "MT-030",
          "category": "geography",
          "text": "The Yaak Valley occupies Montana's far northwestern corner.",
          "source_id": "MT-F"
        }
      ]
    },
    {
      "name": "Nebraska",
      "code": "NE",
      "facts": [
        {
          "id": "NE-001",
          "category": "geography",
          "text": "Lincoln serves as Nebraska's capital.",
          "source_id": "NE-D"
        },
        {
          "id": "NE-002",
          "category": "history",
          "text": "Nebraska became the 37th state in 1867.",
          "source_id": "NE-D"
        },
        {
          "id": "NE-003",
          "category": "geography",
          "text": "Panorama Point is Nebraska's highest point.",
          "source_id": "NE-D"
        },
        {
          "id": "NE-004",
          "category": "geography",
          "text": "Nebraska contains 93 counties.",
          "source_id": "NE-D"
        },
        {
          "id": "NE-005",
          "category": "nature_and_wildlife",
          "text": "Goldenrod is Nebraska's floral emblem.",
          "source_id": "NE-D"
        },
        {
          "id": "NE-006",
          "category": "nature_and_wildlife",
          "text": "The western meadowlark is Nebraska's bird emblem.",
          "source_id": "NE-D"
        },
        {
          "id": "NE-007",
          "category": "nature_and_wildlife",
          "text": "The eastern cottonwood is Nebraska's state tree.",
          "source_id": "NE-D"
        },
        {
          "id": "NE-008",
          "category": "nature_and_wildlife",
          "text": "The channel catfish is Nebraska's designated fish.",
          "source_id": "NE-D"
        },
        {
          "id": "NE-009",
          "category": "nature_and_wildlife",
          "text": "The white-tailed deer is Nebraska's state animal.",
          "source_id": "NE-D"
        },
        {
          "id": "NE-010",
          "category": "culture",
          "text": "Nebraska's name refers to flat water.",
          "source_id": "NE-D"
        },
        {
          "id": "NE-011",
          "category": "government",
          "text": "Nebraska's legislature has one chamber rather than two.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-012",
          "category": "food_and_farming",
          "text": "Edwin Perkins developed Kool-Aid in Hastings in 1927.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-013",
          "category": "history",
          "text": "Arbor Day began in Nebraska in 1872.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-014",
          "category": "people",
          "text": "J. Sterling Morton promoted the first Arbor Day.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-015",
          "category": "landmarks_and_engineering",
          "text": "North Platte contains Union Pacific's large Bailey railway yard.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-016",
          "category": "landmarks_and_engineering",
          "text": "Chimney Rock guided travellers on the Oregon Trail.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-017",
          "category": "unusual",
          "text": "Hebron displays an oversized porch swing.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-018",
          "category": "nature_and_wildlife",
          "text": "Omaha's zoo contains the indoor Lied Jungle.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-019",
          "category": "geography",
          "text": "The Ogallala Aquifer lies beneath much of Nebraska.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-020",
          "category": "history",
          "text": "The Halsey area contains extensive hand-planted forest.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-021",
          "category": "culture",
          "text": "Cornhusker State replaced Tree Planters' State as Nebraska's nickname.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-022",
          "category": "geology",
          "text": "Blue agate is Nebraska's state gemstone.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-023",
          "category": "nature_and_wildlife",
          "text": "Nebraska's insect emblem is the honeybee.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-024",
          "category": "geography",
          "text": "Cozad lies on the 100th meridian.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-025",
          "category": "sport",
          "text": "Omaha began hosting the College World Series in 1950.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-026",
          "category": "people",
          "text": "Father Edward Flanagan founded Boys Town in 1917.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-027",
          "category": "culture",
          "text": "Nebraska has counties named Antelope and Buffalo.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-028",
          "category": "landmarks_and_engineering",
          "text": "Grand Island's Stuhr Museum was designed by Edward Durell Stone.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-029",
          "category": "history",
          "text": "Buffalo Bill staged a North Platte rodeo in 1882.",
          "source_id": "NE-F"
        },
        {
          "id": "NE-030",
          "category": "culture",
          "text": "Prague, Nebraska celebrates the Czech pastry kolache.",
          "source_id": "NE-F"
        }
      ]
    },
    {
      "name": "Nevada",
      "code": "NV",
      "facts": [
        {
          "id": "NV-001",
          "category": "geography",
          "text": "Carson City serves as Nevada's capital.",
          "source_id": "NV-D"
        },
        {
          "id": "NV-002",
          "category": "history",
          "text": "Nevada became the 36th state on Halloween in 1864.",
          "source_id": "NV-D"
        },
        {
          "id": "NV-003",
          "category": "geography",
          "text": "Boundary Peak is Nevada's highest summit.",
          "source_id": "NV-D"
        },
        {
          "id": "NV-004",
          "category": "geography",
          "text": "Nevada borders five other states.",
          "source_id": "NV-D"
        },
        {
          "id": "NV-005",
          "category": "nature_and_wildlife",
          "text": "Sagebrush is Nevada's floral emblem.",
          "source_id": "NV-D"
        },
        {
          "id": "NV-006",
          "category": "nature_and_wildlife",
          "text": "The mountain bluebird is Nevada's bird emblem.",
          "source_id": "NV-D"
        },
        {
          "id": "NV-007",
          "category": "nature_and_wildlife",
          "text": "The desert bighorn sheep is Nevada's state animal.",
          "source_id": "NV-D"
        },
        {
          "id": "NV-008",
          "category": "nature_and_wildlife",
          "text": "The Lahontan cutthroat trout is Nevada's designated fish.",
          "source_id": "NV-D"
        },
        {
          "id": "NV-009",
          "category": "culture",
          "text": "Nevada's name comes from Spanish for snow-covered.",
          "source_id": "NV-D"
        },
        {
          "id": "NV-010",
          "category": "geography",
          "text": "Nevada shares Lake Tahoe with California.",
          "source_id": "NV-D"
        },
        {
          "id": "NV-011",
          "category": "culture",
          "text": "Silver State reflects Nevada's mining history.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-012",
          "category": "geography",
          "text": "Nevada's desert scenery also includes snowy mountain ranges.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-013",
          "category": "history",
          "text": "Mark Twain used his famous pen name while reporting in Nevada.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-014",
          "category": "history",
          "text": "Samuel Clemens worked for Virginia City's Territorial Enterprise.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-015",
          "category": "culture",
          "text": "Elko hosts a National Cowboy Poetry Gathering.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-016",
          "category": "unusual",
          "text": "Nevada's State Route 375 is nicknamed the Extraterrestrial Highway.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-017",
          "category": "landmarks_and_engineering",
          "text": "Rhyolite preserves ruins of a former mining town.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-018",
          "category": "geology",
          "text": "Berlin-Ichthyosaur State Park protects ancient marine-reptile fossils.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-019",
          "category": "geology",
          "text": "The ichthyosaur is Nevada's designated state fossil.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-020",
          "category": "landmarks_and_engineering",
          "text": "Hoover Dam harnesses the Colorado River.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-021",
          "category": "landmarks_and_engineering",
          "text": "Pershing County's courthouse has an unusual circular design.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-022",
          "category": "culture",
          "text": "Life magazine popularised Highway 50's Loneliest Road label.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-023",
          "category": "history",
          "text": "Pack camels once transported goods through Nevada.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-024",
          "category": "history",
          "text": "Nevada's constitution was telegraphed to Washington in 1864.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-025",
          "category": "nature_and_wildlife",
          "text": "Nevada recognises both single-leaf pinyon and bristlecone pine as state trees.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-026",
          "category": "culture",
          "text": "Shoshone, Paiute and Washoe peoples have Nevada homelands.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-027",
          "category": "geography",
          "text": "The Las Vegas Strip lies outside Las Vegas city limits.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-028",
          "category": "geography",
          "text": "Reno lies west of Los Angeles.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-029",
          "category": "history",
          "text": "Howard Hughes invested heavily in Nevada hotels and casinos.",
          "source_id": "NV-F"
        },
        {
          "id": "NV-030",
          "category": "culture",
          "text": "Home Means Nevada is the state's official song.",
          "source_id": "NV-F"
        }
      ]
    },
    {
      "name": "New Hampshire",
      "code": "NH",
      "facts": [
        {
          "id": "NH-001",
          "category": "geography",
          "text": "Concord serves as New Hampshire's capital.",
          "source_id": "NH-D"
        },
        {
          "id": "NH-002",
          "category": "history",
          "text": "New Hampshire was ninth to ratify the US Constitution.",
          "source_id": "NH-D"
        },
        {
          "id": "NH-003",
          "category": "geography",
          "text": "Mount Washington is New Hampshire's highest summit.",
          "source_id": "NH-D"
        },
        {
          "id": "NH-004",
          "category": "geography",
          "text": "New Hampshire contains ten counties.",
          "source_id": "NH-D"
        },
        {
          "id": "NH-005",
          "category": "nature_and_wildlife",
          "text": "Purple lilac is New Hampshire's floral emblem.",
          "source_id": "NH-D"
        },
        {
          "id": "NH-006",
          "category": "nature_and_wildlife",
          "text": "The purple finch is New Hampshire's bird emblem.",
          "source_id": "NH-D"
        },
        {
          "id": "NH-007",
          "category": "nature_and_wildlife",
          "text": "Paper birch is New Hampshire's state tree.",
          "source_id": "NH-D"
        },
        {
          "id": "NH-008",
          "category": "nature_and_wildlife",
          "text": "Brook trout is New Hampshire's freshwater fish emblem.",
          "source_id": "NH-D"
        },
        {
          "id": "NH-009",
          "category": "nature_and_wildlife",
          "text": "Striped bass is New Hampshire's saltwater fish emblem.",
          "source_id": "NH-D"
        },
        {
          "id": "NH-010",
          "category": "geography",
          "text": "New Hampshire has a short Atlantic coastline.",
          "source_id": "NH-D"
        },
        {
          "id": "NH-011",
          "category": "science_and_invention",
          "text": "Mount Washington recorded an extraordinary wind gust in 1934.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-012",
          "category": "people",
          "text": "Alan Shepard, the first American in space, came from Derry.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-013",
          "category": "people",
          "text": "Sculptor Augustus Saint-Gaudens lived and worked in Cornish.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-014",
          "category": "people",
          "text": "Sarah Josepha Hale came from Newport.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-015",
          "category": "culture",
          "text": "Hale wrote the poem Mary Had a Little Lamb.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-016",
          "category": "landmarks_and_engineering",
          "text": "Concord preserves Franklin Pierce's home, the Pierce Manse.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-017",
          "category": "history",
          "text": "Dover's colonial settlement dates to 1623.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-018",
          "category": "history",
          "text": "The state's constitution dates to 1784.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-019",
          "category": "history",
          "text": "Dover mill workers staged a strike in 1828.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-020",
          "category": "landmarks_and_engineering",
          "text": "The State House retains its original legislative chambers.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-021",
          "category": "culture",
          "text": "Granite State recalls New Hampshire's quarrying industry.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-022",
          "category": "landmarks_and_engineering",
          "text": "The Mount Washington Auto Road climbs to the summit.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-023",
          "category": "landmarks_and_engineering",
          "text": "A Stanley steam car climbed Mount Washington in 1899.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-024",
          "category": "history",
          "text": "Peterborough established a tax-supported public library in 1833.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-025",
          "category": "landmarks_and_engineering",
          "text": "Enfield preserves a former Shaker community.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-026",
          "category": "landmarks_and_engineering",
          "text": "Laconia's historic Belknap Mill dates to 1823.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-027",
          "category": "landmarks_and_engineering",
          "text": "Cannon Mountain's aerial tramway opened in 1938.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-028",
          "category": "unusual",
          "text": "Lake Winnipesaukee has a tradition of boat-delivered mail.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-029",
          "category": "landmarks_and_engineering",
          "text": "Concord's planetarium honours teacher-astronaut Christa McAuliffe.",
          "source_id": "NH-F"
        },
        {
          "id": "NH-030",
          "category": "geography",
          "text": "New Castle occupies islands near the Piscataqua River's mouth.",
          "source_id": "NH-F"
        }
      ]
    },
    {
      "name": "New Jersey",
      "code": "NJ",
      "facts": [
        {
          "id": "NJ-001",
          "category": "geography",
          "text": "Trenton serves as New Jersey's capital.",
          "source_id": "NJ-D"
        },
        {
          "id": "NJ-002",
          "category": "history",
          "text": "New Jersey was third to ratify the US Constitution.",
          "source_id": "NJ-D"
        },
        {
          "id": "NJ-003",
          "category": "geography",
          "text": "High Point is New Jersey's highest natural point.",
          "source_id": "NJ-D"
        },
        {
          "id": "NJ-004",
          "category": "geography",
          "text": "New Jersey contains 21 counties.",
          "source_id": "NJ-D"
        },
        {
          "id": "NJ-005",
          "category": "nature_and_wildlife",
          "text": "The violet is New Jersey's floral emblem.",
          "source_id": "NJ-D"
        },
        {
          "id": "NJ-006",
          "category": "nature_and_wildlife",
          "text": "The American goldfinch is New Jersey's bird emblem.",
          "source_id": "NJ-D"
        },
        {
          "id": "NJ-007",
          "category": "nature_and_wildlife",
          "text": "The northern red oak is New Jersey's state tree.",
          "source_id": "NJ-D"
        },
        {
          "id": "NJ-008",
          "category": "nature_and_wildlife",
          "text": "The brook trout is New Jersey's designated fish.",
          "source_id": "NJ-D"
        },
        {
          "id": "NJ-009",
          "category": "nature_and_wildlife",
          "text": "The horse is New Jersey's state animal.",
          "source_id": "NJ-D"
        },
        {
          "id": "NJ-010",
          "category": "culture",
          "text": "New Jersey's name honours the Channel Island of Jersey.",
          "source_id": "NJ-D"
        },
        {
          "id": "NJ-011",
          "category": "culture",
          "text": "Atlantic City supplied street names for the classic American Monopoly board.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-012",
          "category": "science_and_invention",
          "text": "Thomas Edison developed his phonograph at Menlo Park.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-013",
          "category": "culture",
          "text": "Edison's work earned him the Wizard of Menlo Park nickname.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-014",
          "category": "sport",
          "text": "Rutgers and Princeton played an early college football game in 1869.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-015",
          "category": "landmarks_and_engineering",
          "text": "John Roebling established a wire-rope factory in Trenton.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-016",
          "category": "geology",
          "text": "Haddonfield yielded an important Hadrosaurus skeleton in 1858.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-017",
          "category": "geology",
          "text": "Hadrosaurus is New Jersey's state dinosaur.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-018",
          "category": "nature_and_wildlife",
          "text": "The knobbed whelk is New Jersey's state seashell.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-019",
          "category": "nature_and_wildlife",
          "text": "New Jersey's insect emblem is the honeybee.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-020",
          "category": "people",
          "text": "Frank Sinatra was born in New Jersey.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-021",
          "category": "people",
          "text": "Bruce Springsteen is a New Jersey native.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-022",
          "category": "people",
          "text": "Whitney Houston was born in New Jersey.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-023",
          "category": "people",
          "text": "Writer Judy Blume was born in New Jersey.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-024",
          "category": "people",
          "text": "President Grover Cleveland was born in New Jersey.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-025",
          "category": "culture",
          "text": "New Jersey is well known for roadside diners.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-026",
          "category": "landmarks_and_engineering",
          "text": "Cape May preserves historic seaside-resort architecture.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-027",
          "category": "landmarks_and_engineering",
          "text": "Atlantic City is known for its oceanfront boardwalk.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-028",
          "category": "culture",
          "text": "New Jersey uses the nickname Garden State.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-029",
          "category": "history",
          "text": "Pierre Eugène du Simitière designed New Jersey's seal.",
          "source_id": "NJ-F"
        },
        {
          "id": "NJ-030",
          "category": "landmarks_and_engineering",
          "text": "Submarine pioneer John Holland tested craft in the Passaic River.",
          "source_id": "NJ-F"
        }
      ]
    },
    {
      "name": "New Mexico",
      "code": "NM",
      "facts": [
        {
          "id": "NM-001",
          "category": "geography",
          "text": "Santa Fe serves as New Mexico's capital.",
          "source_id": "NM-D"
        },
        {
          "id": "NM-002",
          "category": "history",
          "text": "New Mexico became the 47th state in 1912.",
          "source_id": "NM-D"
        },
        {
          "id": "NM-003",
          "category": "geography",
          "text": "Wheeler Peak is New Mexico's highest summit.",
          "source_id": "NM-D"
        },
        {
          "id": "NM-004",
          "category": "geography",
          "text": "New Mexico contains 33 counties.",
          "source_id": "NM-D"
        },
        {
          "id": "NM-005",
          "category": "nature_and_wildlife",
          "text": "The yucca flower is New Mexico's floral emblem.",
          "source_id": "NM-D"
        },
        {
          "id": "NM-006",
          "category": "nature_and_wildlife",
          "text": "The greater roadrunner is New Mexico's bird emblem.",
          "source_id": "NM-D"
        },
        {
          "id": "NM-007",
          "category": "nature_and_wildlife",
          "text": "The piñon pine is New Mexico's state tree.",
          "source_id": "NM-D"
        },
        {
          "id": "NM-008",
          "category": "nature_and_wildlife",
          "text": "The black bear is New Mexico's state animal.",
          "source_id": "NM-D"
        },
        {
          "id": "NM-009",
          "category": "food_and_farming",
          "text": "New Mexico recognises the biscochito as its official cookie.",
          "source_id": "NM-D"
        },
        {
          "id": "NM-010",
          "category": "geography",
          "text": "New Mexico shares an international border with Mexico.",
          "source_id": "NM-D"
        },
        {
          "id": "NM-011",
          "category": "geology",
          "text": "White Sands consists of gypsum sand dunes.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-012",
          "category": "geography",
          "text": "Santa Fe is America's highest-elevation state capital.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-013",
          "category": "unusual",
          "text": "Truth or Consequences renamed itself after a radio programme.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-014",
          "category": "history",
          "text": "The city's earlier name was Hot Springs.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-015",
          "category": "nature_and_wildlife",
          "text": "The living Smokey Bear was rescued from a New Mexico wildfire.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-016",
          "category": "culture",
          "text": "Albuquerque hosts a major international hot-air-balloon fiesta.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-017",
          "category": "food_and_farming",
          "text": "Hatch is associated with green chile peppers.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-018",
          "category": "culture",
          "text": "Deming hosts duck races.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-019",
          "category": "landmarks_and_engineering",
          "text": "The Palace of the Governors dates to 1610.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-020",
          "category": "history",
          "text": "Taos Pueblo is a long-inhabited Indigenous community.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-021",
          "category": "nature_and_wildlife",
          "text": "Carlsbad Caverns shelters large colonies of bats.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-022",
          "category": "science_and_invention",
          "text": "The first atomic-bomb test occurred at Trinity in 1945.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-023",
          "category": "science_and_invention",
          "text": "Los Alamos was central to developing the atomic bomb.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-024",
          "category": "science_and_invention",
          "text": "Robert Goddard tested rockets in New Mexico.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-025",
          "category": "landmarks_and_engineering",
          "text": "Santa Fe Opera performs in a partly open-air theatre.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-026",
          "category": "geography",
          "text": "Elephant Butte Reservoir was created by damming the Rio Grande.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-027",
          "category": "culture",
          "text": "New Mexico uses the nickname Land of Enchantment.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-028",
          "category": "history",
          "text": "Territorial governor Lew Wallace worked on Ben-Hur in New Mexico.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-029",
          "category": "history",
          "text": "Albuquerque's Spanish colonial founding dates to 1706.",
          "source_id": "NM-F"
        },
        {
          "id": "NM-030",
          "category": "geography",
          "text": "The Santa Fe Trail ended at Santa Fe.",
          "source_id": "NM-F"
        }
      ]
    },
    {
      "name": "New York",
      "code": "NY",
      "facts": [
        {
          "id": "NY-001",
          "category": "geography",
          "text": "Albany serves as New York's capital.",
          "source_id": "NY-D"
        },
        {
          "id": "NY-002",
          "category": "history",
          "text": "New York was eleventh to ratify the US Constitution.",
          "source_id": "NY-D"
        },
        {
          "id": "NY-003",
          "category": "geography",
          "text": "Mount Marcy is New York's highest summit.",
          "source_id": "NY-D"
        },
        {
          "id": "NY-004",
          "category": "nature_and_wildlife",
          "text": "The rose is New York's floral emblem.",
          "source_id": "NY-D"
        },
        {
          "id": "NY-005",
          "category": "nature_and_wildlife",
          "text": "The eastern bluebird is New York's bird emblem.",
          "source_id": "NY-D"
        },
        {
          "id": "NY-006",
          "category": "nature_and_wildlife",
          "text": "Sugar maple is New York's state tree.",
          "source_id": "NY-D"
        },
        {
          "id": "NY-007",
          "category": "nature_and_wildlife",
          "text": "The beaver is New York's state animal.",
          "source_id": "NY-D"
        },
        {
          "id": "NY-008",
          "category": "nature_and_wildlife",
          "text": "Brook trout is New York's freshwater fish emblem.",
          "source_id": "NY-D"
        },
        {
          "id": "NY-009",
          "category": "culture",
          "text": "New York's name honours the Duke of York.",
          "source_id": "NY-D"
        },
        {
          "id": "NY-010",
          "category": "geography",
          "text": "New York borders both Lake Erie and Lake Ontario.",
          "source_id": "NY-D"
        },
        {
          "id": "NY-011",
          "category": "unusual",
          "text": "The 1969 Woodstock festival took place in Bethel.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-012",
          "category": "history",
          "text": "George Washington took his first presidential oath in New York City.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-013",
          "category": "landmarks_and_engineering",
          "text": "Federal Hall marks Washington's inauguration site.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-014",
          "category": "landmarks_and_engineering",
          "text": "The Erie Canal linked the Hudson River with the Great Lakes.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-015",
          "category": "history",
          "text": "A B-25 bomber struck the Empire State Building in 1945.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-016",
          "category": "culture",
          "text": "Chittenango celebrates local author L. Frank Baum and Oz.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-017",
          "category": "unusual",
          "text": "Hartsdale established a pet cemetery in 1896.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-018",
          "category": "culture",
          "text": "The Catskills provide the setting for Rip Van Winkle.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-019",
          "category": "geography",
          "text": "The Genesee River flows north towards Lake Ontario.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-020",
          "category": "nature_and_wildlife",
          "text": "Wild orchids grow in New York State.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-021",
          "category": "geography",
          "text": "Taughannock Falls has a single drop exceeding 200 feet.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-022",
          "category": "culture",
          "text": "Rochester uses both Flour City and Flower City nicknames.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-023",
          "category": "history",
          "text": "Brewer Matthew Vassar founded Vassar College in 1861.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-024",
          "category": "landmarks_and_engineering",
          "text": "Robert Fulton's steamboat travelled to Albany in 1807.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-025",
          "category": "culture",
          "text": "New York uses the nickname Empire State.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-026",
          "category": "landmarks_and_engineering",
          "text": "Newburgh preserves George Washington's wartime headquarters.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-027",
          "category": "landmarks_and_engineering",
          "text": "Adirondack Park covers a vast area of northern New York.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-028",
          "category": "culture",
          "text": "Union College is associated with early American college fraternities.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-029",
          "category": "people",
          "text": "Troy meatpacker Samuel Wilson is linked to Uncle Sam's identity.",
          "source_id": "NY-F"
        },
        {
          "id": "NY-030",
          "category": "unusual",
          "text": "A home near Rochester was designed to resemble mushrooms.",
          "source_id": "NY-F"
        }
      ]
    },
    {
      "name": "North Carolina",
      "code": "NC",
      "facts": [
        {
          "id": "NC-001",
          "category": "geography",
          "text": "Raleigh serves as North Carolina's capital.",
          "source_id": "NC-D"
        },
        {
          "id": "NC-002",
          "category": "history",
          "text": "North Carolina became the 12th state in 1789.",
          "source_id": "NC-D"
        },
        {
          "id": "NC-003",
          "category": "geography",
          "text": "North Carolina contains 100 counties.",
          "source_id": "NC-D"
        },
        {
          "id": "NC-004",
          "category": "nature_and_wildlife",
          "text": "Flowering dogwood is North Carolina's floral emblem.",
          "source_id": "NC-D"
        },
        {
          "id": "NC-005",
          "category": "nature_and_wildlife",
          "text": "The northern cardinal is North Carolina's bird emblem.",
          "source_id": "NC-D"
        },
        {
          "id": "NC-006",
          "category": "nature_and_wildlife",
          "text": "The pine is North Carolina's state tree.",
          "source_id": "NC-D"
        },
        {
          "id": "NC-007",
          "category": "nature_and_wildlife",
          "text": "The eastern grey squirrel is North Carolina's state mammal.",
          "source_id": "NC-D"
        },
        {
          "id": "NC-008",
          "category": "nature_and_wildlife",
          "text": "The Plott hound is North Carolina's official dog.",
          "source_id": "NC-D"
        },
        {
          "id": "NC-009",
          "category": "nature_and_wildlife",
          "text": "Channel bass is North Carolina's saltwater fish emblem.",
          "source_id": "NC-D"
        },
        {
          "id": "NC-010",
          "category": "geography",
          "text": "Pamlico Sound lies behind North Carolina's Outer Banks.",
          "source_id": "NC-D"
        },
        {
          "id": "NC-011",
          "category": "science_and_invention",
          "text": "The Wright brothers achieved powered flight near Kitty Hawk in 1903.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-012",
          "category": "landmarks_and_engineering",
          "text": "Cape Hatteras Lighthouse was relocated to escape shoreline erosion.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-013",
          "category": "geography",
          "text": "Mount Mitchell is the highest summit east of the Mississippi.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-014",
          "category": "nature_and_wildlife",
          "text": "Venus flytraps grow naturally in coastal North Carolina.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-015",
          "category": "food_and_farming",
          "text": "Pepsi originated in New Bern.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-016",
          "category": "food_and_farming",
          "text": "Krispy Kreme began in Winston-Salem.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-017",
          "category": "industry",
          "text": "High Point became associated with furniture manufacturing.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-018",
          "category": "landmarks_and_engineering",
          "text": "Wilmington preserves the battleship USS North Carolina.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-019",
          "category": "history",
          "text": "Schoolchildren helped fund the battleship's preservation.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-020",
          "category": "history",
          "text": "Winston-Salem formed by joining Winston and Salem.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-021",
          "category": "landmarks_and_engineering",
          "text": "Asheville contains the vast Biltmore estate.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-022",
          "category": "landmarks_and_engineering",
          "text": "Grandfather Mountain has a Mile High Swinging Bridge.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-023",
          "category": "history",
          "text": "Bath incorporated in 1705.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-024",
          "category": "people",
          "text": "President James K. Polk was born in Mecklenburg County.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-025",
          "category": "people",
          "text": "Andrew Johnson worked as a tailor's apprentice in Raleigh.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-026",
          "category": "people",
          "text": "Hiram Revels, the first Black US senator, was born in Fayetteville.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-027",
          "category": "culture",
          "text": "New Bern's name refers to Bern, Switzerland.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-028",
          "category": "food_and_farming",
          "text": "Students campaigned to make sweet potato the state vegetable.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-029",
          "category": "culture",
          "text": "Harkers Island hosts a decoy-carving festival.",
          "source_id": "NC-F"
        },
        {
          "id": "NC-030",
          "category": "food_and_farming",
          "text": "Morehead City hosts the North Carolina Seafood Festival.",
          "source_id": "NC-F"
        }
      ]
    },
    {
      "name": "North Dakota",
      "code": "ND",
      "facts": [
        {
          "id": "ND-001",
          "category": "geography",
          "text": "Bismarck serves as North Dakota's capital.",
          "source_id": "ND-D"
        },
        {
          "id": "ND-002",
          "category": "history",
          "text": "North Dakota gained statehood on 2 November 1889.",
          "source_id": "ND-D"
        },
        {
          "id": "ND-003",
          "category": "geography",
          "text": "White Butte is North Dakota's highest point.",
          "source_id": "ND-D"
        },
        {
          "id": "ND-004",
          "category": "geography",
          "text": "North Dakota contains 53 counties.",
          "source_id": "ND-D"
        },
        {
          "id": "ND-005",
          "category": "nature_and_wildlife",
          "text": "The wild prairie rose is North Dakota's floral emblem.",
          "source_id": "ND-D"
        },
        {
          "id": "ND-006",
          "category": "nature_and_wildlife",
          "text": "The western meadowlark is North Dakota's bird emblem.",
          "source_id": "ND-D"
        },
        {
          "id": "ND-007",
          "category": "nature_and_wildlife",
          "text": "The American elm is North Dakota's state tree.",
          "source_id": "ND-D"
        },
        {
          "id": "ND-008",
          "category": "nature_and_wildlife",
          "text": "Northern pike is North Dakota's designated state fish.",
          "source_id": "ND-D"
        },
        {
          "id": "ND-009",
          "category": "nature_and_wildlife",
          "text": "The Nokota is North Dakota's honorary equine.",
          "source_id": "ND-D"
        },
        {
          "id": "ND-010",
          "category": "geography",
          "text": "North Dakota borders Canada and three US states.",
          "source_id": "ND-D"
        },
        {
          "id": "ND-011",
          "category": "landmarks_and_engineering",
          "text": "The International Peace Garden straddles the Canadian border.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-012",
          "category": "unusual",
          "text": "Jamestown displays a gigantic bison sculpture.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-013",
          "category": "unusual",
          "text": "Turtle Lake celebrates turtles with racing and a statue.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-014",
          "category": "history",
          "text": "Theodore Roosevelt ranched in Dakota Territory.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-015",
          "category": "history",
          "text": "Roosevelt's ranches included Maltese Cross and Elkhorn.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-016",
          "category": "culture",
          "text": "Minot's rapid early growth inspired its Magic City nickname.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-017",
          "category": "culture",
          "text": "New Leipzig celebrates German heritage with Oktoberfest.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-018",
          "category": "people",
          "text": "Bandleader Lawrence Welk came from Strasburg.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-019",
          "category": "landmarks_and_engineering",
          "text": "Garrison Dam created Lake Sakakawea.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-020",
          "category": "geography",
          "text": "Devils Lake is North Dakota's largest natural lake.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-021",
          "category": "geology",
          "text": "Hillsboro occupies land once covered by a glacial lake.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-022",
          "category": "history",
          "text": "Knife River preserves former Hidatsa earth-lodge village sites.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-023",
          "category": "landmarks_and_engineering",
          "text": "Writing Rock preserves petroglyphs carved on granite boulders.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-024",
          "category": "culture",
          "text": "Flickertail refers to local Richardson's ground squirrels.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-025",
          "category": "history",
          "text": "Fort Union was an important Upper Missouri fur-trading post.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-026",
          "category": "culture",
          "text": "New Rockford hosts a steam-threshing reunion.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-027",
          "category": "landmarks_and_engineering",
          "text": "Parshall houses the Paul Broste Rock Museum.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-028",
          "category": "history",
          "text": "Medora preserves the Château de Morès.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-029",
          "category": "landmarks_and_engineering",
          "text": "Bismarck has a statue of Sakakawea carrying her son.",
          "source_id": "ND-F"
        },
        {
          "id": "ND-030",
          "category": "culture",
          "text": "North Dakota adopted Peace Garden State as a nickname in 1957.",
          "source_id": "ND-F"
        }
      ]
    },
    {
      "name": "Ohio",
      "code": "OH",
      "facts": [
        {
          "id": "OH-001",
          "category": "geography",
          "text": "Columbus serves as Ohio's capital.",
          "source_id": "OH-D"
        },
        {
          "id": "OH-002",
          "category": "history",
          "text": "Ohio became the 17th state in 1803.",
          "source_id": "OH-D"
        },
        {
          "id": "OH-003",
          "category": "geography",
          "text": "Campbell Hill is Ohio's highest point.",
          "source_id": "OH-D"
        },
        {
          "id": "OH-004",
          "category": "geography",
          "text": "Ohio contains 88 counties.",
          "source_id": "OH-D"
        },
        {
          "id": "OH-005",
          "category": "nature_and_wildlife",
          "text": "The scarlet carnation is Ohio's floral emblem.",
          "source_id": "OH-D"
        },
        {
          "id": "OH-006",
          "category": "nature_and_wildlife",
          "text": "The northern cardinal is Ohio's bird emblem.",
          "source_id": "OH-D"
        },
        {
          "id": "OH-007",
          "category": "nature_and_wildlife",
          "text": "The Ohio buckeye is Ohio's state tree.",
          "source_id": "OH-D"
        },
        {
          "id": "OH-008",
          "category": "nature_and_wildlife",
          "text": "The white-tailed deer is Ohio's state animal.",
          "source_id": "OH-D"
        },
        {
          "id": "OH-009",
          "category": "geography",
          "text": "Ohio's northern coast faces Lake Erie.",
          "source_id": "OH-D"
        },
        {
          "id": "OH-010",
          "category": "geography",
          "text": "The Cuyahoga River flows through northeastern Ohio.",
          "source_id": "OH-D"
        },
        {
          "id": "OH-011",
          "category": "unusual",
          "text": "Ohio's state flag has a distinctive swallowtail shape.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-012",
          "category": "landmarks_and_engineering",
          "text": "Cleveland houses the Rock & Roll Hall of Fame.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-013",
          "category": "sport",
          "text": "Canton houses the Pro Football Hall of Fame.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-014",
          "category": "people",
          "text": "Neil Armstrong came from Wapakoneta.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-015",
          "category": "science_and_invention",
          "text": "Ohio-born John Glenn became the first American to orbit Earth.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-016",
          "category": "science_and_invention",
          "text": "John Glenn returned to space at age 77 in 1998.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-017",
          "category": "science_and_invention",
          "text": "The Wright brothers developed aircraft in Dayton.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-018",
          "category": "industry",
          "text": "Akron became associated with tyre and rubber manufacturing.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-019",
          "category": "landmarks_and_engineering",
          "text": "Zanesville has an unusual Y-shaped bridge.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-020",
          "category": "geology",
          "text": "Kelleys Island preserves grooves carved by moving glaciers.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-021",
          "category": "science_and_invention",
          "text": "Dayton's James Ritty developed a cash register.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-022",
          "category": "science_and_invention",
          "text": "Kettering inventor Ermal Fraze developed the pull-tab can opening.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-023",
          "category": "people",
          "text": "Thomas Edison was born in Milan, Ohio.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-024",
          "category": "people",
          "text": "Poet Paul Laurence Dunbar came from Dayton.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-025",
          "category": "sport",
          "text": "Jesse Owens grew up in Cleveland.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-026",
          "category": "history",
          "text": "Chillicothe served as Ohio's first state capital.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-027",
          "category": "history",
          "text": "Ohio University was founded in Athens in 1804.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-028",
          "category": "history",
          "text": "Oberlin College was founded in 1833.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-029",
          "category": "history",
          "text": "Marietta's name honours Marie Antoinette.",
          "source_id": "OH-F"
        },
        {
          "id": "OH-030",
          "category": "culture",
          "text": "Hang On Sloopy is Ohio's official rock song.",
          "source_id": "OH-F"
        }
      ]
    },
    {
      "name": "Oklahoma",
      "code": "OK",
      "facts": [
        {
          "id": "OK-001",
          "category": "geography",
          "text": "Oklahoma City serves as Oklahoma's capital.",
          "source_id": "OK-D"
        },
        {
          "id": "OK-002",
          "category": "history",
          "text": "Oklahoma became the 46th state in 1907.",
          "source_id": "OK-D"
        },
        {
          "id": "OK-003",
          "category": "geography",
          "text": "Black Mesa contains Oklahoma's highest point.",
          "source_id": "OK-D"
        },
        {
          "id": "OK-004",
          "category": "geography",
          "text": "Oklahoma contains 77 counties.",
          "source_id": "OK-D"
        },
        {
          "id": "OK-005",
          "category": "nature_and_wildlife",
          "text": "The Oklahoma rose is the state's floral emblem.",
          "source_id": "OK-D"
        },
        {
          "id": "OK-006",
          "category": "nature_and_wildlife",
          "text": "The scissor-tailed flycatcher is Oklahoma's bird emblem.",
          "source_id": "OK-D"
        },
        {
          "id": "OK-007",
          "category": "nature_and_wildlife",
          "text": "The eastern redbud is Oklahoma's state tree.",
          "source_id": "OK-D"
        },
        {
          "id": "OK-008",
          "category": "nature_and_wildlife",
          "text": "The white bass is Oklahoma's designated fish.",
          "source_id": "OK-D"
        },
        {
          "id": "OK-009",
          "category": "culture",
          "text": "Oklahoma's name combines Choctaw words for red and people.",
          "source_id": "OK-D"
        },
        {
          "id": "OK-010",
          "category": "geography",
          "text": "Oklahoma borders six other states.",
          "source_id": "OK-D"
        },
        {
          "id": "OK-011",
          "category": "science_and_invention",
          "text": "Oklahoma City installed parking meters in 1935.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-012",
          "category": "science_and_invention",
          "text": "Grocer Sylvan Goldman developed an early shopping trolley in Oklahoma.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-013",
          "category": "landmarks_and_engineering",
          "text": "Oklahoma's capitol received its dome in 2002.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-014",
          "category": "history",
          "text": "Guthrie was Oklahoma's capital before Oklahoma City.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-015",
          "category": "culture",
          "text": "Tahlequah is the Cherokee Nation's capital.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-016",
          "category": "people",
          "text": "Humorist Will Rogers was a citizen of the Cherokee Nation.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-017",
          "category": "people",
          "text": "Garth Brooks was born in Tulsa and grew up in Yukon.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-018",
          "category": "history",
          "text": "Boise City was accidentally hit by practice bombs in 1943.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-019",
          "category": "unusual",
          "text": "Beaver hosts a contest throwing dried cow dung.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-020",
          "category": "science_and_invention",
          "text": "Tinker Air Force Base hosted a successful tornado forecast in 1948.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-021",
          "category": "landmarks_and_engineering",
          "text": "Tulsa tested an early Yield traffic sign.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-022",
          "category": "landmarks_and_engineering",
          "text": "Spiro Mounds preserves an important Indigenous ceremonial centre.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-023",
          "category": "landmarks_and_engineering",
          "text": "Sequoyah's Cabin preserves the home of the Cherokee writing-system creator.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-024",
          "category": "nature_and_wildlife",
          "text": "Indian blanket is Oklahoma's official wildflower.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-025",
          "category": "nature_and_wildlife",
          "text": "Chickasaw National Recreation Area includes springs, streams and lakes.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-026",
          "category": "geography",
          "text": "The Arbuckle Mountains contain Turner Falls.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-027",
          "category": "landmarks_and_engineering",
          "text": "Oklahoma City's national memorial commemorates the 1995 bombing.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-028",
          "category": "landmarks_and_engineering",
          "text": "Duncan displays a sculpture commemorating Chisholm Trail cattle drives.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-029",
          "category": "culture",
          "text": "The film Twister is set in Oklahoma.",
          "source_id": "OK-F"
        },
        {
          "id": "OK-030",
          "category": "history",
          "text": "Sooner originally referred to settlers entering land before the authorised start.",
          "source_id": "OK-F"
        }
      ]
    },
    {
      "name": "Oregon",
      "code": "OR",
      "facts": [
        {
          "id": "OR-001",
          "category": "geography",
          "text": "Salem serves as Oregon's capital.",
          "source_id": "OR-D"
        },
        {
          "id": "OR-002",
          "category": "nature_and_wildlife",
          "text": "The western meadowlark is Oregon's state bird.",
          "source_id": "OR-D"
        },
        {
          "id": "OR-003",
          "category": "nature_and_wildlife",
          "text": "Oregon grape is the state's official flower.",
          "source_id": "OR-D"
        },
        {
          "id": "OR-004",
          "category": "nature_and_wildlife",
          "text": "The Douglas fir is Oregon's state tree.",
          "source_id": "OR-D"
        },
        {
          "id": "OR-005",
          "category": "nature_and_wildlife",
          "text": "The American beaver is Oregon's state animal.",
          "source_id": "OR-D"
        },
        {
          "id": "OR-006",
          "category": "geography",
          "text": "Oregon meets the Pacific Ocean on its western side.",
          "source_id": "OR-D"
        },
        {
          "id": "OR-007",
          "category": "geography",
          "text": "Mount Hood is Oregon's highest mountain.",
          "source_id": "OR-D"
        },
        {
          "id": "OR-008",
          "category": "history",
          "text": "Oregon became the 33rd state in 1859.",
          "source_id": "OR-D"
        },
        {
          "id": "OR-009",
          "category": "geography",
          "text": "Oregon borders California, Nevada, Idaho and Washington.",
          "source_id": "OR-D"
        },
        {
          "id": "OR-010",
          "category": "culture",
          "text": "Oregon's nickname is the Beaver State.",
          "source_id": "OR-D"
        },
        {
          "id": "OR-011",
          "category": "nature_and_wildlife",
          "text": "Crater Lake fills a collapsed volcano's caldera.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-012",
          "category": "geography",
          "text": "Crater Lake is the deepest lake in the United States.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-013",
          "category": "nature_and_wildlife",
          "text": "Bend contains a volcanic cinder cone called Pilot Butte.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-014",
          "category": "nature_and_wildlife",
          "text": "Chinook salmon is Oregon's official state fish.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-015",
          "category": "food_and_farming",
          "text": "Dorris Ranch has a historic commercial hazelnut orchard.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-016",
          "category": "nature_and_wildlife",
          "text": "Silver Falls State Park features a trail linking ten waterfalls.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-017",
          "category": "nature_and_wildlife",
          "text": "The Oregon Caves formed in marble.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-018",
          "category": "culture",
          "text": "Oregon's flag has different designs on its two sides.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-019",
          "category": "culture",
          "text": "A beaver appears on the back of Oregon's flag.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-020",
          "category": "food_and_farming",
          "text": "The hazelnut is Oregon's official state nut.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-021",
          "category": "history",
          "text": "Oregon's statehood anniversary falls on Valentine's Day.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-022",
          "category": "landmarks_and_engineering",
          "text": "The Oregon Pioneer statue stands atop the state capitol.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-023",
          "category": "culture",
          "text": "Navy blue and gold are Oregon's official colours.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-024",
          "category": "history",
          "text": "The University of Oregon opened in Eugene in 1876.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-025",
          "category": "landmarks_and_engineering",
          "text": "Sea Lion Caves lies near Florence on Oregon's coast.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-026",
          "category": "nature_and_wildlife",
          "text": "Darlingtonia State Natural Site protects carnivorous plants.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-027",
          "category": "culture",
          "text": "Portland is nicknamed the City of Roses.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-028",
          "category": "history",
          "text": "Portland's International Rose Test Garden began in 1917.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-029",
          "category": "history",
          "text": "Fort Clatsop recreates Lewis and Clark's winter camp.",
          "source_id": "OR-F"
        },
        {
          "id": "OR-030",
          "category": "geography",
          "text": "The Columbia River forms much of Oregon's northern border.",
          "source_id": "OR-F"
        }
      ]
    },
    {
      "name": "Pennsylvania",
      "code": "PA",
      "facts": [
        {
          "id": "PA-001",
          "category": "geography",
          "text": "Harrisburg serves as Pennsylvania's capital.",
          "source_id": "PA-D"
        },
        {
          "id": "PA-002",
          "category": "nature_and_wildlife",
          "text": "The ruffed grouse is Pennsylvania's state bird.",
          "source_id": "PA-D"
        },
        {
          "id": "PA-003",
          "category": "nature_and_wildlife",
          "text": "Mountain laurel is Pennsylvania's state flower.",
          "source_id": "PA-D"
        },
        {
          "id": "PA-004",
          "category": "nature_and_wildlife",
          "text": "The eastern hemlock is Pennsylvania's state tree.",
          "source_id": "PA-D"
        },
        {
          "id": "PA-005",
          "category": "nature_and_wildlife",
          "text": "Brook trout is Pennsylvania's state fish.",
          "source_id": "PA-D"
        },
        {
          "id": "PA-006",
          "category": "nature_and_wildlife",
          "text": "The Great Dane is Pennsylvania's official state dog.",
          "source_id": "PA-D"
        },
        {
          "id": "PA-007",
          "category": "geography",
          "text": "Mount Davis is Pennsylvania's highest point.",
          "source_id": "PA-D"
        },
        {
          "id": "PA-008",
          "category": "history",
          "text": "Pennsylvania became the second state in 1787.",
          "source_id": "PA-D"
        },
        {
          "id": "PA-009",
          "category": "geography",
          "text": "Pennsylvania has a shoreline on Lake Erie.",
          "source_id": "PA-D"
        },
        {
          "id": "PA-010",
          "category": "culture",
          "text": "Pennsylvania is nicknamed the Keystone State.",
          "source_id": "PA-D"
        },
        {
          "id": "PA-011",
          "category": "landmarks_and_engineering",
          "text": "Rockville Bridge carries trains across stone arches near Harrisburg.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-012",
          "category": "food_and_farming",
          "text": "Kennett Square calls itself the Mushroom Capital of the World.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-013",
          "category": "culture",
          "text": "The Pittsburgh Steelers' name reflects the city's steelmaking heritage.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-014",
          "category": "landmarks_and_engineering",
          "text": "Pittsburgh's hilly neighbourhoods contain hundreds of public stairways.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-015",
          "category": "geography",
          "text": "The Appalachian Mountains run through Pennsylvania.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-016",
          "category": "history",
          "text": "ENIAC, an early electronic computer, was unveiled in Philadelphia.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-017",
          "category": "history",
          "text": "York Barbell began in York in 1932.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-018",
          "category": "history",
          "text": "Philadelphia Zoo opened in 1874.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-019",
          "category": "history",
          "text": "Edwin Drake drilled his influential Titusville oil well in 1859.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-020",
          "category": "food_and_farming",
          "text": "Hershey is closely associated with chocolate manufacturing.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-021",
          "category": "food_and_farming",
          "text": "Cheesesteak sandwiches are a Philadelphia speciality.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-022",
          "category": "history",
          "text": "The Declaration of Independence was signed in Philadelphia.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-023",
          "category": "landmarks_and_engineering",
          "text": "Philadelphia houses the Liberty Bell.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-024",
          "category": "history",
          "text": "Pittsburgh's Liberty Tunnels opened in 1924.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-025",
          "category": "geography",
          "text": "Pennsylvania is the only original state without an Atlantic coastline.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-026",
          "category": "people",
          "text": "Actor Jimmy Stewart was born in Indiana, Pennsylvania.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-027",
          "category": "culture",
          "text": "Nazareth is home to Martin guitar manufacturing.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-028",
          "category": "history",
          "text": "Philadelphia once served as the United States capital.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-029",
          "category": "history",
          "text": "Zippo was founded in Bradford in 1932.",
          "source_id": "PA-F"
        },
        {
          "id": "PA-030",
          "category": "culture",
          "text": "Punxsutawney Phil is the groundhog featured in Groundhog Day celebrations.",
          "source_id": "PA-F"
        }
      ]
    },
    {
      "name": "Rhode Island",
      "code": "RI",
      "facts": [
        {
          "id": "RI-001",
          "category": "geography",
          "text": "Providence serves as Rhode Island's capital.",
          "source_id": "RI-D"
        },
        {
          "id": "RI-002",
          "category": "culture",
          "text": "Rhode Island is nicknamed the Ocean State.",
          "source_id": "RI-D"
        },
        {
          "id": "RI-003",
          "category": "culture",
          "text": "Rhode Island's state motto is simply Hope.",
          "source_id": "RI-D"
        },
        {
          "id": "RI-004",
          "category": "nature_and_wildlife",
          "text": "The Rhode Island Red chicken is the state bird.",
          "source_id": "RI-D"
        },
        {
          "id": "RI-005",
          "category": "nature_and_wildlife",
          "text": "The violet is Rhode Island's state flower.",
          "source_id": "RI-D"
        },
        {
          "id": "RI-006",
          "category": "nature_and_wildlife",
          "text": "The red maple is Rhode Island's state tree.",
          "source_id": "RI-D"
        },
        {
          "id": "RI-007",
          "category": "nature_and_wildlife",
          "text": "Striped bass is Rhode Island's state fish.",
          "source_id": "RI-D"
        },
        {
          "id": "RI-008",
          "category": "food_and_farming",
          "text": "Coffee milk is Rhode Island's official state drink.",
          "source_id": "RI-D"
        },
        {
          "id": "RI-009",
          "category": "geography",
          "text": "Jerimoth Hill is Rhode Island's highest point.",
          "source_id": "RI-D"
        },
        {
          "id": "RI-010",
          "category": "geography",
          "text": "Rhode Island is the smallest US state by area.",
          "source_id": "RI-D"
        },
        {
          "id": "RI-011",
          "category": "history",
          "text": "Rhode Island was the last original colony to ratify the Constitution.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-012",
          "category": "geography",
          "text": "Rhode Island shares a maritime boundary with New York.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-013",
          "category": "sport",
          "text": "Newport hosted the first US Open golf championship in 1895.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-014",
          "category": "landmarks_and_engineering",
          "text": "The Independent Man statue crowns Rhode Island's State House.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-015",
          "category": "history",
          "text": "Rhode Island entered the Union in May 1790.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-016",
          "category": "history",
          "text": "Rhode Island did not ratify the constitutional amendment establishing Prohibition.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-017",
          "category": "culture",
          "text": "An anchor forms the central image of Rhode Island's seal.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-018",
          "category": "history",
          "text": "John F. Kennedy married Jacqueline Bouvier in Newport in 1953.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-019",
          "category": "landmarks_and_engineering",
          "text": "Watch Hill has a historic Flying Horse Carousel.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-020",
          "category": "sport",
          "text": "Newport houses the International Tennis Hall of Fame.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-021",
          "category": "people",
          "text": "Composer George M. Cohan was born in Providence.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-022",
          "category": "culture",
          "text": "Providence has a giant blue termite sculpture beside the highway.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-023",
          "category": "history",
          "text": "Slater Mill in Pawtucket helped develop American textile manufacturing.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-024",
          "category": "landmarks_and_engineering",
          "text": "The State House contains a replica of the Liberty Bell.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-025",
          "category": "landmarks_and_engineering",
          "text": "Adamsville has a monument honouring Rhode Island Red chickens.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-026",
          "category": "landmarks_and_engineering",
          "text": "Newport's White Horse Tavern dates to the seventeenth century.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-027",
          "category": "culture",
          "text": "The Crescent Park Carousel represents Rhode Island's folk-art heritage.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-028",
          "category": "culture",
          "text": "Bristol's Independence Day celebrations date back to 1785.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-029",
          "category": "landmarks_and_engineering",
          "text": "Newport's Touro Synagogue was completed in 1763.",
          "source_id": "RI-F"
        },
        {
          "id": "RI-030",
          "category": "science_and_invention",
          "text": "The Quonset hut was developed at Quonset Point.",
          "source_id": "RI-F"
        }
      ]
    },
    {
      "name": "South Carolina",
      "code": "SC",
      "facts": [
        {
          "id": "SC-001",
          "category": "geography",
          "text": "Columbia serves as South Carolina's capital.",
          "source_id": "SC-D"
        },
        {
          "id": "SC-002",
          "category": "nature_and_wildlife",
          "text": "The Carolina wren is South Carolina's state bird.",
          "source_id": "SC-D"
        },
        {
          "id": "SC-003",
          "category": "nature_and_wildlife",
          "text": "Yellow jessamine is South Carolina's state flower.",
          "source_id": "SC-D"
        },
        {
          "id": "SC-004",
          "category": "nature_and_wildlife",
          "text": "The sabal palmetto is South Carolina's state tree.",
          "source_id": "SC-D"
        },
        {
          "id": "SC-005",
          "category": "nature_and_wildlife",
          "text": "The Boykin spaniel is South Carolina's state dog.",
          "source_id": "SC-D"
        },
        {
          "id": "SC-006",
          "category": "nature_and_wildlife",
          "text": "Striped bass is South Carolina's state fish.",
          "source_id": "SC-D"
        },
        {
          "id": "SC-007",
          "category": "geography",
          "text": "Sassafras Mountain is South Carolina's highest point.",
          "source_id": "SC-D"
        },
        {
          "id": "SC-008",
          "category": "history",
          "text": "South Carolina became the eighth state in 1788.",
          "source_id": "SC-D"
        },
        {
          "id": "SC-009",
          "category": "geography",
          "text": "South Carolina's only neighbouring states are Georgia and North Carolina.",
          "source_id": "SC-D"
        },
        {
          "id": "SC-010",
          "category": "food_and_farming",
          "text": "Sweet tea is South Carolina's official hospitality beverage.",
          "source_id": "SC-D"
        },
        {
          "id": "SC-011",
          "category": "history",
          "text": "Palmetto logs helped absorb cannon fire at Sullivan's Island.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-012",
          "category": "geography",
          "text": "Myrtle Beach forms part of the Grand Strand coastline.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-013",
          "category": "history",
          "text": "South Carolina once promoted itself as the Iodine State.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-014",
          "category": "sport",
          "text": "Aiken has a Thoroughbred Racing Hall of Fame.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-015",
          "category": "nature_and_wildlife",
          "text": "Organic material gives the Black River its tea-coloured water.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-016",
          "category": "culture",
          "text": "Batesburg-Leesville hosts the South Carolina Poultry Festival.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-017",
          "category": "history",
          "text": "A Camden weather vane depicts Catawba leader King Haiglar.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-018",
          "category": "geography",
          "text": "The Blue Ridge Mountains extend into South Carolina.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-019",
          "category": "nature_and_wildlife",
          "text": "Tannins darken the water of the Edisto River.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-020",
          "category": "culture",
          "text": "The shag is South Carolina's official state dance.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-021",
          "category": "culture",
          "text": "One state motto translates as 'While I breathe, I hope'.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-022",
          "category": "landmarks_and_engineering",
          "text": "Campbell's Covered Bridge was built in 1909.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-023",
          "category": "history",
          "text": "Coker Experimental Farms in Hartsville developed improved crop varieties.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-024",
          "category": "history",
          "text": "The Civil War's opening bombardment targeted Fort Sumter.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-025",
          "category": "sport",
          "text": "Pitcher Bill Voiselle wore 96 to honour his hometown.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-026",
          "category": "food_and_farming",
          "text": "Clemson used Stumphouse Tunnel for blue-cheese ageing experiments.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-027",
          "category": "landmarks_and_engineering",
          "text": "Gaffney's Peachoid water tower resembles a giant peach.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-028",
          "category": "culture",
          "text": "Mount Pleasant has a longstanding sweetgrass basket-making tradition.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-029",
          "category": "nature_and_wildlife",
          "text": "Purple martins gather at Lake Murray's Bomb Island.",
          "source_id": "SC-F"
        },
        {
          "id": "SC-030",
          "category": "landmarks_and_engineering",
          "text": "Orangeburg's Edisto Memorial Gardens displays roses.",
          "source_id": "SC-F"
        }
      ]
    },
    {
      "name": "South Dakota",
      "code": "SD",
      "facts": [
        {
          "id": "SD-001",
          "category": "geography",
          "text": "Pierre serves as South Dakota's capital.",
          "source_id": "SD-D"
        },
        {
          "id": "SD-002",
          "category": "nature_and_wildlife",
          "text": "The ring-necked pheasant is South Dakota's state bird.",
          "source_id": "SD-D"
        },
        {
          "id": "SD-003",
          "category": "nature_and_wildlife",
          "text": "The pasque flower is South Dakota's state flower.",
          "source_id": "SD-D"
        },
        {
          "id": "SD-004",
          "category": "nature_and_wildlife",
          "text": "Black Hills spruce is South Dakota's state tree.",
          "source_id": "SD-D"
        },
        {
          "id": "SD-005",
          "category": "nature_and_wildlife",
          "text": "The coyote is South Dakota's state animal.",
          "source_id": "SD-D"
        },
        {
          "id": "SD-006",
          "category": "nature_and_wildlife",
          "text": "Walleye is South Dakota's state fish.",
          "source_id": "SD-D"
        },
        {
          "id": "SD-007",
          "category": "food_and_farming",
          "text": "Kuchen is South Dakota's official state dessert.",
          "source_id": "SD-D"
        },
        {
          "id": "SD-008",
          "category": "history",
          "text": "Both Dakotas became states on November 2, 1889.",
          "source_id": "SD-D"
        },
        {
          "id": "SD-009",
          "category": "geography",
          "text": "South Dakota borders six other states.",
          "source_id": "SD-D"
        },
        {
          "id": "SD-010",
          "category": "culture",
          "text": "Dances with Wolves was filmed partly in South Dakota.",
          "source_id": "SD-D"
        },
        {
          "id": "SD-011",
          "category": "nature_and_wildlife",
          "text": "Custer State Park supports a free-roaming bison herd.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-012",
          "category": "nature_and_wildlife",
          "text": "Jewel Cave takes its name from glittering calcite crystals.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-013",
          "category": "nature_and_wildlife",
          "text": "Wind Cave contains delicate mineral formations called boxwork.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-014",
          "category": "landmarks_and_engineering",
          "text": "The Crazy Horse Memorial is carved into a mountain.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-015",
          "category": "geography",
          "text": "Badlands National Park combines eroded rock formations with prairie.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-016",
          "category": "nature_and_wildlife",
          "text": "Badlands fossils preserve evidence of ancient mammals.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-017",
          "category": "nature_and_wildlife",
          "text": "Black-footed ferrets have been reintroduced in the Badlands.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-018",
          "category": "geography",
          "text": "Black Hills translates a Lakota name describing their dark appearance.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-019",
          "category": "geography",
          "text": "Lake Prior sits in the town of Woonsocket.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-020",
          "category": "history",
          "text": "Black Elk Wilderness honours an Oglala Lakota holy man.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-021",
          "category": "culture",
          "text": "Sturgis is famous for its motorcycle rally.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-022",
          "category": "nature_and_wildlife",
          "text": "The Mammoth Site in Hot Springs displays excavated mammoth remains.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-023",
          "category": "landmarks_and_engineering",
          "text": "Lemmon has a park featuring petrified-wood sculptures.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-024",
          "category": "history",
          "text": "Fort Pierre Chouteau began as a fur-trading post in 1832.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-025",
          "category": "history",
          "text": "Deadwood developed as a Black Hills gold-rush town.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-026",
          "category": "culture",
          "text": "Clark's Potato Day has featured mashed-potato wrestling.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-027",
          "category": "landmarks_and_engineering",
          "text": "Murdo's Pioneer Auto museum displays historic vehicles.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-028",
          "category": "history",
          "text": "Work on Mount Rushmore began in 1927.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-029",
          "category": "culture",
          "text": "Bear Butte is sacred to several Indigenous nations.",
          "source_id": "SD-F"
        },
        {
          "id": "SD-030",
          "category": "history",
          "text": "Yankton was the original capital of Dakota Territory.",
          "source_id": "SD-F"
        }
      ]
    },
    {
      "name": "Tennessee",
      "code": "TN",
      "facts": [
        {
          "id": "TN-001",
          "category": "geography",
          "text": "Nashville serves as Tennessee's capital.",
          "source_id": "TN-D"
        },
        {
          "id": "TN-002",
          "category": "nature_and_wildlife",
          "text": "The northern mockingbird is Tennessee's state bird.",
          "source_id": "TN-D"
        },
        {
          "id": "TN-003",
          "category": "nature_and_wildlife",
          "text": "The iris is Tennessee's official cultivated flower.",
          "source_id": "TN-D"
        },
        {
          "id": "TN-004",
          "category": "nature_and_wildlife",
          "text": "The tulip poplar is Tennessee's state tree.",
          "source_id": "TN-D"
        },
        {
          "id": "TN-005",
          "category": "nature_and_wildlife",
          "text": "The raccoon is Tennessee's state wild animal.",
          "source_id": "TN-D"
        },
        {
          "id": "TN-006",
          "category": "nature_and_wildlife",
          "text": "Smallmouth bass is Tennessee's official sport fish.",
          "source_id": "TN-D"
        },
        {
          "id": "TN-007",
          "category": "geography",
          "text": "Tennessee borders eight other states.",
          "source_id": "TN-D"
        },
        {
          "id": "TN-008",
          "category": "history",
          "text": "Tennessee became the 16th state in 1796.",
          "source_id": "TN-D"
        },
        {
          "id": "TN-009",
          "category": "culture",
          "text": "Three flag stars represent Tennessee's three Grand Divisions.",
          "source_id": "TN-D"
        },
        {
          "id": "TN-010",
          "category": "history",
          "text": "Tennessee's name derives from the Cherokee settlement Tanasi.",
          "source_id": "TN-D"
        },
        {
          "id": "TN-011",
          "category": "nature_and_wildlife",
          "text": "High Smoky Mountain elevations support spruce-fir forests.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-012",
          "category": "people",
          "text": "Davy Crockett was born near Limestone Creek.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-013",
          "category": "nature_and_wildlife",
          "text": "Chattanooga's Tennessee Aquarium highlights freshwater ecosystems.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-014",
          "category": "geography",
          "text": "The 1811–1812 New Madrid earthquakes helped form Reelfoot Lake.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-015",
          "category": "geography",
          "text": "The Smoky Mountains take their name from their blue haze.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-016",
          "category": "landmarks_and_engineering",
          "text": "Elvis Presley's Graceland home is in Memphis.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-017",
          "category": "history",
          "text": "Cotton trading helped Memphis develop as a river port.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-018",
          "category": "culture",
          "text": "Rocky Top is one of Tennessee's official state songs.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-019",
          "category": "culture",
          "text": "Bristol is celebrated as a birthplace of country music.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-020",
          "category": "history",
          "text": "Kingston served as Tennessee's capital for one day in 1807.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-021",
          "category": "culture",
          "text": "The Grand Ole Opry began broadcasting in 1925.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-022",
          "category": "people",
          "text": "Railroad engineer Casey Jones lived in Jackson.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-023",
          "category": "history",
          "text": "Oak Ridge contributed to the Manhattan Project.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-024",
          "category": "nature_and_wildlife",
          "text": "Tennessee contains thousands of documented caves.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-025",
          "category": "people",
          "text": "Alex Haley's boyhood home is preserved in Henning.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-026",
          "category": "history",
          "text": "Knoxville hosted the 1982 World's Fair.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-027",
          "category": "history",
          "text": "Memphis's National Civil Rights Museum incorporates the Lorraine Motel.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-028",
          "category": "landmarks_and_engineering",
          "text": "Nashville has a full-scale replica of the Parthenon.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-029",
          "category": "nature_and_wildlife",
          "text": "Sweetwater's Lost Sea is an underground lake.",
          "source_id": "TN-F"
        },
        {
          "id": "TN-030",
          "category": "sport",
          "text": "The Ocoee River hosted Olympic whitewater events in 1996.",
          "source_id": "TN-F"
        }
      ]
    },
    {
      "name": "Texas",
      "code": "TX",
      "facts": [
        {
          "id": "TX-001",
          "category": "geography",
          "text": "Austin serves as Texas's capital.",
          "source_id": "TX-D"
        },
        {
          "id": "TX-002",
          "category": "nature_and_wildlife",
          "text": "The northern mockingbird is Texas's state bird.",
          "source_id": "TX-D"
        },
        {
          "id": "TX-003",
          "category": "nature_and_wildlife",
          "text": "Bluebonnets are Texas's state flowers.",
          "source_id": "TX-D"
        },
        {
          "id": "TX-004",
          "category": "nature_and_wildlife",
          "text": "The pecan is Texas's state tree.",
          "source_id": "TX-D"
        },
        {
          "id": "TX-005",
          "category": "nature_and_wildlife",
          "text": "Guadalupe bass is Texas's state fish.",
          "source_id": "TX-D"
        },
        {
          "id": "TX-006",
          "category": "nature_and_wildlife",
          "text": "The nine-banded armadillo is Texas's official small mammal.",
          "source_id": "TX-D"
        },
        {
          "id": "TX-007",
          "category": "geography",
          "text": "Guadalupe Peak is Texas's highest point.",
          "source_id": "TX-D"
        },
        {
          "id": "TX-008",
          "category": "history",
          "text": "Texas became the 28th state in 1845.",
          "source_id": "TX-D"
        },
        {
          "id": "TX-009",
          "category": "geography",
          "text": "Texas has 254 counties.",
          "source_id": "TX-D"
        },
        {
          "id": "TX-010",
          "category": "food_and_farming",
          "text": "Chili is Texas's official state dish.",
          "source_id": "TX-D"
        },
        {
          "id": "TX-011",
          "category": "people",
          "text": "Sam Houston served as Tennessee's governor before moving to Texas.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-012",
          "category": "nature_and_wildlife",
          "text": "The Big Tree near Rockport is an ancient live oak.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-013",
          "category": "geography",
          "text": "Caddo Lake lies on Texas's border with Louisiana.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-014",
          "category": "nature_and_wildlife",
          "text": "Texas supports many different bat species.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-015",
          "category": "nature_and_wildlife",
          "text": "The lightning whelk is Texas's state shell.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-016",
          "category": "culture",
          "text": "Cowboy boots are Texas's official state footwear.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-017",
          "category": "culture",
          "text": "Friendship is Texas's state motto.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-018",
          "category": "history",
          "text": "Texas existed as an independent republic from 1836 to 1845.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-019",
          "category": "landmarks_and_engineering",
          "text": "The Alamo stands in San Antonio.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-020",
          "category": "landmarks_and_engineering",
          "text": "Texas's capitol was built using pink granite.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-021",
          "category": "geography",
          "text": "Austin stands on the Texas Colorado River.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-022",
          "category": "culture",
          "text": "Austin promotes itself as the Live Music Capital of the World.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-023",
          "category": "food_and_farming",
          "text": "Dr Pepper originated in Waco in 1885.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-024",
          "category": "landmarks_and_engineering",
          "text": "Waco's historic suspension bridge crosses the Brazos River.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-025",
          "category": "history",
          "text": "The Texas Capitol opened in 1888.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-026",
          "category": "history",
          "text": "Houston's Astrodome opened in 1965.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-027",
          "category": "sport",
          "text": "The Houston Comets won four consecutive WNBA championships, 1997–2000.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-028",
          "category": "history",
          "text": "A devastating hurricane struck Galveston in 1900.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-029",
          "category": "nature_and_wildlife",
          "text": "Tyler is known for its municipal rose garden.",
          "source_id": "TX-F"
        },
        {
          "id": "TX-030",
          "category": "nature_and_wildlife",
          "text": "Whooping cranes winter at Aransas National Wildlife Refuge.",
          "source_id": "TX-F"
        }
      ]
    },
    {
      "name": "Utah",
      "code": "UT",
      "facts": [
        {
          "id": "UT-001",
          "category": "geography",
          "text": "Salt Lake City serves as Utah's capital.",
          "source_id": "UT-D"
        },
        {
          "id": "UT-002",
          "category": "nature_and_wildlife",
          "text": "The California gull is Utah's state bird.",
          "source_id": "UT-D"
        },
        {
          "id": "UT-003",
          "category": "nature_and_wildlife",
          "text": "The sego lily is Utah's state flower.",
          "source_id": "UT-D"
        },
        {
          "id": "UT-004",
          "category": "nature_and_wildlife",
          "text": "The quaking aspen is Utah's state tree.",
          "source_id": "UT-D"
        },
        {
          "id": "UT-005",
          "category": "nature_and_wildlife",
          "text": "Bonneville cutthroat trout is Utah's state fish.",
          "source_id": "UT-D"
        },
        {
          "id": "UT-006",
          "category": "nature_and_wildlife",
          "text": "Rocky Mountain elk is Utah's state animal.",
          "source_id": "UT-D"
        },
        {
          "id": "UT-007",
          "category": "geography",
          "text": "Kings Peak is Utah's highest point.",
          "source_id": "UT-D"
        },
        {
          "id": "UT-008",
          "category": "history",
          "text": "Utah became the 45th state in 1896.",
          "source_id": "UT-D"
        },
        {
          "id": "UT-009",
          "category": "culture",
          "text": "Utah is nicknamed the Beehive State.",
          "source_id": "UT-D"
        },
        {
          "id": "UT-010",
          "category": "geography",
          "text": "Utah touches New Mexico at Four Corners.",
          "source_id": "UT-D"
        },
        {
          "id": "UT-011",
          "category": "landmarks_and_engineering",
          "text": "Rainbow Bridge is a huge natural sandstone bridge.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-012",
          "category": "nature_and_wildlife",
          "text": "Utah's dry mountain snow attracts powder-skiing enthusiasts.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-013",
          "category": "history",
          "text": "Salt Lake City was originally called Great Salt Lake City.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-014",
          "category": "culture",
          "text": "The beehive symbol represents industry and hard work.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-015",
          "category": "geography",
          "text": "The Uinta Mountains take their name from the Ute people.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-016",
          "category": "geography",
          "text": "Rainfall varies greatly between Utah's deserts and mountains.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-017",
          "category": "history",
          "text": "Promontory hosted the first US transcontinental railroad's final-spike ceremony.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-018",
          "category": "history",
          "text": "The railroads met at Promontory on May 10, 1869.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-019",
          "category": "culture",
          "text": "Levan spells the word navel backwards.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-020",
          "category": "landmarks_and_engineering",
          "text": "The Salt Lake Temple took forty years to build.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-021",
          "category": "culture",
          "text": "Industry is Utah's state motto.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-022",
          "category": "nature_and_wildlife",
          "text": "Utah's national parks include Arches, Bryce Canyon, Canyonlands, Capitol Reef and Zion.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-023",
          "category": "geography",
          "text": "Interstate 70 ends near Cove Fort in western Utah.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-024",
          "category": "sport",
          "text": "Salt Lake City hosted the 2002 Winter Olympics.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-025",
          "category": "geography",
          "text": "Capitol Reef protects a geological fold called the Waterpocket Fold.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-026",
          "category": "geography",
          "text": "Cedar Hills occupies part of ancient Lake Bonneville's shoreline.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-027",
          "category": "history",
          "text": "Fillmore was Utah Territory's first capital.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-028",
          "category": "culture",
          "text": "Kanab's film history earned it the nickname Little Hollywood.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-029",
          "category": "culture",
          "text": "Each word in Salt Lake City's name has four letters.",
          "source_id": "UT-F"
        },
        {
          "id": "UT-030",
          "category": "culture",
          "text": "Touched by an Angel was filmed in Utah.",
          "source_id": "UT-F"
        }
      ]
    },
    {
      "name": "Vermont",
      "code": "VT",
      "facts": [
        {
          "id": "VT-001",
          "category": "geography",
          "text": "Montpelier serves as Vermont's capital.",
          "source_id": "VT-D"
        },
        {
          "id": "VT-002",
          "category": "nature_and_wildlife",
          "text": "The hermit thrush is Vermont's state bird.",
          "source_id": "VT-D"
        },
        {
          "id": "VT-003",
          "category": "nature_and_wildlife",
          "text": "Red clover is Vermont's state flower.",
          "source_id": "VT-D"
        },
        {
          "id": "VT-004",
          "category": "nature_and_wildlife",
          "text": "The sugar maple is Vermont's state tree.",
          "source_id": "VT-D"
        },
        {
          "id": "VT-005",
          "category": "nature_and_wildlife",
          "text": "The Morgan horse is Vermont's state animal.",
          "source_id": "VT-D"
        },
        {
          "id": "VT-006",
          "category": "geography",
          "text": "Mount Mansfield is Vermont's highest peak.",
          "source_id": "VT-D"
        },
        {
          "id": "VT-007",
          "category": "history",
          "text": "Vermont became the 14th state in 1791.",
          "source_id": "VT-D"
        },
        {
          "id": "VT-008",
          "category": "geography",
          "text": "Vermont borders Canada, New York, Massachusetts and New Hampshire.",
          "source_id": "VT-D"
        },
        {
          "id": "VT-009",
          "category": "culture",
          "text": "Vermont's name combines French words for green and mountain.",
          "source_id": "VT-D"
        },
        {
          "id": "VT-010",
          "category": "food_and_farming",
          "text": "Apple pie is Vermont's official state pie.",
          "source_id": "VT-D"
        },
        {
          "id": "VT-011",
          "category": "people",
          "text": "Calvin Coolidge was born on July 4, 1872.",
          "source_id": "VT-F"
        },
        {
          "id": "VT-012",
          "category": "landmarks_and_engineering",
          "text": "A statue of Ceres stands atop Vermont's State House.",
          "source_id": "VT-F"
        },
        {
          "id": "VT-013",
          "category": "people",
          "text": "Rudyard Kipling lived in Vermont during the 1890s.",
          "source_id": "VT-F"
        },
        {
          "id": "VT-014",
          "category": "history",
          "text": "Ira Allen designed Vermont's Great Seal.",
          "source_id": "VT-F"
        },
        {
          "id": "VT-015",
          "category": "history",
          "text": "New Hampshire and New York both claimed present-day Vermont.",
          "source_id": "VT-F"
        },
        {
          "id": "VT-016",
          "category": "history",
          "text": "Evidence of Indigenous life in Vermont reaches back about 13,000 years.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-017",
          "category": "landmarks_and_engineering",
          "text": "Vermont's State House dome is covered with real gold leaf.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-018",
          "category": "nature_and_wildlife",
          "text": "Fossils can be found in the State House's stone floors.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-019",
          "category": "geography",
          "text": "Lake Champlain forms part of Vermont's boundary with New York.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-020",
          "category": "people",
          "text": "President Chester A. Arthur was born in Vermont.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-021",
          "category": "people",
          "text": "Wilson Bentley became famous for photographing snowflakes in Jericho.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-022",
          "category": "nature_and_wildlife",
          "text": "Black bears and moose live in Vermont.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-023",
          "category": "geography",
          "text": "Vermont has five mountains higher than 4,000 feet.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-024",
          "category": "sport",
          "text": "The Long Trail runs the length of Vermont.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-025",
          "category": "sport",
          "text": "Woodstock had an early ski tow in 1934.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-026",
          "category": "nature_and_wildlife",
          "text": "Marble, granite and slate are Vermont's state rocks.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-027",
          "category": "nature_and_wildlife",
          "text": "Grossular garnet is Vermont's state gem.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-028",
          "category": "sport",
          "text": "Skiing and snowboarding are Vermont's official state sports.",
          "source_id": "VT-T"
        },
        {
          "id": "VT-029",
          "category": "food_and_farming",
          "text": "Ben & Jerry's opened in a converted Burlington petrol station.",
          "source_id": "VT-B"
        },
        {
          "id": "VT-030",
          "category": "history",
          "text": "Ben & Jerry's began in 1978.",
          "source_id": "VT-B"
        }
      ]
    },
    {
      "name": "Virginia",
      "code": "VA",
      "facts": [
        {
          "id": "VA-001",
          "category": "geography",
          "text": "Richmond serves as Virginia's capital.",
          "source_id": "VA-D"
        },
        {
          "id": "VA-002",
          "category": "nature_and_wildlife",
          "text": "The northern cardinal is Virginia's state bird.",
          "source_id": "VA-D"
        },
        {
          "id": "VA-003",
          "category": "nature_and_wildlife",
          "text": "Flowering dogwood serves as both Virginia's state tree and flower.",
          "source_id": "VA-D"
        },
        {
          "id": "VA-004",
          "category": "nature_and_wildlife",
          "text": "Brook trout is Virginia's state freshwater fish.",
          "source_id": "VA-D"
        },
        {
          "id": "VA-005",
          "category": "nature_and_wildlife",
          "text": "The American foxhound is Virginia's state dog.",
          "source_id": "VA-D"
        },
        {
          "id": "VA-006",
          "category": "geography",
          "text": "Mount Rogers is Virginia's highest point.",
          "source_id": "VA-D"
        },
        {
          "id": "VA-007",
          "category": "history",
          "text": "Virginia became the tenth state in 1788.",
          "source_id": "VA-D"
        },
        {
          "id": "VA-008",
          "category": "culture",
          "text": "Virginia is nicknamed the Old Dominion.",
          "source_id": "VA-D"
        },
        {
          "id": "VA-009",
          "category": "history",
          "text": "Virginia's name honours Queen Elizabeth I of England.",
          "source_id": "VA-D"
        },
        {
          "id": "VA-010",
          "category": "geography",
          "text": "The James River flows through Virginia.",
          "source_id": "VA-D"
        },
        {
          "id": "VA-011",
          "category": "geography",
          "text": "The Blue Ridge Mountains run through Virginia.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-012",
          "category": "history",
          "text": "Cornwallis surrendered at Yorktown during the American Revolution.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-013",
          "category": "science_and_invention",
          "text": "Richmond introduced an influential electric streetcar system in 1888.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-014",
          "category": "history",
          "text": "Kentucky and West Virginia were once parts of Virginia.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-015",
          "category": "history",
          "text": "Jamestown, Williamsburg and Richmond have all served as Virginia's capital.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-016",
          "category": "history",
          "text": "Jamestown became a permanent English settlement in 1607.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-017",
          "category": "history",
          "text": "Monitor and Virginia fought an ironclad battle at Hampton Roads.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-018",
          "category": "history",
          "text": "Arlington was once part of the District of Columbia.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-019",
          "category": "people",
          "text": "George Washington was born in Virginia.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-020",
          "category": "people",
          "text": "Woodrow Wilson was born in Virginia.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-021",
          "category": "history",
          "text": "William & Mary was founded in Williamsburg in 1693.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-022",
          "category": "history",
          "text": "Richmond served as the Confederacy's capital during the Civil War.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-023",
          "category": "landmarks_and_engineering",
          "text": "Arlington National Cemetery contains the Tomb of the Unknown Soldier.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-024",
          "category": "landmarks_and_engineering",
          "text": "The Pentagon is in Arlington, Virginia.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-025",
          "category": "nature_and_wildlife",
          "text": "The Great Dismal Swamp extends across Virginia and North Carolina.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-026",
          "category": "landmarks_and_engineering",
          "text": "The Chesapeake Bay Bridge-Tunnel combines bridges with underwater tunnels.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-027",
          "category": "nature_and_wildlife",
          "text": "Feral ponies live on Virginia's portion of Assateague Island.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-028",
          "category": "landmarks_and_engineering",
          "text": "Thomas Jefferson designed his home, Monticello.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-029",
          "category": "landmarks_and_engineering",
          "text": "George Washington's Mount Vernon estate is in Virginia.",
          "source_id": "VA-F"
        },
        {
          "id": "VA-030",
          "category": "geography",
          "text": "Bristol's twin cities straddle the Virginia–Tennessee state line.",
          "source_id": "VA-F"
        }
      ]
    },
    {
      "name": "Washington",
      "code": "WA",
      "facts": [
        {
          "id": "WA-001",
          "category": "geography",
          "text": "Olympia serves as Washington's capital.",
          "source_id": "WA-D"
        },
        {
          "id": "WA-002",
          "category": "nature_and_wildlife",
          "text": "The willow goldfinch is Washington's state bird.",
          "source_id": "WA-D"
        },
        {
          "id": "WA-003",
          "category": "nature_and_wildlife",
          "text": "Coast rhododendron is Washington's state flower.",
          "source_id": "WA-D"
        },
        {
          "id": "WA-004",
          "category": "nature_and_wildlife",
          "text": "Western hemlock is Washington's state tree.",
          "source_id": "WA-D"
        },
        {
          "id": "WA-005",
          "category": "nature_and_wildlife",
          "text": "Steelhead trout is Washington's state fish.",
          "source_id": "WA-D"
        },
        {
          "id": "WA-006",
          "category": "nature_and_wildlife",
          "text": "The orca is Washington's state marine mammal.",
          "source_id": "WA-D"
        },
        {
          "id": "WA-007",
          "category": "geography",
          "text": "Mount Rainier is Washington's highest peak.",
          "source_id": "WA-D"
        },
        {
          "id": "WA-008",
          "category": "history",
          "text": "Washington became the 42nd state in 1889.",
          "source_id": "WA-D"
        },
        {
          "id": "WA-009",
          "category": "culture",
          "text": "Washington is nicknamed the Evergreen State.",
          "source_id": "WA-D"
        },
        {
          "id": "WA-010",
          "category": "geography",
          "text": "Washington borders Canada's province of British Columbia.",
          "source_id": "WA-D"
        },
        {
          "id": "WA-011",
          "category": "landmarks_and_engineering",
          "text": "Floating bridges carry traffic across Lake Washington.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-012",
          "category": "geography",
          "text": "The Columbia River forms much of Washington's southern boundary.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-013",
          "category": "geography",
          "text": "Ferries connect many communities around Puget Sound.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-014",
          "category": "nature_and_wildlife",
          "text": "The Olympic Peninsula contains temperate rainforest.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-015",
          "category": "landmarks_and_engineering",
          "text": "Boeing's Everett factory is an enormous aircraft assembly building.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-016",
          "category": "geography",
          "text": "Cape Flattery is the contiguous United States' northwesternmost point.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-017",
          "category": "culture",
          "text": "George Washington's portrait appears on the state seal.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-018",
          "category": "nature_and_wildlife",
          "text": "The green darner dragonfly is Washington's state insect.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-019",
          "category": "food_and_farming",
          "text": "Starbucks began in Seattle.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-020",
          "category": "history",
          "text": "Spokane hosted a World's Fair in 1974.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-021",
          "category": "history",
          "text": "Washington is the only state named after a US president.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-022",
          "category": "people",
          "text": "Jimi Hendrix was born in Seattle.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-023",
          "category": "people",
          "text": "Bing Crosby was born in Tacoma.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-024",
          "category": "history",
          "text": "Washington Territory was created from Oregon Territory in 1853.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-025",
          "category": "history",
          "text": "Grand Coulee Dam was built on the Columbia River.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-026",
          "category": "history",
          "text": "Hanford played a role in the Manhattan Project.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-027",
          "category": "nature_and_wildlife",
          "text": "Mount St. Helens erupted catastrophically in 1980.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-028",
          "category": "science_and_invention",
          "text": "Pictionary was invented in Washington.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-029",
          "category": "sport",
          "text": "Pickleball originated in Washington.",
          "source_id": "WA-F"
        },
        {
          "id": "WA-030",
          "category": "science_and_invention",
          "text": "The board game Cranium originated in Washington.",
          "source_id": "WA-F"
        }
      ]
    },
    {
      "name": "West Virginia",
      "code": "WV",
      "facts": [
        {
          "id": "WV-001",
          "category": "geography",
          "text": "Charleston serves as West Virginia's capital.",
          "source_id": "WV-D"
        },
        {
          "id": "WV-002",
          "category": "nature_and_wildlife",
          "text": "The northern cardinal is West Virginia's state bird.",
          "source_id": "WV-D"
        },
        {
          "id": "WV-003",
          "category": "nature_and_wildlife",
          "text": "Great rhododendron is West Virginia's state flower.",
          "source_id": "WV-D"
        },
        {
          "id": "WV-004",
          "category": "nature_and_wildlife",
          "text": "Sugar maple is West Virginia's state tree.",
          "source_id": "WV-D"
        },
        {
          "id": "WV-005",
          "category": "nature_and_wildlife",
          "text": "The black bear is West Virginia's state animal.",
          "source_id": "WV-D"
        },
        {
          "id": "WV-006",
          "category": "nature_and_wildlife",
          "text": "Brook trout is West Virginia's state fish.",
          "source_id": "WV-D"
        },
        {
          "id": "WV-007",
          "category": "geography",
          "text": "Spruce Knob is West Virginia's highest point.",
          "source_id": "WV-D"
        },
        {
          "id": "WV-008",
          "category": "history",
          "text": "West Virginia became the 35th state in 1863.",
          "source_id": "WV-D"
        },
        {
          "id": "WV-009",
          "category": "culture",
          "text": "West Virginia is nicknamed the Mountain State.",
          "source_id": "WV-D"
        },
        {
          "id": "WV-010",
          "category": "history",
          "text": "West Virginia separated from Virginia during the Civil War.",
          "source_id": "WV-D"
        },
        {
          "id": "WV-011",
          "category": "geography",
          "text": "The Allegheny Mountains run through West Virginia.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-012",
          "category": "culture",
          "text": "Jackson's Mill has a long history of 4-H camping.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-013",
          "category": "sport",
          "text": "Danny Heater scored 135 points in a 1960 basketball game.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-014",
          "category": "nature_and_wildlife",
          "text": "Forests cover much of West Virginia.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-015",
          "category": "history",
          "text": "Jefferson County hosted early rural free mail-delivery trials in 1896.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-016",
          "category": "landmarks_and_engineering",
          "text": "Moundsville contains the prehistoric Grave Creek burial mound.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-017",
          "category": "history",
          "text": "Grafton hosted an influential Mother's Day observance in 1908.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-018",
          "category": "culture",
          "text": "The state motto translates as 'Mountaineers are always free'.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-019",
          "category": "landmarks_and_engineering",
          "text": "New River Gorge Bridge spans a deep Appalachian river gorge.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-020",
          "category": "culture",
          "text": "Bridge Day celebrations feature jumps from New River Gorge Bridge.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-021",
          "category": "history",
          "text": "Philippi was the site of an early Civil War battle.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-022",
          "category": "history",
          "text": "James Rumsey demonstrated a steamboat at Shepherdstown in 1787.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-023",
          "category": "nature_and_wildlife",
          "text": "Organ Cave is part of West Virginia's underground landscape.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-024",
          "category": "food_and_farming",
          "text": "The Golden Delicious apple originated in Clay County.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-025",
          "category": "food_and_farming",
          "text": "The Grimes Golden apple originated near Wellsburg.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-026",
          "category": "history",
          "text": "Wheeling's suspension bridge was completed in 1849.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-027",
          "category": "culture",
          "text": "Mail Pouch advertisements became familiar sights on painted barns.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-028",
          "category": "history",
          "text": "West Virginia University was founded in 1867.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-029",
          "category": "landmarks_and_engineering",
          "text": "Berkeley Springs is known for its mineral springs.",
          "source_id": "WV-F"
        },
        {
          "id": "WV-030",
          "category": "history",
          "text": "Minnie Buckingham Harper entered West Virginia's legislature in 1928.",
          "source_id": "WV-F"
        }
      ]
    },
    {
      "name": "Wisconsin",
      "code": "WI",
      "facts": [
        {
          "id": "WI-001",
          "category": "geography",
          "text": "Madison serves as Wisconsin's capital.",
          "source_id": "WI-D"
        },
        {
          "id": "WI-002",
          "category": "nature_and_wildlife",
          "text": "The American robin is Wisconsin's state bird.",
          "source_id": "WI-D"
        },
        {
          "id": "WI-003",
          "category": "nature_and_wildlife",
          "text": "Wood violet is Wisconsin's state flower.",
          "source_id": "WI-D"
        },
        {
          "id": "WI-004",
          "category": "nature_and_wildlife",
          "text": "Sugar maple is Wisconsin's state tree.",
          "source_id": "WI-D"
        },
        {
          "id": "WI-005",
          "category": "nature_and_wildlife",
          "text": "Muskellunge is Wisconsin's state fish.",
          "source_id": "WI-D"
        },
        {
          "id": "WI-006",
          "category": "nature_and_wildlife",
          "text": "The badger is Wisconsin's state animal.",
          "source_id": "WI-D"
        },
        {
          "id": "WI-007",
          "category": "geography",
          "text": "Timms Hill is Wisconsin's highest point.",
          "source_id": "WI-D"
        },
        {
          "id": "WI-008",
          "category": "history",
          "text": "Wisconsin became the 30th state in 1848.",
          "source_id": "WI-D"
        },
        {
          "id": "WI-009",
          "category": "geography",
          "text": "Wisconsin borders both Lake Michigan and Lake Superior.",
          "source_id": "WI-D"
        },
        {
          "id": "WI-010",
          "category": "food_and_farming",
          "text": "Milk is Wisconsin's official state beverage.",
          "source_id": "WI-D"
        },
        {
          "id": "WI-011",
          "category": "sport",
          "text": "The American Birkebeiner is a major Wisconsin cross-country ski race.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-012",
          "category": "culture",
          "text": "Mount Horeb celebrates trolls in its town identity.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-013",
          "category": "history",
          "text": "Flambeau River State Forest was established in the 1930s.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-014",
          "category": "food_and_farming",
          "text": "Sheboygan is famous for bratwurst sausages.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-015",
          "category": "culture",
          "text": "Forward is Wisconsin's state motto.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-016",
          "category": "history",
          "text": "Devil's Lake became a state park in 1911.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-017",
          "category": "science_and_invention",
          "text": "Milwaukee played a major role in developing the practical typewriter.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-018",
          "category": "culture",
          "text": "A miner and sailor support Wisconsin's coat of arms.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-019",
          "category": "history",
          "text": "An 1854 meeting in Ripon helped establish the Republican Party.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-020",
          "category": "food_and_farming",
          "text": "Monroe is known for Swiss-style cheese.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-021",
          "category": "geography",
          "text": "Door County occupies a peninsula between Green Bay and Lake Michigan.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-022",
          "category": "landmarks_and_engineering",
          "text": "The House on the Rock features an overhanging Infinity Room.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-023",
          "category": "history",
          "text": "Watertown hosted an early German-language kindergarten in 1856.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-024",
          "category": "people",
          "text": "Architect Frank Lloyd Wright was born in Richland Center.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-025",
          "category": "landmarks_and_engineering",
          "text": "Hayward's Freshwater Fishing Hall of Fame has a giant muskie sculpture.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-026",
          "category": "science_and_invention",
          "text": "Harley-Davidson motorcycles originated in Milwaukee.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-027",
          "category": "history",
          "text": "The Ringling brothers began their circus in Baraboo in 1884.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-028",
          "category": "culture",
          "text": "Milwaukee hosts the Summerfest music festival.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-029",
          "category": "culture",
          "text": "Eagle River celebrates its snowmobiling heritage.",
          "source_id": "WI-F"
        },
        {
          "id": "WI-030",
          "category": "culture",
          "text": "Prairie du Sac hosts a cow-chip throwing contest.",
          "source_id": "WI-F"
        }
      ]
    },
    {
      "name": "Wyoming",
      "code": "WY",
      "facts": [
        {
          "id": "WY-001",
          "category": "geography",
          "text": "Cheyenne serves as Wyoming's capital.",
          "source_id": "WY-D"
        },
        {
          "id": "WY-002",
          "category": "nature_and_wildlife",
          "text": "The western meadowlark is Wyoming's state bird.",
          "source_id": "WY-D"
        },
        {
          "id": "WY-003",
          "category": "nature_and_wildlife",
          "text": "Indian paintbrush is Wyoming's state flower.",
          "source_id": "WY-D"
        },
        {
          "id": "WY-004",
          "category": "nature_and_wildlife",
          "text": "Plains cottonwood is Wyoming's state tree.",
          "source_id": "WY-D"
        },
        {
          "id": "WY-005",
          "category": "nature_and_wildlife",
          "text": "Cutthroat trout is Wyoming's state fish.",
          "source_id": "WY-D"
        },
        {
          "id": "WY-006",
          "category": "nature_and_wildlife",
          "text": "The American bison is Wyoming's state mammal.",
          "source_id": "WY-D"
        },
        {
          "id": "WY-007",
          "category": "geography",
          "text": "Gannett Peak is Wyoming's highest point.",
          "source_id": "WY-D"
        },
        {
          "id": "WY-008",
          "category": "history",
          "text": "Wyoming became the 44th state in 1890.",
          "source_id": "WY-D"
        },
        {
          "id": "WY-009",
          "category": "geography",
          "text": "Wyoming borders six other states.",
          "source_id": "WY-D"
        },
        {
          "id": "WY-010",
          "category": "people",
          "text": "Nellie Tayloe Ross became America's first woman governor in Wyoming.",
          "source_id": "WY-D"
        },
        {
          "id": "WY-011",
          "category": "culture",
          "text": "Wyoming licence plates feature a rider on a bucking horse.",
          "source_id": "WY-F"
        },
        {
          "id": "WY-012",
          "category": "history",
          "text": "Devils Tower became the first US national monument in 1906.",
          "source_id": "WY-F"
        },
        {
          "id": "WY-013",
          "category": "history",
          "text": "Cody takes its name from William 'Buffalo Bill' Cody.",
          "source_id": "WY-F"
        },
        {
          "id": "WY-014",
          "category": "geography",
          "text": "The Grand Tetons form part of the Rocky Mountains.",
          "source_id": "WY-F"
        },
        {
          "id": "WY-015",
          "category": "geography",
          "text": "The Great Divide Basin has no outlet to the ocean.",
          "source_id": "WY-F"
        },
        {
          "id": "WY-016",
          "category": "geography",
          "text": "The Wind River becomes the Bighorn River downstream.",
          "source_id": "WY-F"
        },
        {
          "id": "WY-017",
          "category": "culture",
          "text": "Equal Rights is Wyoming's state motto.",
          "source_id": "WY-F"
        },
        {
          "id": "WY-018",
          "category": "culture",
          "text": "Wyoming is nicknamed the Equality State.",
          "source_id": "WY-F"
        },
        {
          "id": "WY-019",
          "category": "history",
          "text": "J. C. Penney's first store opened in Kemmerer.",
          "source_id": "WY-F"
        },
        {
          "id": "WY-020",
          "category": "culture",
          "text": "Eaton's Ranch near Wolf helped popularise dude-ranch holidays.",
          "source_id": "WY-F"
        },
        {
          "id": "WY-021",
          "category": "history",
          "text": "Yellowstone National Park was established on March 1, 1872.",
          "source_id": "WY-P"
        },
        {
          "id": "WY-022",
          "category": "geography",
          "text": "About 96 percent of Yellowstone National Park lies in Wyoming.",
          "source_id": "WY-P"
        },
        {
          "id": "WY-023",
          "category": "geography",
          "text": "Yellowstone is larger than Rhode Island and Delaware combined.",
          "source_id": "WY-P"
        },
        {
          "id": "WY-024",
          "category": "geography",
          "text": "Yellowstone Lake sits more than 7,700 feet above sea level.",
          "source_id": "WY-P"
        },
        {
          "id": "WY-025",
          "category": "nature_and_wildlife",
          "text": "Yellowstone sits above an active volcanic system.",
          "source_id": "WY-P"
        },
        {
          "id": "WY-026",
          "category": "nature_and_wildlife",
          "text": "Yellowstone has thousands of hydrothermal features.",
          "source_id": "WY-P"
        },
        {
          "id": "WY-027",
          "category": "nature_and_wildlife",
          "text": "More than half the world's active geysers are in Yellowstone.",
          "source_id": "WY-P"
        },
        {
          "id": "WY-028",
          "category": "nature_and_wildlife",
          "text": "Yellowstone's Lower Falls drops about 308 feet.",
          "source_id": "WY-P"
        },
        {
          "id": "WY-029",
          "category": "nature_and_wildlife",
          "text": "Both black bears and grizzly bears inhabit Yellowstone.",
          "source_id": "WY-P"
        },
        {
          "id": "WY-030",
          "category": "nature_and_wildlife",
          "text": "Lodgepole pine dominates much of Yellowstone's forest.",
          "source_id": "WY-P"
        }
      ]
    }
  ]
}
